(function () {
  const u = document.createElement("link").relList;
  if (u && u.supports && u.supports("modulepreload")) return;
  for (const g of document.querySelectorAll('link[rel="modulepreload"]')) p(g);
  new MutationObserver((g) => {
    for (const f of g)
      if (f.type === "childList")
        for (const m of f.addedNodes)
          m.tagName === "LINK" && m.rel === "modulepreload" && p(m);
  }).observe(document, { childList: !0, subtree: !0 });
  function h(g) {
    const f = {};
    return (
      g.integrity && (f.integrity = g.integrity),
      g.referrerPolicy && (f.referrerPolicy = g.referrerPolicy),
      g.crossOrigin === "use-credentials"
        ? (f.credentials = "include")
        : g.crossOrigin === "anonymous"
          ? (f.credentials = "omit")
          : (f.credentials = "same-origin"),
      f
    );
  }
  function p(g) {
    if (g.ep) return;
    g.ep = !0;
    const f = h(g);
    fetch(g.href, f);
  }
})();
/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/ window.theme = window.theme || {};
window.Shopify = window.Shopify || {};
theme.config = {
  bpSmall: !1,
  hasSessionStorage: !0,
  hasLocalStorage: !0,
  mediaQuerySmall: "screen and (max-width: 769px)",
  youTubeReady: !1,
  vimeoReady: !1,
  vimeoLoading: !1,
  isTouch: !!(
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
  ),
  stickyHeader: !1,
  rtl: document.documentElement.getAttribute("dir") == "rtl",
};
theme.config.isTouch &&
  (document.documentElement.className += " supports-touch");
console &&
  console.log &&
  console.log(
    "Impulse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co",
  );
theme.recentlyViewed = { recent: {}, productInfo: {} };
(function () {
  ((theme.delegate = {
    on: function (o, e, t) {
      return (
        this.namespaces || (this.namespaces = {}),
        (this.namespaces[o] = e),
        (t = t || !1),
        this.addEventListener(o.split(".")[0], e, t),
        this
      );
    },
    off: function (o) {
      if (this.namespaces)
        return (
          this.removeEventListener(o.split(".")[0], this.namespaces[o]),
          delete this.namespaces[o],
          this
        );
    },
  }),
    (window.on = Element.prototype.on = theme.delegate.on),
    (window.off = Element.prototype.off = theme.delegate.off),
    (theme.utils = {
      defaultTo: function (o, e) {
        return o == null || o !== o ? e : o;
      },
      wrap: function (o, e) {
        (o.parentNode.insertBefore(e, o), e.appendChild(o));
      },
      debounce: function (o, e, t) {
        var s;
        return function () {
          var i = this,
            n = arguments,
            r = function () {
              ((s = null), t || e.apply(i, n));
            },
            a = t && !s;
          (clearTimeout(s), (s = setTimeout(r, o)), a && e.apply(i, n));
        };
      },
      throttle: function (o, e) {
        var t = !1;
        return function () {
          t ||
            (e.apply(this, arguments),
            (t = !0),
            setTimeout(function () {
              t = !1;
            }, o));
        };
      },
      prepareTransition: function (o, e) {
        o.addEventListener("transitionend", t);
        function t(s) {
          (o.classList.remove("is-transitioning"),
            o.removeEventListener("transitionend", t));
        }
        (o.classList.add("is-transitioning"),
          o.offsetWidth,
          typeof e == "function" && e());
      },
      compact: function (o) {
        for (
          var e = -1, t = o == null ? 0 : o.length, s = 0, i = [];
          ++e < t;

        ) {
          var n = o[e];
          n && (i[s++] = n);
        }
        return i;
      },
      serialize: function (o) {
        var e = [];
        return (
          Array.prototype.slice.call(o.elements).forEach(function (t) {
            if (
              !(
                !t.name ||
                t.disabled ||
                ["file", "reset", "submit", "button"].indexOf(t.type) > -1
              )
            ) {
              if (t.type === "select-multiple") {
                Array.prototype.slice.call(t.options).forEach(function (s) {
                  s.selected &&
                    e.push(
                      encodeURIComponent(t.name) +
                        "=" +
                        encodeURIComponent(s.value),
                    );
                });
                return;
              }
              (["checkbox", "radio"].indexOf(t.type) > -1 && !t.checked) ||
                e.push(
                  encodeURIComponent(t.name) +
                    "=" +
                    encodeURIComponent(t.value),
                );
            }
          }),
          e.join("&")
        );
      },
    }),
    (theme.a11y = {
      trapFocus: function (o) {
        var e = {
            focusin: o.namespace ? "focusin." + o.namespace : "focusin",
            focusout: o.namespace ? "focusout." + o.namespace : "focusout",
            keydown: o.namespace
              ? "keydown." + o.namespace
              : "keydown.handleFocus",
          },
          t = o.container.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
          ),
          s = [].slice.call(t),
          i = s.filter((l) => l.offsetParent !== null),
          n = i[0],
          r = i[i.length - 1];
        (o.elementToFocus || (o.elementToFocus = o.container),
          o.container.setAttribute("tabindex", "-1"),
          o.elementToFocus.focus(),
          document.documentElement.off("focusin"),
          document.documentElement.on(e.focusout, function () {
            document.documentElement.off(e.keydown);
          }),
          document.documentElement.on(e.focusin, function (l) {
            (l.target !== o.container && l.target !== r && l.target !== n) ||
              document.documentElement.on(e.keydown, function (c) {
                a(c);
              });
          }));
        function a(l) {
          l.keyCode === 9 &&
            l.target === r &&
            !l.shiftKey &&
            (l.preventDefault(), n.focus());
        }
      },
      removeTrapFocus: function (o) {
        var e = o.namespace ? "focusin." + o.namespace : "focusin";
        (o.container && o.container.removeAttribute("tabindex"),
          document.documentElement.off(e));
      },
      lockMobileScrolling: function (o, e) {
        var t = e || document.documentElement;
        (document.documentElement.classList.add("lock-scroll"),
          t.on("touchmove" + o, function () {
            return !0;
          }));
      },
      unlockMobileScrolling: function (o, e) {
        document.documentElement.classList.remove("lock-scroll");
        var t = e || document.documentElement;
        t.off("touchmove" + o);
      },
    }),
    document.documentElement.on("keyup.tab", function (o) {
      o.keyCode === 9 &&
        (document.documentElement.classList.add("tab-outline"),
        document.documentElement.off("keyup.tab"));
    }),
    (theme.Currency = (function () {
      var o = "${{amount}}",
        e = theme && theme.settings && theme.settings.superScriptPrice;
      function t(i, n) {
        (n || (n = theme.settings.moneyFormat),
          typeof i == "string" && (i = i.replace(".", "")));
        var r = "",
          a = /\{\{\s*(\w+)\s*\}\}/,
          l = n || o;
        function c(v, I, C, T) {
          if (
            ((I = theme.utils.defaultTo(I, 2)),
            (C = theme.utils.defaultTo(C, ",")),
            (T = theme.utils.defaultTo(T, ".")),
            isNaN(v) || v == null)
          )
            return 0;
          v = (v / 100).toFixed(I);
          var P = v.split("."),
            q = P[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + C),
            k = P[1] ? T + P[1] : "";
          return q + k;
        }
        switch (l.match(a)[1]) {
          case "amount":
            ((r = c(i, 2)),
              e &&
                r &&
                r.includes(".") &&
                (r = r.replace(".", "<sup>") + "</sup>"));
            break;
          case "amount_no_decimals":
            r = c(i, 0);
            break;
          case "amount_with_comma_separator":
            ((r = c(i, 2, ".", ",")),
              e &&
                r &&
                r.includes(",") &&
                (r = r.replace(",", "<sup>") + "</sup>"));
            break;
          case "amount_no_decimals_with_comma_separator":
            r = c(i, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            r = c(i, 0, " ");
            break;
        }
        return l.replace(a, r);
      }
      function s(i) {
        if (
          i &&
          !(
            !i.unit_price_measurement ||
            !i.unit_price_measurement.reference_value
          )
        )
          return i.unit_price_measurement.reference_value === 1
            ? i.unit_price_measurement.reference_unit
            : i.unit_price_measurement.reference_value +
                i.unit_price_measurement.reference_unit;
      }
      return { formatMoney: t, getBaseUnit: s };
    })()),
    (theme.Images = (function () {
      function o(i) {
        if (!i) return "620x";
        var n = i.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/,
        );
        return n !== null ? n[1] : null;
      }
      function e(i, n) {
        if (!i || n == null) return i;
        if (n === "master") return this.removeProtocol(i);
        var r = i.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (r != null) {
          var a = i.split(r[0]),
            l = r[0];
          return this.removeProtocol(a[0] + "_" + n + l);
        }
        return null;
      }
      function t(i) {
        return i.replace(/http(s)?:/, "");
      }
      function s(i, n) {
        if (i == null) return [];
        if (n) {
          const r = [];
          return (
            n.forEach((a) => {
              let l = `${i}?width=${a}`;
              (a === n[n.length - 1] ? (l += ` ${a}w`) : (l += ` ${a}w,`),
                r.push(l));
            }),
            r
          );
        } else return [i];
      }
      return {
        imageSize: o,
        getSizedImageUrl: e,
        removeProtocol: t,
        buildImagePath: s,
      };
    })()),
    (theme.initWhenVisible = function (o) {
      var e = o.threshold ? o.threshold : 0,
        t = new IntersectionObserver(
          (s, i) => {
            s.forEach((n) => {
              n.isIntersecting &&
                typeof o.callback == "function" &&
                (o.callback(), i.unobserve(n.target));
            });
          },
          { rootMargin: "0px 0px " + e + "px 0px" },
        );
      t.observe(o.element);
    }),
    (theme.LibraryLoader = (function () {
      var o = { link: "link", script: "script" },
        e = { requested: "requested", loaded: "loaded" },
        t = "https://cdn.shopify.com/shopifycloud/",
        s = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: o.script,
          },
          vimeo: {
            tagId: "vimeo-api",
            src: "https://player.vimeo.com/api/player.js",
            type: o.script,
          },
          shopifyXr: {
            tagId: "shopify-model-viewer-xr",
            src: t + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
            type: o.script,
          },
          modelViewerUi: {
            tagId: "shopify-model-viewer-ui",
            src: t + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
            type: o.script,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: t + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: o.link,
          },
        };
      function i(a, l) {
        var c = s[a];
        if (c && c.status !== e.requested) {
          if (((l = l || function () {}), c.status === e.loaded)) {
            l();
            return;
          }
          c.status = e.requested;
          var v;
          switch (c.type) {
            case o.script:
              v = n(c, l);
              break;
            case o.link:
              v = r(c, l);
              break;
          }
          ((v.id = c.tagId), (c.element = v));
          var I = document.getElementsByTagName(c.type)[0];
          I.parentNode.insertBefore(v, I);
        }
      }
      function n(a, l) {
        var c = document.createElement("script");
        return (
          (c.src = a.src),
          c.addEventListener("load", function () {
            ((a.status = e.loaded), l());
          }),
          c
        );
      }
      function r(a, l) {
        var c = document.createElement("link");
        return (
          (c.href = a.src),
          (c.rel = "stylesheet"),
          (c.type = "text/css"),
          c.addEventListener("load", function () {
            ((a.status = e.loaded), l());
          }),
          c
        );
      }
      return { load: i };
    })()),
    (theme.rteInit = function () {
      (document.querySelectorAll(".rte table").forEach((e) => {
        var t = document.createElement("div");
        (t.classList.add("table-wrapper"), theme.utils.wrap(e, t));
      }),
        document
          .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
          .forEach((e) => {
            o(e);
          }),
        document
          .querySelectorAll('.rte iframe[src*="player.vimeo"]')
          .forEach((e) => {
            o(e);
          }));
      function o(e) {
        e.src = e.src;
        var t = document.createElement("div");
        (t.classList.add("video-wrapper"), theme.utils.wrap(e, t));
      }
      document.querySelectorAll(".rte a img").forEach((e) => {
        e.parentNode.classList.add("rte__image");
      });
    }),
    (theme.Sections = function () {
      ((this.constructors = {}),
        (this.instances = []),
        document.addEventListener(
          "shopify:section:load",
          this._onSectionLoad.bind(this),
        ),
        document.addEventListener(
          "shopify:section:unload",
          this._onSectionUnload.bind(this),
        ),
        document.addEventListener(
          "shopify:section:select",
          this._onSelect.bind(this),
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this._onDeselect.bind(this),
        ),
        document.addEventListener(
          "shopify:block:select",
          this._onBlockSelect.bind(this),
        ),
        document.addEventListener(
          "shopify:block:deselect",
          this._onBlockDeselect.bind(this),
        ));
    }),
    (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
      _createInstance: function (o, e, t) {
        var s = o.getAttribute("data-section-id"),
          i = o.getAttribute("data-section-type");
        if (((e = e || this.constructors[i]), !(typeof e > "u"))) {
          if (t) {
            var n = this._findInstance(s);
            n && this._removeInstance(s);
          }
          try {
            var r = Object.assign(new e(o), { id: s, type: i, container: o });
            this.instances.push(r);
          } catch (a) {
            console.error(a);
          }
        }
      },
      _findInstance: function (o) {
        for (var e = 0; e < this.instances.length; e++)
          if (this.instances[e].id === o) return this.instances[e];
      },
      _removeInstance: function (o) {
        for (var e = this.instances.length, t; e--; )
          if (this.instances[e].id === o) {
            ((t = this.instances[e]), this.instances.splice(e, 1));
            break;
          }
        return t;
      },
      _onSectionLoad: function (o, e, t) {
        (window.AOS && AOS.refreshHard(),
          theme && theme.initGlobals && theme.initGlobals());
        var s = e || o.target,
          i = e || o.target.querySelector("[data-section-id]");
        if (i) {
          this._createInstance(i);
          var n = e ? t : this._findInstance(o.detail.sectionId),
            r = s.querySelectorAll("[data-subsection]");
          (r.length && this.loadSubSections(s),
            n && typeof n.onLoad == "function" && n.onLoad(o),
            setTimeout(function () {
              window.dispatchEvent(new Event("scroll"));
            }, 200));
        }
      },
      _onSectionUnload: function (o) {
        this.instances = this.instances.filter(function (e) {
          var t = e.id === o.detail.sectionId;
          return (t && typeof e.onUnload == "function" && e.onUnload(o), !t);
        });
      },
      loadSubSections: function (o) {
        if (o) {
          var e = o.querySelectorAll("[data-section-id]");
          e.forEach((t) => {
            this._onSectionLoad(null, t, t.dataset.sectionId);
          });
        }
      },
      _onSelect: function (o) {
        var e = this._findInstance(o.detail.sectionId);
        typeof e < "u" && typeof e.onSelect == "function" && e.onSelect(o);
      },
      _onDeselect: function (o) {
        var e = this._findInstance(o.detail.sectionId);
        typeof e < "u" && typeof e.onDeselect == "function" && e.onDeselect(o);
      },
      _onBlockSelect: function (o) {
        var e = this._findInstance(o.detail.sectionId);
        typeof e < "u" &&
          typeof e.onBlockSelect == "function" &&
          e.onBlockSelect(o);
      },
      _onBlockDeselect: function (o) {
        var e = this._findInstance(o.detail.sectionId);
        typeof e < "u" &&
          typeof e.onBlockDeselect == "function" &&
          e.onBlockDeselect(o);
      },
      register: function (o, e, t) {
        this.constructors[o] = e;
        var s = document.querySelectorAll('[data-section-type="' + o + '"]');
        (t && (s = t.querySelectorAll('[data-section-type="' + o + '"]')),
          s.forEach(
            function (i) {
              this._createInstance(i, e, t);
            }.bind(this),
          ));
      },
      reinit: function (o) {
        for (var e = 0; e < this.instances.length; e++) {
          var t = this.instances[e];
          t.type === o && typeof t.forceReload == "function" && t.forceReload();
        }
      },
    })),
    (theme.Variants = (function () {
      function o(e) {
        ((this.container = e.container),
          (this.variants = e.variants),
          (this.singleOptionSelector = e.singleOptionSelector),
          (this.originalSelectorId = e.originalSelectorId),
          (this.enableHistoryState = e.enableHistoryState),
          (this.dynamicVariantsEnabled = e.dynamicVariantsEnabled),
          (this.currentlySelectedValues = this._getCurrentOptions()),
          (this.currentVariant = this._getVariantFromOptions()),
          this.container
            .querySelectorAll(this.singleOptionSelector)
            .forEach((t) => {
              t.addEventListener("change", this._onSelectChange.bind(this));
            }));
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          _getCurrentOptions: function () {
            var e = [];
            return (
              this.container
                .querySelectorAll(this.singleOptionSelector)
                .forEach((t) => {
                  var s = t.getAttribute("type");
                  s === "radio" || s === "checkbox"
                    ? t.checked &&
                      e.push({ value: t.value, index: t.dataset.index })
                    : e.push({ value: t.value, index: t.dataset.index });
                }),
              (e = theme.utils.compact(e)),
              e
            );
          },
          _numberFromOptionKey: function (e) {
            return parseInt(e.substr(-1));
          },
          _getWeightedOptionMatchCount: function (e) {
            return this._getCurrentOptions().reduce(
              (t, { value: s, index: i }) => {
                const r = 4 - this._numberFromOptionKey(i);
                return e[i] === s ? t + r : t;
              },
              0,
            );
          },
          _getFullMatch(e) {
            const t = this._getCurrentOptions();
            return this.variants.find((i) => {
              const n = t.every(({ value: r, index: a }) => i[a] === r);
              return e ? n && i.available : n;
            });
          },
          _getClosestAvailableMatch: function (e) {
            if (!e) return null;
            const t = this._getCurrentOptions(),
              s = this.variants;
            return (
              e &&
              s.filter(
                (n) =>
                  t
                    .filter(
                      ({ value: r, index: a }) =>
                        this._numberFromOptionKey(a) <=
                        this._numberFromOptionKey(e.index),
                    )
                    .every(({ value: r, index: a }) => n[a] === r) &&
                  n.available,
              )
            ).reduce((n, r) => {
              if (n === null) return r;
              const a = this._getWeightedOptionMatchCount(n, e);
              return this._getWeightedOptionMatchCount(r, e) > a ? r : n;
            }, null);
          },
          _getVariantFromOptions: function (e) {
            const t = this._getFullMatch(!0),
              s = this._getClosestAvailableMatch(e),
              i = this._getFullMatch(!1);
            return this.dynamicVariantsEnabled
              ? t || s || i || null
              : i || null;
          },
          _updateInputState: function (e, t) {
            return (s) => {
              if (e === null) return;
              const i = s.dataset.index,
                n = s.value,
                r = s.getAttribute("type");
              r === "radio" || r === "checkbox"
                ? ((s.checked = e[i] === n),
                  s.checked && s.dispatchEvent(new Event("updateSwatch")))
                : (s.value = e[i]);
            };
          },
          _onSelectChange: function ({ srcElement: e }) {
            const t = this.container.querySelectorAll(
                this.singleOptionSelector,
              ),
              s = this._getVariantFromOptions({
                index: e.dataset.index,
                value: e.value,
              });
            t.forEach(this._updateInputState(s, e));
            const i = (this.currentlySelectedValues =
                this._getCurrentOptions()),
              n = {
                variant: s,
                currentlySelectedValues: i,
                value: e.value,
                index: e.parentElement.dataset.index,
              };
            (this.container.dispatchEvent(
              new CustomEvent("variantChange", { detail: n }),
            ),
              document.dispatchEvent(
                new CustomEvent("variant:change", { detail: n }),
              ),
              s &&
                (this._updateMasterSelect(s),
                this._updateImages(s),
                this._updatePrice(s),
                this._updateUnitPrice(s),
                this._updateSKU(s),
                (this.currentVariant = s),
                this.enableHistoryState && this._updateHistoryState(s)));
          },
          _updateImages: function (e) {
            e.featured_image &&
              this.container.dispatchEvent(
                new CustomEvent("variantImageChange", {
                  detail: { variant: e },
                }),
              );
          },
          _updatePrice: function (e) {
            (this.currentVariant &&
              e.price === this.currentVariant.price &&
              e.compare_at_price === this.currentVariant.compare_at_price) ||
              this.container.dispatchEvent(
                new CustomEvent("variantPriceChange", {
                  detail: { variant: e },
                }),
              );
          },
          _updateUnitPrice: function (e) {
            (this.currentVariant &&
              e.unit_price === this.currentVariant.unit_price) ||
              this.container.dispatchEvent(
                new CustomEvent("variantUnitPriceChange", {
                  detail: { variant: e },
                }),
              );
          },
          _updateSKU: function (e) {
            (this.currentVariant && e.sku === this.currentVariant.sku) ||
              this.container.dispatchEvent(
                new CustomEvent("variantSKUChange", { detail: { variant: e } }),
              );
          },
          _updateHistoryState: function (e) {
            if (!(!history.replaceState || !e)) {
              var t =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?variant=" +
                e.id;
              window.history.replaceState({ path: t }, "", t);
            }
          },
          _updateMasterSelect: function (e) {
            let t = this.container.querySelector(this.originalSelectorId);
            t &&
              ((t.value = e.id),
              t.dispatchEvent(new Event("change", { bubbles: !0 })));
          },
        })),
        o
      );
    })()),
    (window.vimeoApiReady = function () {
      ((theme.config.vimeoLoading = !0),
        d().then(function () {
          ((theme.config.vimeoReady = !0),
            (theme.config.vimeoLoading = !1),
            document.dispatchEvent(new CustomEvent("vimeoReady")));
        }));
    }));
  function d() {
    let o, e;
    return new Promise((t, s) => {
      ((o = setInterval(function () {
        Vimeo && (clearInterval(o), clearTimeout(e), t());
      }, 500)),
        (e = setTimeout(function () {
          (clearInterval(o), s());
        }, 4e3)));
    });
  }
  ((theme.VimeoPlayer = (function () {
    const o = {
        loading: "loading",
        loaded: "loaded",
        interactable: "video-interactable",
      },
      e = {
        byline: !1,
        loop: !0,
        muted: !0,
        playsinline: !0,
        portrait: !1,
        title: !1,
      };
    function t(s, i, n) {
      ((this.divId = s),
        (this.el = document.getElementById(s)),
        (this.videoId = i),
        (this.iframe = null),
        (this.options = n),
        this.options &&
          this.options.videoParent &&
          (this.parent = this.el.closest(this.options.videoParent)),
        this.setAsLoading(),
        theme.config.vimeoReady
          ? this.init()
          : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
            document.addEventListener("vimeoReady", this.init.bind(this))));
    }
    return (
      (t.prototype = Object.assign({}, t.prototype, {
        init: function () {
          const s = e;
          ((s.id = this.videoId),
            (this.videoPlayer = new Vimeo.Player(this.el, s)),
            this.videoPlayer.ready().then(this.playerReady.bind(this)));
        },
        playerReady: function () {
          ((this.iframe = this.el.querySelector("iframe")),
            this.iframe.setAttribute("tabindex", "-1"),
            this.options.loop === "false" && this.videoPlayer.setLoop(!1),
            this.options.style === "sound"
              ? this.videoPlayer.setVolume(1)
              : this.videoPlayer.setVolume(0),
            this.setAsLoaded(),
            new IntersectionObserver(
              (i, n) => {
                i.forEach((r) => {
                  r.isIntersecting ? this.play() : this.pause();
                });
              },
              { rootMargin: "0px 0px 50px 0px" },
            ).observe(this.iframe));
        },
        setAsLoading: function () {
          this.parent && this.parent.classList.add(o.loading);
        },
        setAsLoaded: function () {
          this.parent &&
            (this.parent.classList.remove(o.loading),
            this.parent.classList.add(o.loaded),
            this.parent.classList.add(o.interactable),
            Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
        },
        enableInteraction: function () {
          this.parent && this.parent.classList.add(o.interactable);
        },
        play: function () {
          this.videoPlayer &&
            typeof this.videoPlayer.play == "function" &&
            this.videoPlayer.play();
        },
        pause: function () {
          this.videoPlayer &&
            typeof this.videoPlayer.pause == "function" &&
            this.videoPlayer.pause();
        },
        destroy: function () {
          this.videoPlayer &&
            typeof this.videoPlayer.destroy == "function" &&
            this.videoPlayer.destroy();
        },
      })),
      t
    );
  })()),
    (window.onYouTubeIframeAPIReady = function () {
      ((theme.config.youTubeReady = !0),
        document.dispatchEvent(new CustomEvent("youTubeReady")));
    }),
    (theme.YouTube = (function () {
      var o = {
          loading: "loading",
          loaded: "loaded",
          interactable: "video-interactable",
        },
        e = {
          width: 1280,
          height: 720,
          playerVars: {
            autohide: 0,
            autoplay: 1,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
          },
        };
      function t(s, i) {
        ((this.divId = s),
          (this.iframe = null),
          (this.attemptedToPlay = !1),
          (e.events = {
            onReady: this.onVideoPlayerReady.bind(this),
            onStateChange: this.onVideoStateChange.bind(this),
          }),
          (this.options = Object.assign({}, e, i)),
          this.options &&
            (this.options.videoParent &&
              (this.parent = document
                .getElementById(this.divId)
                .closest(this.options.videoParent)),
            this.options.autoplay ||
              (this.options.playerVars.autoplay = this.options.autoplay),
            this.options.style === "sound" &&
              ((this.options.playerVars.controls = 1),
              (this.options.playerVars.autoplay = 0))),
          this.setAsLoading(),
          theme.config.youTubeReady
            ? this.init()
            : (theme.LibraryLoader.load("youtubeSdk"),
              document.addEventListener("youTubeReady", this.init.bind(this))));
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          init: function () {
            this.videoPlayer = new YT.Player(this.divId, this.options);
          },
          onVideoPlayerReady: function (s) {
            ((this.iframe = document.getElementById(this.divId)),
              this.iframe.setAttribute("tabindex", "-1"),
              this.options.style !== "sound" && s.target.mute());
            var i = new IntersectionObserver(
              (n, r) => {
                n.forEach((a) => {
                  a.isIntersecting ? this.play() : this.pause();
                });
              },
              { rootMargin: "0px 0px 50px 0px" },
            );
            i.observe(this.iframe);
          },
          onVideoStateChange: function (s) {
            switch (s.data) {
              case -1:
                this.attemptedToPlay &&
                  (this.setAsLoaded(), this.enableInteraction());
                break;
              case 0:
                this.play(s);
                break;
              case 1:
                this.setAsLoaded();
                break;
              case 3:
                this.attemptedToPlay = !0;
                break;
            }
          },
          setAsLoading: function () {
            this.parent && this.parent.classList.add(o.loading);
          },
          setAsLoaded: function () {
            this.parent &&
              (this.parent.classList.remove(o.loading),
              this.parent.classList.add(o.loaded),
              Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
          },
          enableInteraction: function () {
            this.parent && this.parent.classList.add(o.interactable);
          },
          play: function () {
            this.videoPlayer &&
              typeof this.videoPlayer.playVideo == "function" &&
              this.videoPlayer.playVideo();
          },
          pause: function () {
            this.videoPlayer &&
              typeof this.videoPlayer.pauseVideo == "function" &&
              this.videoPlayer.pauseVideo();
          },
          destroy: function () {
            this.videoPlayer &&
              typeof this.videoPlayer.destroy == "function" &&
              this.videoPlayer.destroy();
          },
        })),
        t
      );
    })()),
    (function () {
      var o = !1,
        e;
      (document.body.addEventListener("touchstart", function (t) {
        if (!t.target.closest(".flickity-slider")) return (o = !1);
        ((o = !0), (e = { x: t.touches[0].pageX, y: t.touches[0].pageY }));
      }),
        document.body.addEventListener(
          "touchmove",
          function (t) {
            if (o && t.cancelable) {
              var s = {
                x: t.touches[0].pageX - e.x,
                y: t.touches[0].pageY - e.y,
              };
              Math.abs(s.x) > Flickity.defaults.dragThreshold &&
                t.preventDefault();
            }
          },
          { passive: !1 },
        ));
    })(),
    (theme.AjaxRenderer = (function () {
      function o({ sections: e, onReplace: t, debug: s } = {}) {
        ((this.sections = e || []),
          (this.cachedSections = []),
          (this.onReplace = t),
          (this.debug = !!s));
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          renderPage: function (e, t, s = !0) {
            const i = new URLSearchParams(window.location.search),
              n = this.getUpdatedParams(i, t),
              r = this.sections.map((a) => {
                const l = `${e}?section_id=${a.sectionId}&${n.toString()}`,
                  c = (v) => v.url === l;
                return this.cachedSections.some(c)
                  ? this.renderSectionFromCache(c, a)
                  : this.renderSectionFromFetch(l, a);
              });
            return (s && this.updateURLHash(n), Promise.all(r));
          },
          renderSectionFromCache: function (e, t) {
            const s = this.cachedSections.find(e);
            return (
              this.log(`[AjaxRenderer] rendering from cache: url=${s.url}`),
              this.renderSection(s.html, t),
              Promise.resolve(t)
            );
          },
          renderSectionFromFetch: function (e, t) {
            return (
              this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
              new Promise((s, i) => {
                fetch(e)
                  .then((n) => n.text())
                  .then((n) => {
                    const r = n;
                    ((this.cachedSections = [
                      ...this.cachedSections,
                      { html: r, url: e },
                    ]),
                      this.renderSection(r, t),
                      s(t));
                  })
                  .catch((n) => i(n));
              })
            );
          },
          renderSection: function (e, t) {
            this.log(
              `[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`,
            );
            const s = new DOMParser().parseFromString(e, "text/html");
            if (this.onReplace) this.onReplace(s, t);
            else if (typeof t.nodeId == "string") {
              var i = s.getElementById(t.nodeId);
              if (!i) return;
              document.getElementById(t.nodeId).innerHTML = i.innerHTML;
            } else
              t.nodeId.forEach((n) => {
                document.getElementById(n).innerHTML =
                  s.getElementById(n).innerHTML;
              });
            return t;
          },
          getUpdatedParams: function (e, t) {
            const s = new URLSearchParams(e),
              i = ["sort_by", "q", "options[prefix]", "type"];
            for (const [n, r] of s.entries())
              !t.getAll(n).includes(r) && !i.includes(n) && s.delete(n);
            for (const [n, r] of t.entries())
              !s.getAll(n).includes(r) && r !== "" && s.append(n, r);
            return s;
          },
          updateURLHash: function (e) {
            history.pushState(
              {},
              "",
              `${window.location.pathname}${e && "?".concat(e)}`,
            );
          },
          log: function (...e) {
            this.debug && console.log(...e);
          },
        })),
        o
      );
    })()),
    window.Shopify &&
      window.Shopify.theme &&
      navigator &&
      navigator.sendBeacon &&
      window.Shopify.designMode &&
      navigator.sendBeacon(
        "https://api.archetypethemes.co/api/beacon",
        new URLSearchParams({
          shop: window.Shopify.shop,
          themeName:
            window.theme &&
            window.theme.settings &&
            `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
          role: window.Shopify.theme.role,
          route: window.location.pathname,
          themeId: window.Shopify.theme.id,
          themeStoreId: window.Shopify.theme.theme_store_id || 0,
          isThemeEditor: !!window.Shopify.designMode,
        }),
      ),
    (theme.cart = {
      getCart: function () {
        var o = "".concat(theme.routes.cart, "?t=").concat(Date.now());
        return fetch(o, { credentials: "same-origin", method: "GET" }).then(
          (e) => e.json(),
        );
      },
      getCartProductMarkup: function () {
        var o = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
        return (
          (o = o.indexOf("?") === -1 ? o + "?view=ajax" : o + "&view=ajax"),
          fetch(o, { credentials: "same-origin", method: "GET" })
            .then((e) => e.text())
            .catch((e) => console.error(e))
        );
      },
      changeItem: function (o, e) {
        return this._updateCart({
          url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
          data: JSON.stringify({ id: o, quantity: e }),
        });
      },
      _updateCart: function (o) {
        return fetch(o.url, {
          method: "POST",
          body: o.data,
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        })
          .then((e) => e.text())
          .then((e) => e);
      },
      updateAttribute: function (o, e) {
        return this._updateCart({
          url: "/cart/update.js",
          data: JSON.stringify({
            attributes: { [o]: theme.cart.attributeToString(e) },
          }),
        });
      },
      updateNote: function (o) {
        return this._updateCart({
          url: "/cart/update.js",
          data: JSON.stringify({ note: theme.cart.attributeToString(o) }),
        });
      },
      attributeToString: function (o) {
        return (
          typeof o != "string" && ((o += ""), o === "undefined" && (o = "")),
          o.trim()
        );
      },
    }),
    (theme.CartForm = (function () {
      var o = {
          products: "[data-products]",
          qtySelector: ".js-qty__wrapper",
          discounts: "[data-discounts]",
          savings: "[data-savings]",
          subTotal: "[data-subtotal]",
          cartBubble: ".cart-link__bubble",
          cartNote: '[name="note"]',
          termsCheckbox: ".cart__terms-checkbox",
          checkoutBtn: ".cart__checkout",
        },
        e = { btnLoading: "btn--loading" },
        t = { requiresTerms: !1 };
      function s(i) {
        i &&
          ((this.form = i),
          (this.wrapper = i.parentNode),
          (this.location = i.dataset.location),
          (this.namespace = ".cart-" + this.location),
          (this.products = i.querySelector(o.products)),
          (this.submitBtn = i.querySelector(o.checkoutBtn)),
          (this.discounts = i.querySelector(o.discounts)),
          (this.savings = i.querySelector(o.savings)),
          (this.subtotal = i.querySelector(o.subTotal)),
          (this.termsCheckbox = i.querySelector(o.termsCheckbox)),
          (this.noteInput = i.querySelector(o.cartNote)),
          (this.cartItemsUpdated = !1),
          this.termsCheckbox && (t.requiresTerms = !0),
          this.init());
      }
      return (
        (s.prototype = Object.assign({}, s.prototype, {
          init: function () {
            (this.initQtySelectors(),
              document.addEventListener(
                "cart:quantity" + this.namespace,
                this.quantityChanged.bind(this),
              ),
              this.form.on("submit" + this.namespace, this.onSubmit.bind(this)),
              this.noteInput &&
                this.noteInput.addEventListener("change", function () {
                  var i = this.value;
                  theme.cart.updateNote(i);
                }),
              document.addEventListener(
                "cart:build",
                function () {
                  this.buildCart();
                }.bind(this),
              ));
          },
          reInit: function () {
            this.initQtySelectors();
          },
          onSubmit: function (i) {
            if (
              (this.submitBtn.classList.add(e.btnLoading),
              (document.documentElement.classList.contains("js-drawer-open") &&
                this.cartItemsUpdated) ||
                (document.documentElement.classList.contains("cart-open") &&
                  this.cartItemsUpdated))
            )
              return (
                this.submitBtn.classList.remove(e.btnLoading),
                i.preventDefault(),
                !1
              );
            if (t.requiresTerms && !this.termsCheckbox.checked)
              return (
                alert(theme.strings.cartTermsConfirmation),
                this.submitBtn.classList.remove(e.btnLoading),
                i.preventDefault(),
                !1
              );
          },
          _parseProductHTML: function (i) {
            const n = document.createElement("div");
            return (
              (n.innerHTML = i),
              {
                items: n.querySelector(".cart__items"),
                discounts: n.querySelector(".cart__discounts"),
              }
            );
          },
          buildCart: function () {
            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
          },
          cartMarkup: function (i) {
            var n = this._parseProductHTML(i),
              r = n.items,
              a = parseInt(r.dataset.count),
              l = r.dataset.cartSubtotal,
              c = r.dataset.cartSavings;
            (this.updateCartDiscounts(n.discounts),
              this.updateSavings(c),
              a > 0
                ? this.wrapper.classList.remove("is-empty")
                : this.wrapper.classList.add("is-empty"),
              this.updateCount(a),
              (this.products.innerHTML = ""),
              this.products.append(r),
              (this.subtotal.innerHTML = theme.Currency.formatMoney(
                l,
                theme.settings.moneyFormat,
              )),
              this.reInit(),
              window.AOS && AOS.refreshHard(),
              Shopify &&
                Shopify.StorefrontExpressButtons &&
                Shopify.StorefrontExpressButtons.initialize());
          },
          updateCartDiscounts: function (i) {
            this.discounts &&
              ((this.discounts.innerHTML = ""), this.discounts.append(i));
          },
          initQtySelectors: function () {
            this.form.querySelectorAll(o.qtySelector).forEach((i) => {
              new theme.QtySelector(i, {
                namespace: this.namespace,
                isCart: !0,
              });
            });
          },
          quantityChanged: function (i) {
            var n = i.detail[0],
              r = i.detail[1],
              a = i.detail[2];
            !n ||
              !r ||
              (a && a.classList.add("is-loading"),
              theme.cart
                .changeItem(n, r)
                .then(
                  function (l) {
                    const c = JSON.parse(l);
                    if (c.status === 422) alert(c.message);
                    else {
                      const v = c.items.find((I) => I.key === n);
                      (v &&
                        (i.type === "cart:quantity.cart-cart-drawer" ||
                          i.type === "cart:quantity.cart-header") &&
                        (this.cartItemsUpdated = !0),
                        ((v && i.type === "cart:quantity.cart-cart-drawer") ||
                          (v && i.type === "cart:quantity.cart-header")) &&
                          (v.quantity, (this.cartItemsUpdated = !1)),
                        c.item_count > 0
                          ? this.wrapper.classList.remove("is-empty")
                          : this.wrapper.classList.add("is-empty"));
                    }
                    (this.buildCart(),
                      document.dispatchEvent(
                        new CustomEvent("cart:updated", {
                          detail: { cart: c },
                        }),
                      ));
                  }.bind(this),
                )
                .catch(function (l) {}));
          },
          updateSubtotal: function (i) {
            this.form.querySelector(o.subTotal).innerHTML =
              theme.Currency.formatMoney(i, theme.settings.moneyFormat);
          },
          updateSavings: function (i) {
            if (this.savings)
              if (i > 0) {
                var n = theme.Currency.formatMoney(
                  i,
                  theme.settings.moneyFormat,
                );
                (this.savings.classList.remove("hide"),
                  (this.savings.innerHTML = theme.strings.cartSavings.replace(
                    "[savings]",
                    n,
                  )));
              } else this.savings.classList.add("hide");
          },
          updateCount: function (i) {
            var n = document.querySelectorAll(".cart-link__bubble-num");
            n.length &&
              n.forEach((a) => {
                a.innerText = i;
              });
            var r = document.querySelectorAll(o.cartBubble);
            r.length &&
              (i > 0
                ? r.forEach((a) => {
                    a.classList.add("cart-link__bubble--visible");
                  })
                : r.forEach((a) => {
                    a.classList.remove("cart-link__bubble--visible");
                  }));
          },
        })),
        s
      );
    })()),
    (theme.collapsibles = (function () {
      var o = {
          trigger: ".collapsible-trigger",
          module: ".collapsible-content",
          moduleInner: ".collapsible-content__inner",
          tabs: ".collapsible-trigger--tab",
        },
        e = {
          hide: "hide",
          open: "is-open",
          autoHeight: "collapsible--auto-height",
          tabs: "collapsible-trigger--tab",
        },
        t = ".collapsible",
        s = !1;
      function i(a) {
        var l = a || document;
        l.querySelectorAll(o.trigger).forEach((c) => {
          var v = c.classList.contains(e.open);
          (c.setAttribute("aria-expanded", v),
            c.off("click" + t),
            c.on("click" + t, n));
        });
      }
      function n(a) {
        if (!s) {
          s = !0;
          var l = a.currentTarget,
            c = l.classList.contains(e.open),
            v = l.classList.contains(e.tabs),
            I = l.getAttribute("aria-controls"),
            C = document.getElementById(I);
          if ((I || (I = l.dataset.controls), !!I)) {
            if (!C) {
              var T = document.querySelectorAll('[data-id="' + I + '"]');
              T.length > 0 &&
                (C = l.parentNode.querySelector('[data-id="' + I + '"]'));
            }
            if (!C) {
              s = !1;
              return;
            }
            var P = C.querySelector(o.moduleInner).offsetHeight,
              q = C.classList.contains(e.autoHeight),
              k = C.parentNode.closest(o.module),
              A = P;
            if (v) {
              if (c) {
                s = !1;
                return;
              }
              var M;
              document
                .querySelectorAll(o.tabs + '[data-id="' + l.dataset.id + '"]')
                .forEach((j) => {
                  (j.classList.remove(e.open),
                    (M = document.querySelector(
                      "#" + j.getAttribute("aria-controls"),
                    )),
                    r(M, 0, !0));
                });
            }
            if (
              (c &&
                q &&
                setTimeout(function () {
                  ((P = 0), r(C, P, c, q));
                }, 0),
              c && !q && (P = 0),
              l.setAttribute("aria-expanded", !c),
              c ? l.classList.remove(e.open) : l.classList.add(e.open),
              r(C, P, c, q),
              k)
            ) {
              var V = k.style.height;
              c && V === "auto" && (A = 0);
              var N = c ? k.offsetHeight - A : P + k.offsetHeight;
              r(k, N, !1, !1);
            }
          }
        }
      }
      function r(a, l, c, v) {
        if (
          (a.classList.remove(e.hide),
          theme.utils.prepareTransition(a, function () {
            ((a.style.height = l + "px"),
              c ? a.classList.remove(e.open) : a.classList.add(e.open));
          }),
          !c && v)
        ) {
          var I = a;
          window.setTimeout(function () {
            (I.css("height", "auto"), (s = !1));
          }, 500);
        } else s = !1;
      }
      return { init: i };
    })()),
    (theme.Disclosure = (function () {
      var o = {
          disclosureForm: "[data-disclosure-form]",
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        e = { listVisible: "disclosure-list--visible" };
      function t(s) {
        ((this.container = s), this._cacheSelectors(), this._setupListeners());
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          _cacheSelectors: function () {
            this.cache = {
              disclosureForm: this.container.closest(o.disclosureForm),
              disclosureList: this.container.querySelector(o.disclosureList),
              disclosureToggle: this.container.querySelector(
                o.disclosureToggle,
              ),
              disclosureInput: this.container.querySelector(o.disclosureInput),
              disclosureOptions: this.container.querySelectorAll(
                o.disclosureOptions,
              ),
            };
          },
          _setupListeners: function () {
            ((this.eventHandlers = this._setupEventHandlers()),
              this.cache.disclosureToggle.addEventListener(
                "click",
                this.eventHandlers.toggleList,
              ),
              this.cache.disclosureOptions.forEach(function (s) {
                s.addEventListener("click", this.eventHandlers.connectOptions);
              }, this),
              this.container.addEventListener(
                "keyup",
                this.eventHandlers.onDisclosureKeyUp,
              ),
              this.cache.disclosureList.addEventListener(
                "focusout",
                this.eventHandlers.onDisclosureListFocusOut,
              ),
              this.cache.disclosureToggle.addEventListener(
                "focusout",
                this.eventHandlers.onDisclosureToggleFocusOut,
              ),
              document.body.addEventListener(
                "click",
                this.eventHandlers.onBodyClick,
              ));
          },
          _setupEventHandlers: function () {
            return {
              connectOptions: this._connectOptions.bind(this),
              toggleList: this._toggleList.bind(this),
              onBodyClick: this._onBodyClick.bind(this),
              onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
              onDisclosureListFocusOut:
                this._onDisclosureListFocusOut.bind(this),
              onDisclosureToggleFocusOut:
                this._onDisclosureToggleFocusOut.bind(this),
            };
          },
          _connectOptions: function (s) {
            (s.preventDefault(),
              this._submitForm(s.currentTarget.dataset.value));
          },
          _onDisclosureToggleFocusOut: function (s) {
            var i = this.container.contains(s.relatedTarget) === !1;
            i && this._hideList();
          },
          _onDisclosureListFocusOut: function (s) {
            var i = s.currentTarget.contains(s.relatedTarget),
              n = this.cache.disclosureList.classList.contains(e.listVisible);
            n && !i && this._hideList();
          },
          _onDisclosureKeyUp: function (s) {
            s.which === 27 &&
              (this._hideList(), this.cache.disclosureToggle.focus());
          },
          _onBodyClick: function (s) {
            var i = this.container.contains(s.target),
              n = this.cache.disclosureList.classList.contains(e.listVisible);
            n && !i && this._hideList();
          },
          _submitForm: function (s) {
            ((this.cache.disclosureInput.value = s),
              this.cache.disclosureForm.submit());
          },
          _hideList: function () {
            (this.cache.disclosureList.classList.remove(e.listVisible),
              this.cache.disclosureToggle.setAttribute("aria-expanded", !1));
          },
          _toggleList: function () {
            var s =
              this.cache.disclosureToggle.getAttribute("aria-expanded") ===
              "true";
            (this.cache.disclosureList.classList.toggle(e.listVisible),
              this.cache.disclosureToggle.setAttribute("aria-expanded", !s));
          },
          destroy: function () {
            (this.cache.disclosureToggle.removeEventListener(
              "click",
              this.eventHandlers.toggleList,
            ),
              this.cache.disclosureOptions.forEach(function (s) {
                s.removeEventListener(
                  "click",
                  this.eventHandlers.connectOptions,
                );
              }, this),
              this.container.removeEventListener(
                "keyup",
                this.eventHandlers.onDisclosureKeyUp,
              ),
              this.cache.disclosureList.removeEventListener(
                "focusout",
                this.eventHandlers.onDisclosureListFocusOut,
              ),
              this.cache.disclosureToggle.removeEventListener(
                "focusout",
                this.eventHandlers.onDisclosureToggleFocusOut,
              ),
              document.body.removeEventListener(
                "click",
                this.eventHandlers.onBodyClick,
              ));
          },
        })),
        t
      );
    })()),
    (theme.Drawers = (function () {
      function o(e, t) {
        ((this.config = {
          id: e,
          close: ".js-drawer-close",
          open: ".js-drawer-open-" + t,
          openClass: "js-drawer-open",
          closingClass: "js-drawer-closing",
          activeDrawer: "drawer--is-open",
          namespace: ".drawer-" + t,
        }),
          (this.nodes = { page: document.querySelector("#MainContent") }),
          (this.drawer = document.querySelector("#" + e)),
          (this.isOpen = !1),
          this.drawer && this.init());
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          init: function () {
            (document.querySelectorAll(this.config.open).forEach((e) => {
              (e.setAttribute("aria-expanded", "false"),
                e.addEventListener("click", this.open.bind(this)));
            }),
              this.drawer
                .querySelector(this.config.close)
                .addEventListener("click", this.close.bind(this)),
              document.addEventListener(
                "modalOpen",
                function () {
                  this.close();
                }.bind(this),
              ));
          },
          open: function (e, t) {
            (e && e.preventDefault(),
              !this.isOpen &&
                (e && e.stopPropagation
                  ? (e.stopPropagation(),
                    e.currentTarget.setAttribute("aria-expanded", "true"),
                    (this.activeSource = e.currentTarget))
                  : t &&
                    (t.setAttribute("aria-expanded", "true"),
                    (this.activeSource = t)),
                theme.utils.prepareTransition(
                  this.drawer,
                  function () {
                    this.drawer.classList.add(this.config.activeDrawer);
                  }.bind(this),
                ),
                document.documentElement.classList.add(this.config.openClass),
                (this.isOpen = !0),
                theme.a11y.trapFocus({
                  container: this.drawer,
                  namespace: "drawer_focus",
                }),
                document.dispatchEvent(new CustomEvent("drawerOpen")),
                document.dispatchEvent(
                  new CustomEvent("drawerOpen." + this.config.id),
                ),
                this.bindEvents()));
          },
          close: function (e) {
            if (this.isOpen) {
              if (e && !e.target.closest(".js-drawer-close")) {
                if (e.target.closest(".drawer")) return;
              }
              (document.activeElement.blur(),
                theme.utils.prepareTransition(
                  this.drawer,
                  function () {
                    this.drawer.classList.remove(this.config.activeDrawer);
                  }.bind(this),
                ),
                document.documentElement.classList.remove(
                  this.config.openClass,
                ),
                document.documentElement.classList.add(
                  this.config.closingClass,
                ),
                window.setTimeout(
                  function () {
                    (document.documentElement.classList.remove(
                      this.config.closingClass,
                    ),
                      this.activeSource &&
                        this.activeSource.getAttribute("aria-expanded") &&
                        (this.activeSource.setAttribute(
                          "aria-expanded",
                          "false",
                        ),
                        this.activeSource.focus()));
                  }.bind(this),
                  500,
                ),
                (this.isOpen = !1),
                theme.a11y.removeTrapFocus({
                  container: this.drawer,
                  namespace: "drawer_focus",
                }),
                this.unbindEvents());
            }
          },
          bindEvents: function () {
            (window.on(
              "click" + this.config.namespace,
              function (e) {
                this.close(e);
              }.bind(this),
            ),
              window.on(
                "keyup" + this.config.namespace,
                function (e) {
                  e.keyCode === 27 && this.close();
                }.bind(this),
              ),
              theme.a11y.lockMobileScrolling(
                this.config.namespace,
                this.nodes.page,
              ));
          },
          unbindEvents: function () {
            (window.off("click" + this.config.namespace),
              window.off("keyup" + this.config.namespace),
              theme.a11y.unlockMobileScrolling(
                this.config.namespace,
                this.nodes.page,
              ));
          },
        })),
        o
      );
    })()),
    (theme.Modals = (function () {
      function o(e, t, s) {
        var i = {
          close: ".js-modal-close",
          open: ".js-modal-open-" + t,
          openClass: "modal--is-active",
          closingClass: "modal--is-closing",
          bodyOpenClass: ["modal-open"],
          bodyOpenSolidClass: "modal-open--solid",
          bodyClosingClass: "modal-closing",
          closeOffContentClick: !0,
        };
        if (
          ((this.id = e),
          (this.modal = document.getElementById(e)),
          !this.modal)
        )
          return !1;
        ((this.modalContent = this.modal.querySelector(".modal__inner")),
          (this.config = Object.assign(i, s)),
          (this.modalIsOpen = !1),
          (this.focusOnOpen = this.config.focusIdOnOpen
            ? document.getElementById(this.config.focusIdOnOpen)
            : this.modal),
          (this.isSolid = this.config.solid),
          this.init());
      }
      return (
        (o.prototype.init = function () {
          (document.querySelectorAll(this.config.open).forEach((e) => {
            (e.setAttribute("aria-expanded", "false"),
              e.addEventListener("click", this.open.bind(this)),
              e.classList.remove("btn--not-ready"));
          }),
            this.modal.querySelectorAll(this.config.close).forEach((e) => {
              e.addEventListener("click", this.close.bind(this));
            }),
            document.addEventListener(
              "drawerOpen",
              function () {
                this.close();
              }.bind(this),
            ));
        }),
        (o.prototype.open = function (e) {
          var t = !1;
          this.modalIsOpen ||
            (e ? e.preventDefault() : (t = !0),
            e &&
              e.stopPropagation &&
              (e.stopPropagation(),
              (this.activeSource = e.currentTarget.setAttribute(
                "aria-expanded",
                "true",
              ))),
            this.modalIsOpen && !t && this.close(),
            this.modal.classList.add(this.config.openClass),
            document.documentElement.classList.add(
              ...this.config.bodyOpenClass,
            ),
            this.isSolid &&
              document.documentElement.classList.add(
                this.config.bodyOpenSolidClass,
              ),
            (this.modalIsOpen = !0),
            setTimeout(() => {
              theme.a11y.trapFocus({
                container: this.modal,
                elementToFocus: this.focusOnOpen,
                namespace: "modal_focus",
              });
            }, 100),
            document.dispatchEvent(new CustomEvent("modalOpen")),
            document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
            this.bindEvents());
        }),
        (o.prototype.close = function (e) {
          if (this.modalIsOpen) {
            if (e && !e.target.closest(".js-modal-close")) {
              if (e.target.closest(".modal__inner")) return;
            }
            (document.activeElement.blur(),
              this.modal.classList.remove(this.config.openClass),
              this.modal.classList.add(this.config.closingClass),
              document.documentElement.classList.remove(
                ...this.config.bodyOpenClass,
              ),
              document.documentElement.classList.add(
                this.config.bodyClosingClass,
              ),
              window.setTimeout(
                function () {
                  (document.documentElement.classList.remove(
                    this.config.bodyClosingClass,
                  ),
                    this.modal.classList.remove(this.config.closingClass),
                    this.activeSource &&
                      this.activeSource.getAttribute("aria-expanded") &&
                      this.activeSource
                        .setAttribute("aria-expanded", "false")
                        .focus());
                }.bind(this),
                500,
              ),
              this.isSolid &&
                document.documentElement.classList.remove(
                  this.config.bodyOpenSolidClass,
                ),
              (this.modalIsOpen = !1),
              theme.a11y.removeTrapFocus({
                container: this.modal,
                namespace: "modal_focus",
              }),
              document.dispatchEvent(new CustomEvent("modalClose." + this.id)),
              this.unbindEvents());
          }
        }),
        (o.prototype.bindEvents = function () {
          (window.on(
            "keyup.modal",
            function (e) {
              e.keyCode === 27 && this.close();
            }.bind(this),
          ),
            this.config.closeOffContentClick &&
              this.modal.on("click.modal", this.close.bind(this)));
        }),
        (o.prototype.unbindEvents = function () {
          (document.documentElement.off(".modal"),
            this.config.closeOffContentClick && this.modal.off(".modal"));
        }),
        o
      );
    })()));
  class u extends HTMLElement {
    constructor() {
      (super(),
        (this.parallaxImage = this.querySelector("[data-parallax-image]")),
        (this.windowInnerHeight = window.innerHeight),
        (this.isActive = !1),
        (this.timeout = null),
        (this.directionMap = { right: 0, top: 90, left: 180, bottom: 270 }),
        (this.directionMultipliers = {
          0: [1, 0],
          90: [0, -1],
          180: [-1, 0],
          270: [0, 1],
        }),
        this.init(),
        window.addEventListener("scroll", () => this.scrollHandler()));
    }
    getParallaxInfo() {
      const {
        width: e,
        height: t,
        top: s,
      } = this.parallaxImage.getBoundingClientRect();
      let i = this.parallaxImage,
        n,
        { angle: r, movement: a } = i.dataset,
        l = Math.ceil(
          r === "top" ? t * (parseFloat(a) / 100) : e * (parseFloat(a) / 100),
        );
      ((r = this.directionMap[r] ?? parseFloat(r)),
        r !== r && (r = 270),
        l !== l && (l = 100),
        (r %= 360),
        r < 0 && (r += 360));
      const c = r > 90 && r < 270,
        v = r < 180;
      if (
        ((i.style[c ? "left" : "right"] = 0),
        (i.style[v ? "top" : "bottom"] = 0),
        r % 90)
      ) {
        const I = (r * Math.PI) / 180;
        n = [Math.cos(I), Math.sin(I) * -1];
      } else n = this.directionMultipliers[r];
      return (
        n[0] && (i.style.width = `calc(100% + ${l * Math.abs(n[0])}px)`),
        n[1] && (i.style.height = `calc(100% + ${l * Math.abs(n[1])}px)`),
        { element: i, movementPixels: l, multipliers: n, top: s, height: t }
      );
    }
    init() {
      const {
          element: e,
          movementPixels: t,
          multipliers: s,
          top: i,
          height: n,
        } = this.getParallaxInfo(),
        r = this.windowInnerHeight - i,
        a = this.windowInnerHeight + n,
        l = r / a;
      if (l > -0.1 && l < 1.1) {
        const c = Math.min(Math.max(l, 0), 1) * t;
        e.style.transform = `translate3d(${c * s[0]}px, ${c * s[1]}px, 0)`;
      }
      this.isActive && requestAnimationFrame(this.init.bind(this));
    }
    scrollHandler() {
      (this.isActive
        ? clearTimeout(this.timeout)
        : ((this.isActive = !0), requestAnimationFrame(this.init.bind(this))),
        (this.timeout = setTimeout(() => (this.isActive = !1), 20)));
    }
  }
  if (
    (customElements.define("parallax-image", u), typeof window.noUiSlider > "u")
  )
    throw new Error(
      "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js",
    );
  ((theme.PriceRange = (function () {
    var o = 10,
      e = {
        priceRangeSlider: ".price-range__slider",
        priceRangeInputMin: ".price-range__input-min",
        priceRangeInputMax: ".price-range__input-max",
        priceRangeDisplayMin: ".price-range__display-min",
        priceRangeDisplayMax: ".price-range__display-max",
      };
    function t(s, { onChange: i, onUpdate: n, ...r } = {}) {
      return (
        (this.container = s),
        (this.onChange = i),
        (this.onUpdate = n),
        (this.sliderOptions = r || {}),
        this.init()
      );
    }
    return (
      (t.prototype = Object.assign({}, t.prototype, {
        init: function () {
          if (!this.container.classList.contains("price-range"))
            throw new Error(
              "You must instantiate PriceRange with a valid container",
            );
          return (
            (this.formEl = this.container.closest("form")),
            (this.sliderEl = this.container.querySelector(e.priceRangeSlider)),
            (this.inputMinEl = this.container.querySelector(
              e.priceRangeInputMin,
            )),
            (this.inputMaxEl = this.container.querySelector(
              e.priceRangeInputMax,
            )),
            (this.displayMinEl = this.container.querySelector(
              e.priceRangeDisplayMin,
            )),
            (this.displayMaxEl = this.container.querySelector(
              e.priceRangeDisplayMax,
            )),
            (this.minRange = parseFloat(this.container.dataset.min) || 0),
            (this.minValue = parseFloat(this.container.dataset.minValue) || 0),
            (this.maxRange = parseFloat(this.container.dataset.max) || 100),
            (this.maxValue =
              parseFloat(this.container.dataset.maxValue) || this.maxRange),
            this.createPriceRange()
          );
        },
        createPriceRange: function () {
          this.sliderEl &&
            this.sliderEl.noUiSlider &&
            typeof this.sliderEl.noUiSlider.destroy == "function" &&
            this.sliderEl.noUiSlider.destroy();
          var s = noUiSlider.create(this.sliderEl, {
            connect: !0,
            step: o,
            ...this.sliderOptions,
            start: [this.minValue, this.maxValue],
            range: { min: this.minRange, max: this.maxRange },
          });
          return (
            s.on("update", (i) => {
              ((this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                i[0],
                theme.settings.moneyFormat,
              )),
                (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                  i[1],
                  theme.settings.moneyFormat,
                )),
                this.onUpdate && this.onUpdate(i));
            }),
            s.on("change", (i) => {
              if (
                ((this.inputMinEl.value = i[0]),
                (this.inputMaxEl.value = i[1]),
                this.onChange)
              ) {
                const n = new FormData(this.formEl);
                this.onChange(n);
              }
            }),
            s
          );
        },
      })),
      t
    );
  })()),
    (theme.AjaxProduct = (function () {
      var o = { loading: !1 };
      function e(t, s, i) {
        ((this.form = t), (this.args = i));
        var n = s || ".add-to-cart";
        this.form &&
          ((this.addToCart = t.querySelector(n)),
          this.form.addEventListener(
            "submit",
            this.addItemFromForm.bind(this),
          ));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          addItemFromForm: function (t, s) {
            if ((t.preventDefault(), !o.loading)) {
              (this.addToCart.classList.add("btn--loading"), (o.loading = !0));
              var i = new FormData(this.form);
              fetch(theme.routes.cartAdd, {
                method: "POST",
                body: i,
                headers: { "X-Requested-With": "XMLHttpRequest" },
              })
                .then((n) => n.json())
                .then(
                  function (n) {
                    if (n.status === 422)
                      (this.error(n),
                        document.dispatchEvent(
                          new CustomEvent("ajaxProduct:added"),
                        ));
                    else {
                      var r = n;
                      this.success(r);
                    }
                    ((o.loading = !1),
                      this.addToCart.classList.remove("btn--loading"),
                      document.body.classList.contains("template-cart") &&
                        (window.scrollTo(0, 0), location.reload()));
                  }.bind(this),
                );
            }
          },
          success: function (t) {
            var s = this.form.querySelector(".errors");
            (s && s.remove(),
              this.form.dispatchEvent(
                new CustomEvent("ajaxProduct:added", {
                  detail: { product: t, addToCartBtn: this.addToCart },
                  bubbles: !0,
                }),
              ),
              this.args &&
                this.args.scopedEventId &&
                document.dispatchEvent(
                  new CustomEvent(
                    "ajaxProduct:added:" + this.args.scopedEventId,
                    { detail: { product: t, addToCartBtn: this.addToCart } },
                  ),
                ));
          },
          error: function (t) {
            if (!t.description) {
              console.warn(t);
              return;
            }
            var s = this.form.querySelector(".errors");
            s && s.remove();
            var i = document.createElement("div");
            (i.classList.add("errors", "text-center"),
              typeof t.description == "object"
                ? (i.textContent = t.message)
                : (i.textContent = t.description),
              this.form.append(i),
              this.form.dispatchEvent(
                new CustomEvent("ajaxProduct:error", {
                  detail: { errorMessage: t.description },
                  bubbles: !0,
                }),
              ),
              this.args &&
                this.args.scopedEventId &&
                document.dispatchEvent(
                  new CustomEvent(
                    "ajaxProduct:error:" + this.args.scopedEventId,
                    { detail: { errorMessage: t.description } },
                  ),
                ));
          },
        })),
        e
      );
    })()),
    (theme.ProductMedia = (function () {
      var o = {},
        e = {},
        t = {},
        s = {
          mediaGroup: "[data-product-single-media-group]",
          xrButton: "[data-shopify-xr]",
        };
      function i(c, v) {
        ((o[v] = { loaded: !1 }),
          c.forEach(function (I, C) {
            var T = I.dataset.mediaId,
              P = I.querySelector("model-viewer"),
              q = P.dataset.modelId;
            if (C === 0) {
              var k = I.closest(s.mediaGroup),
                A = k.querySelector(s.xrButton);
              t[v] = { element: A, defaultId: q };
            }
            e[T] = { modelId: q, sectionId: v, container: I, element: P };
          }),
          window.Shopify.loadFeatures([
            { name: "shopify-xr", version: "1.0", onLoad: n },
            { name: "model-viewer-ui", version: "1.0", onLoad: r },
          ]),
          theme.LibraryLoader.load("modelViewerUiStyles"));
      }
      function n(c) {
        if (!c) {
          if (!window.ShopifyXR) {
            document.addEventListener("shopify_xr_initialized", function () {
              n();
            });
            return;
          }
          for (var v in o)
            if (o.hasOwnProperty(v)) {
              var I = o[v];
              if (I.loaded) continue;
              var C = document.querySelector("#ModelJson-" + v);
              (window.ShopifyXR.addModels(JSON.parse(C.innerHTML)),
                (I.loaded = !0));
            }
          window.ShopifyXR.setupXRElements();
        }
      }
      function r(c) {
        if (!c) {
          for (var v in e)
            if (e.hasOwnProperty(v)) {
              var I = e[v];
              (!I.modelViewerUi &&
                Shopify &&
                (I.modelViewerUi = new Shopify.ModelViewerUI(I.element)),
                a(I));
            }
        }
      }
      function a(c) {
        var v = t[c.sectionId];
        (c.container.addEventListener("mediaVisible", function () {
          (v.element.setAttribute("data-shopify-model3d-id", c.modelId),
            !theme.config.isTouch && c.modelViewerUi.play());
        }),
          c.container.addEventListener("mediaHidden", function () {
            (v.element.setAttribute("data-shopify-model3d-id", v.defaultId),
              c.modelViewerUi.pause());
          }),
          c.container.addEventListener("xrLaunch", function () {
            c.modelViewerUi.pause();
          }));
      }
      function l(c) {
        for (var v in e)
          if (e.hasOwnProperty(v)) {
            var I = e[v];
            I.sectionId === c && delete e[v];
          }
        delete o[c];
      }
      return { init: i, removeSectionModels: l };
    })()),
    (theme.QtySelector = (function () {
      var o = {
        input: ".js-qty__num",
        plus: ".js-qty__adjust--plus",
        minus: ".js-qty__adjust--minus",
      };
      function e(t, s) {
        ((this.wrapper = t),
          (this.plus = t.querySelector(o.plus)),
          (this.minus = t.querySelector(o.minus)),
          (this.input = t.querySelector(o.input)),
          (this.minValue = this.input.getAttribute("min") || 1));
        var i = { namespace: null, isCart: !1, key: this.input.dataset.id };
        ((this.options = Object.assign({}, i, s)), this.init());
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            (this.plus.addEventListener(
              "click",
              function () {
                var t = this._getQty();
                this._change(t + 1);
              }.bind(this),
            ),
              this.minus.addEventListener(
                "click",
                function () {
                  var t = this._getQty();
                  this._change(t - 1);
                }.bind(this),
              ),
              this.input.addEventListener(
                "change",
                function (t) {
                  this._change(this._getQty());
                }.bind(this),
              ));
          },
          _getQty: function () {
            var t = this.input.value;
            return (
              (parseFloat(t) == parseInt(t) && !isNaN(t)) || (t = 1),
              parseInt(t)
            );
          },
          _change: function (t) {
            (t <= this.minValue && (t = this.minValue),
              (this.input.value = t),
              this.options.isCart &&
                document.dispatchEvent(
                  new CustomEvent("cart:quantity" + this.options.namespace, {
                    detail: [this.options.key, t, this.wrapper],
                  }),
                ));
          },
        })),
        e
      );
    })()),
    (theme.initQuickShop = function () {
      var o = document.querySelectorAll(".grid-product");
      if (!o.length || !theme.settings.quickView) return;
      o.forEach((t) => {
        (t.addEventListener("mouseover", e), t.addEventListener("focusin", e));
      });
      function e(t) {
        var s = t.currentTarget;
        if (!theme.config.bpSmall) {
          if (
            (s.removeEventListener("mouseover", e),
            s.removeEventListener("focusin", e),
            !s || !s.dataset.productId)
          )
            return;
          var i = s.dataset.productId,
            n = s.dataset.productHandle,
            r = s.querySelector(".quick-product__btn");
          theme.preloadProductModal(n, i, r);
        }
      }
    }),
    (theme.preloadProductModal = function (o, e, t) {
      var s = document.getElementById("QuickShopHolder-" + o),
        i = theme.routes.home + "/products/" + o + "?view=modal";
      ((i = i.replace("//", "/")),
        fetch(i)
          .then((n) => n.text())
          .then((n) => {
            const r = document.createElement("div");
            r.innerHTML = n;
            const a = r.querySelector(
              '.product-section[data-product-handle="' + o + '"]',
            );
            if (s) {
              ((s.innerHTML = ""), s.append(a));
              var l = "QuickShopModal-" + e,
                c = "quick-modal-" + e;
              (new theme.Modals(l, c),
                theme.sections.register("product", theme.Product, s),
                theme.collapsibles.init(),
                theme.videoModal());
            }
          }));
    }),
    (theme.Slideshow = (function () {
      var o = {
          animateOut: "animate-out",
          isPaused: "is-paused",
          isActive: "is-active",
        },
        e = {
          allSlides: ".slideshow__slide",
          currentSlide: ".is-selected",
          wrapper: ".slideshow-wrapper",
          pauseButton: ".slideshow__pause",
        },
        t = {
          thumb: ".product__thumb-item:not(.hide)",
          links: ".product__thumb-item:not(.hide) a",
          arrow: ".product__thumb-arrow",
        },
        s = {
          adaptiveHeight: !1,
          autoPlay: !1,
          avoidReflow: !1,
          childNav: null,
          childNavScroller: null,
          childVertical: !1,
          dragThreshold: 7,
          fade: !1,
          friction: 0.8,
          initialIndex: 0,
          pageDots: !1,
          pauseAutoPlayOnHover: !1,
          prevNextButtons: !1,
          rightToLeft: theme.config.rtl,
          selectedAttraction: 0.14,
          setGallerySize: !0,
          wrapAround: !0,
        };
      function i(n, r) {
        if (
          ((this.el = n),
          (this.args = Object.assign({}, s, r)),
          (this.args.on = {
            ready: this.init.bind(this),
            change: this.slideChange.bind(this),
            settle: this.afterChange.bind(this),
          }),
          this.args.childNav &&
            ((this.childNavEls = this.args.childNav.querySelectorAll(t.thumb)),
            (this.childNavLinks = this.args.childNav.querySelectorAll(t.links)),
            (this.arrows = this.args.childNav.querySelectorAll(t.arrow)),
            this.childNavLinks.length && this.initChildNav()),
          this.args.avoidReflow && l(n),
          (this.slideshow = new Flickity(n, this.args)),
          n.dataset.zoom &&
            n.dataset.zoom === "true" &&
            (this.slideshow.on("dragStart", () => {
              ((this.slideshow.slider.style.pointerEvents = "none"),
                this.slideshow.options.fade &&
                  (this.slideshow.slider.querySelector(
                    ".is-selected",
                  ).style.pointerEvents = "none"));
            }),
            this.slideshow.on("dragEnd", () => {
              ((this.slideshow.slider.style.pointerEvents = "auto"),
                this.slideshow.options.fade &&
                  (this.slideshow.slider.querySelector(
                    ".is-selected",
                  ).style.pointerEvents = "auto"));
            })),
          this.args.autoPlay)
        ) {
          var a = n.closest(e.wrapper);
          ((this.pauseBtn = a.querySelector(e.pauseButton)),
            this.pauseBtn &&
              this.pauseBtn.addEventListener(
                "click",
                this._togglePause.bind(this),
              ));
        }
        window.on(
          "resize",
          theme.utils.debounce(
            300,
            function () {
              this.resize();
            }.bind(this),
          ),
        );
        function l(c) {
          if (c.id) {
            for (var v = c.firstChild; v != null && v.nodeType == 3; )
              v = v.nextSibling;
            var I = document.createElement("style");
            ((I.innerHTML = `#${c.id} .flickity-viewport{height:${v.offsetHeight}px}`),
              document.head.appendChild(I));
          }
        }
      }
      return (
        (i.prototype = Object.assign({}, i.prototype, {
          init: function (n) {
            ((this.currentSlide = this.el.querySelector(e.currentSlide)),
              this.args.callbacks &&
                this.args.callbacks.onInit &&
                typeof this.args.callbacks.onInit == "function" &&
                this.args.callbacks.onInit(this.currentSlide),
              window.AOS && AOS.refresh());
          },
          slideChange: function (n) {
            (this.args.fade &&
              this.currentSlide &&
              (this.currentSlide.classList.add(o.animateOut),
              this.currentSlide.addEventListener(
                "transitionend",
                function () {
                  this.currentSlide.classList.remove(o.animateOut);
                }.bind(this),
              )),
              this.args.childNav && this.childNavGoTo(n),
              this.args.callbacks &&
                this.args.callbacks.onChange &&
                typeof this.args.callbacks.onChange == "function" &&
                this.args.callbacks.onChange(n),
              this.arrows &&
                this.arrows.length &&
                (this.arrows[0].classList.toggle("hide", n === 0),
                this.arrows[1].classList.toggle(
                  "hide",
                  n === this.childNavLinks.length - 1,
                )));
          },
          afterChange: function (n) {
            (this.args.fade &&
              this.el.querySelectorAll(e.allSlides).forEach((r) => {
                r.classList.remove(o.animateOut);
              }),
              (this.currentSlide = this.el.querySelector(e.currentSlide)),
              this.args.childNav &&
                this.childNavGoTo(this.slideshow.selectedIndex));
          },
          destroy: function () {
            (this.args.childNav &&
              this.childNavLinks.length &&
              this.childNavLinks.forEach((n) => {
                n.classList.remove(o.isActive);
              }),
              this.slideshow.destroy());
          },
          reposition: function () {
            this.slideshow.reposition();
          },
          _togglePause: function () {
            this.pauseBtn.classList.contains(o.isPaused)
              ? (this.pauseBtn.classList.remove(o.isPaused),
                this.slideshow.playPlayer())
              : (this.pauseBtn.classList.add(o.isPaused),
                this.slideshow.pausePlayer());
          },
          resize: function () {
            this.slideshow.resize();
          },
          play: function () {
            this.slideshow.playPlayer();
          },
          pause: function () {
            this.slideshow.pausePlayer();
          },
          goToSlide: function (n) {
            this.slideshow.select(n);
          },
          setDraggable: function (n) {
            ((this.slideshow.options.draggable = n),
              this.slideshow.updateDraggable());
          },
          initChildNav: function () {
            (this.childNavLinks[this.args.initialIndex].classList.add(
              "is-active",
            ),
              this.childNavLinks.forEach((n, r) => {
                (n.setAttribute("data-index", r),
                  n.addEventListener(
                    "click",
                    function (a) {
                      (a.preventDefault(),
                        this.goToSlide(this.getChildIndex(a.currentTarget)));
                    }.bind(this),
                  ),
                  n.addEventListener(
                    "focus",
                    function (a) {
                      this.goToSlide(this.getChildIndex(a.currentTarget));
                    }.bind(this),
                  ),
                  n.addEventListener(
                    "keydown",
                    function (a) {
                      a.keyCode === 13 &&
                        this.goToSlide(this.getChildIndex(a.currentTarget));
                    }.bind(this),
                  ));
              }),
              this.arrows.length &&
                this.arrows.forEach((n) => {
                  n.addEventListener("click", this.arrowClick.bind(this));
                }));
          },
          getChildIndex: function (n) {
            return parseInt(n.dataset.index);
          },
          childNavGoTo: function (n) {
            this.childNavLinks.forEach((c) => {
              (c.blur(), c.classList.remove(o.isActive));
            });
            var r = this.childNavLinks[n];
            if ((r.classList.add(o.isActive), !!this.args.childNavScroller))
              if (this.args.childVertical) {
                var a = r.offsetTop;
                this.args.childNavScroller.scrollTop = a - 100;
              } else {
                var l = r.offsetLeft;
                this.args.childNavScroller.scrollLeft = l - 100;
              }
          },
          arrowClick: function (n) {
            n.currentTarget.classList.contains("product__thumb-arrow--prev")
              ? this.slideshow.previous()
              : this.slideshow.next();
          },
        })),
        i
      );
    })()),
    (theme.VariantAvailability = (function () {
      var o = { disabled: "disabled" };
      function e(t) {
        ((this.type = t.type),
          (this.variantsObject = t.variantsObject),
          (this.currentVariantObject = t.currentVariantObject),
          (this.container = t.container),
          (this.namespace = t.namespace),
          this.init());
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            (this.container.on(
              "variantChange" + this.namespace,
              this.setAvailability.bind(this),
            ),
              this.setInitialAvailability());
          },
          createAvailableOptionsTree(t, s) {
            return t.reduce(
              (i, n) => (
                Object.keys(i).forEach((r) => {
                  if (n[r] === null) return;
                  let a = i[r].find((v) => v.value === n[r]);
                  typeof a > "u" &&
                    ((a = { value: n[r], soldOut: !0 }), i[r].push(a));
                  const l = s.find(({ value: v, index: I }) => I === "option1"),
                    c = s.find(({ value: v, index: I }) => I === "option2");
                  switch (r) {
                    case "option1":
                      a.soldOut = a.soldOut && n.available ? !1 : a.soldOut;
                      break;
                    case "option2":
                      l &&
                        n.option1 === l.value &&
                        (a.soldOut = a.soldOut && n.available ? !1 : a.soldOut);
                    case "option3":
                      l &&
                        n.option1 === l.value &&
                        c &&
                        n.option2 === c.value &&
                        (a.soldOut = a.soldOut && n.available ? !1 : a.soldOut);
                  }
                }),
                i
              ),
              { option1: [], option2: [], option3: [] },
            );
          },
          setInitialAvailability: function () {
            this.container
              .querySelectorAll(".variant-input-wrap")
              .forEach((r) => {
                this.disableVariantGroup(r);
              });
            const t = this.currentVariantObject.options.map((r, a) => ({
                value: r,
                index: `option${a + 1}`,
              })),
              s = this.createAvailableOptionsTree(
                this.variantsObject,
                t,
                this.currentVariantObject,
              );
            for (var [i, n] of Object.entries(s)) this.manageOptionState(i, n);
          },
          setAvailability: function (t) {
            const {
                value: s,
                index: i,
                currentlySelectedValues: n,
                variant: r,
              } = t.detail,
              a = this.createAvailableOptionsTree(
                this.variantsObject,
                n,
                r,
                i,
                s,
              );
            for (var [l, c] of Object.entries(a))
              this.manageOptionState(l, c, s);
          },
          manageOptionState: function (t, s) {
            var i = this.container.querySelector(
              '.variant-input-wrap[data-index="' + t + '"]',
            );
            s.forEach((n) => {
              this.enableVariantOption(i, n);
            });
          },
          enableVariantOption: function (t, s) {
            var i = s.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
            if (this.type === "dropdown")
              s.soldOut
                ? (t.querySelector('option[value="' + i + '"]').disabled = !0)
                : (t.querySelector('option[value="' + i + '"]').disabled = !1);
            else {
              var n = t.querySelector('.variant-input[data-value="' + i + '"]'),
                r = n.querySelector("input"),
                a = n.querySelector("label");
              (r.classList.remove(o.disabled),
                a.classList.remove(o.disabled),
                s.soldOut &&
                  (r.classList.add(o.disabled), a.classList.add(o.disabled)));
            }
          },
          disableVariantGroup: function (t) {
            this.type === "dropdown"
              ? t.querySelectorAll("option").forEach((s) => {
                  s.disabled = !0;
                })
              : (t.querySelectorAll("input").forEach((s) => {
                  s.classList.add(o.disabled);
                }),
                t.querySelectorAll("label").forEach((s) => {
                  s.classList.add(o.disabled);
                }));
          },
        })),
        e
      );
    })()),
    (theme.videoModal = function () {
      var o,
        e,
        t = "VideoHolder",
        s = {
          youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
          vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
          mp4Trigger: ".product-video-trigger--mp4",
          mp4Player: ".product-video-mp4-sound",
        },
        i = document.querySelectorAll(s.youtube),
        n = document.querySelectorAll(s.vimeo),
        r = document.querySelectorAll(s.mp4Trigger);
      if (!i.length && !n.length && !r.length) return;
      var a = document.getElementById(t);
      (i.length && theme.LibraryLoader.load("youtubeSdk"),
        n.length && theme.LibraryLoader.load("vimeo", window.vimeoApiReady));
      var l = new theme.Modals("VideoModal", "video-modal", {
        closeOffContentClick: !0,
        bodyOpenClass: ["modal-open", "video-modal-open"],
        solid: !0,
      });
      (i.forEach((k) => {
        k.addEventListener("click", c);
      }),
        n.forEach((k) => {
          k.addEventListener("click", v);
        }),
        r.forEach((k) => {
          k.addEventListener("click", I);
        }),
        document.addEventListener("modalClose.VideoModal", q));
      function c(k) {
        if (theme.config.youTubeReady) {
          (k.preventDefault(), P(), l.open(k));
          var A = T(k.currentTarget.getAttribute("href"));
          o = new theme.YouTube(t, {
            videoId: A,
            style: "sound",
            events: { onReady: C },
          });
        }
      }
      function v(k) {
        if (theme.config.vimeoReady) {
          (k.preventDefault(), P(), l.open(k));
          var A = k.currentTarget.dataset.videoId,
            M = k.currentTarget.dataset.videoLoop;
          e = new theme.VimeoPlayer(t, A, { style: "sound", loop: M });
        }
      }
      function I(k) {
        P();
        var A = k.currentTarget,
          M = A.parentNode.querySelector(s.mp4Player),
          V = M.cloneNode(!0);
        (V.classList.remove("hide"),
          a.append(V),
          l.open(k),
          a.querySelector("video").play());
      }
      function C(k) {
        (k.target.unMute(), k.target.playVideo());
      }
      function T(k) {
        var A =
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
          M = k.match(A);
        return M && M[7].length == 11 ? M[7] : !1;
      }
      function P() {
        a.innerHTML = "";
      }
      function q() {
        o && typeof o.destroy == "function"
          ? o.destroy()
          : e && typeof e.destroy == "function"
            ? e.destroy()
            : P();
      }
    }));
  class h extends HTMLElement {
    constructor() {
      (super(),
        (this.el = this),
        (this.inner = this.querySelector("[data-tool-tip-inner]")),
        (this.closeButton = this.querySelector("[data-tool-tip-close]")),
        (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
        (this.toolTipTitle = this.querySelector("[data-tool-tip-title]")),
        (this.triggers = document.querySelectorAll("[data-tool-tip-trigger]")),
        document.addEventListener("tooltip:open", (e) => {
          this._open(e.detail.context, e.detail.content);
        }));
    }
    _open(e, t) {
      ((this.toolTipContent.innerHTML = t),
        e != "store-availability" && this.toolTipTitle.remove(),
        this._lockScrolling(),
        this.closeButton &&
          this.closeButton.on("click.tooltip-close", () => {
            this._close();
          }),
        document.documentElement.on("click.tooltip-outerclick", (s) => {
          this.el.dataset.toolTipOpen === "true" &&
            !this.inner.contains(s.target) &&
            this._close();
        }),
        document.documentElement.on("keydown.tooltip-esc", (s) => {
          s.code === "Escape" && this._close();
        }),
        (this.el.dataset.toolTipOpen = !0),
        (this.el.dataset.toolTip = e));
    }
    _close() {
      ((this.toolTipContent.innerHTML = ""),
        (this.el.dataset.toolTipOpen = "false"),
        (this.el.dataset.toolTip = ""),
        this._unlockScrolling(),
        this.closeButton.off("click.tooltip-close"),
        document.documentElement.off("click.tooltip-outerclick"),
        document.documentElement.off("keydown.tooltip-esc"));
    }
    _lockScrolling() {
      (theme.a11y.trapFocus({ container: this.el, namespace: "tooltip_focus" }),
        theme.a11y.lockMobileScrolling(),
        document.documentElement.classList.add("modal-open"));
    }
    _unlockScrolling() {
      (theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: "tooltip_focus",
      }),
        theme.a11y.unlockMobileScrolling(),
        document.documentElement.classList.remove("modal-open"));
    }
  }
  customElements.define("tool-tip", h);
  class p extends HTMLElement {
    constructor() {
      (super(),
        (this.el = this),
        (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
        this.init());
    }
    init() {
      const e = new CustomEvent("tooltip:open", {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML,
        },
        bubbles: !0,
      });
      this.el.addEventListener("click", (t) => {
        (t.stopPropagation(), this.dispatchEvent(e));
      });
    }
  }
  customElements.define("tool-tip-trigger", p);
  class g extends HTMLElement {
    constructor() {
      (super(),
        (this.closeBtn = this.querySelector("[data-close-button]")),
        (this.popupTrigger = this.querySelector("[data-message]")),
        (this.id = this.dataset.sectionId),
        (this.newsletterId = `NewsletterPopup-${this.id}`),
        (this.cookie = Cookies.get(`newsletter-${this.id}`)),
        (this.cookieName = `newsletter-${this.id}`),
        (this.secondsBeforeShow = this.dataset.delaySeconds),
        (this.expiry = parseInt(this.dataset.delayDays)),
        (this.modal = new theme.Modals(
          `NewsletterPopup-${this.newsletterId}`,
          "newsletter-popup-modal",
        )),
        this.init());
    }
    init() {
      (document.addEventListener("shopify:block:select", (e) => {
        e.detail.sectionId === this.id && this.show(0, !0);
      }),
        document.addEventListener("shopify:block:deselect", (e) => {
          e.detail.sectionId === this.id && this.hide();
        }),
        document.addEventListener(`modalOpen.${this.newsletterId}`, () =>
          this.hide(),
        ),
        document.addEventListener(`modalClose.${this.newsletterId}`, () =>
          this.show(),
        ),
        document.addEventListener("newsletter:openReminder", () =>
          this.show(0),
        ),
        this.closeBtn.addEventListener("click", () => {
          (this.hide(),
            Cookies.set(this.cookieName, "opened", {
              path: "/",
              expires: this.expiry,
            }));
        }),
        this.popupTrigger.addEventListener("click", () => {
          const e = new CustomEvent("reminder:openNewsletter", { bubbles: !0 });
          (this.dispatchEvent(e), this.hide());
        }));
    }
    show(e = this.secondsBeforeShow, t = !1) {
      sessionStorage.getItem("reminderAppeared") === "true" ||
        setTimeout(() => {
          ((this.dataset.enabled = "true"),
            sessionStorage.setItem("reminderAppeared", !0));
        }, e * 1e3);
    }
    hide() {
      this.dataset.enabled = "false";
    }
  }
  customElements.define("newsletter-reminder", g);
  class f extends HTMLElement {
    constructor() {
      (super(), this.init());
    }
    init() {
      const e = (t, s) => {
        t[0].isIntersecting && (this.removeAnimations(), s.unobserve(this));
      };
      new IntersectionObserver(e.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
    removeAnimations() {
      const e = this.closest(".image-wrap"),
        t = this.closest(".skrim__link");
      (e && e.classList.add("loaded"), t && t.classList.add("loaded"));
    }
  }
  customElements.define("image-element", f);
  class m extends HTMLElement {
    constructor() {
      (super(),
        (this.enabled = this.getAttribute("data-enabled")),
        (this.context = this.getAttribute("data-context")),
        (this.input = this.querySelector('input[type="search"]')),
        (this.predictiveSearchResults =
          this.querySelector("#predictive-search")),
        (this.closeBtn = this.querySelector(".btn--close-search")),
        (this.screen = this.querySelector("[data-screen]")),
        (this.SearchModal = this.closest("#SearchModal") || null),
        document.addEventListener("predictive-search:open", (e) => {
          e.detail.context === this.context &&
            (this.classList.add("is-active"),
            setTimeout(() => {
              this.input.focus();
            }, 100),
            document.body.classList.add("predictive-overflow-hidden"));
        }),
        this.SearchModal &&
          new MutationObserver((t) => {
            t.forEach((s) => {
              s.attributeName === "class" &&
                s.target.className.indexOf("modal--is-active") > -1 &&
                setTimeout(() => {
                  this.input.focus();
                }, 100);
            });
          }).observe(this.SearchModal, { attributes: !0 }),
        this.enabled !== "false" &&
          (this.input.addEventListener("keydown", () => {
            this.classList.add("is-active");
          }),
          this.input.addEventListener(
            "input",
            this.debounce((e) => {
              this.onChange(e);
            }, 300).bind(this),
          ),
          document.addEventListener("predictive-search:close", () => {
            this.close();
          }),
          document.addEventListener("keydown", (e) => {
            e.keyCode === 27 && this.close();
          }),
          this.closeBtn.addEventListener("click", (e) => {
            (e.preventDefault(), this.close());
          }),
          this.screen.addEventListener("click", () => {
            this.close();
          })));
    }
    onChange() {
      const e = this.input.value.trim();
      e.length && this.getSearchResults(e);
    }
    getSearchResults(e) {
      const t = {
          q: e,
          "resources[limit]": 3,
          "resources[limit_scope]": "each",
        },
        s = this.paramUrl(t);
      fetch(`${theme.routes.predictiveSearch}?${s}&section_id=search-results`)
        .then((i) => {
          if (!i.ok) {
            const n = new Error(i.status);
            throw (this.close(), n);
          }
          return i.text();
        })
        .then((i) => {
          const n = new DOMParser()
            .parseFromString(i, "text/html")
            .querySelector("#shopify-section-search-results").innerHTML;
          ((this.predictiveSearchResults.innerHTML = n),
            this.open(),
            AOS.refreshHard());
        })
        .catch((i) => {
          throw (this.close(), i);
        });
    }
    open() {
      this.predictiveSearchResults.style.display = "block";
    }
    close() {
      ((this.predictiveSearchResults.style.display = "none"),
        (this.predictiveSearchResults.innerHTML = ""),
        this.classList.remove("is-active"),
        document.body.classList.remove("predictive-overflow-hidden"),
        document.dispatchEvent(new CustomEvent("predictive-search:close-all")));
    }
    debounce(e, t) {
      let s;
      return (...i) => {
        (clearTimeout(s), (s = setTimeout(() => e.apply(this, i), t)));
      };
    }
    paramUrl(e) {
      return Object.keys(e)
        .map(function (t) {
          return t + "=" + encodeURIComponent(e[t]);
        })
        .join("&");
    }
  }
  customElements.define("predictive-search", m);
  class w extends HTMLElement {
    constructor() {
      (super(),
        (this.checkboxInput = this.querySelector(
          `#Recipient-Checkbox-${this.dataset.sectionId}`,
        )),
        (this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`,
        )),
        (this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`,
        )),
        (this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`,
        )),
        (this.dateInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`,
        )),
        this.addEventListener("change", () => this.onChange()),
        (this.recipientFields = this.querySelector(".recipient-fields")),
        this.checkboxInput.addEventListener("change", () => {
          this.recipientFields.style.display = this.checkboxInput.checked
            ? "block"
            : "none";
        }));
    }
    connectedCallback() {
      (document.addEventListener("ajaxProduct:error", (e) => {
        e.target.querySelector('[name="id"]').value ===
          this.dataset.productVariantId &&
          this.displayErrorMessage(e.detail.errorMessage);
      }),
        document.addEventListener("ajaxProduct:added", (e) => {
          e.target.querySelector('[name="id"]').value ===
            this.dataset.productVariantId &&
            (this.clearInputFields(), this.clearErrorMessage());
        }));
    }
    onChange() {
      this.checkboxInput.checked ||
        (this.clearInputFields(), this.clearErrorMessage());
    }
    clearInputFields() {
      this.querySelectorAll(".field__input").forEach((e) => (e.value = ""));
    }
    displayErrorMessage(e) {
      if ((this.clearErrorMessage(), e))
        return Object.entries(e).forEach(([t, s]) => {
          const i = this[`${t}Input`];
          i &&
            (i.setAttribute("aria-invalid", !0),
            i.classList.add("field__input--error"));
        });
    }
    clearErrorMessage() {
      this.querySelectorAll(".field__input").forEach((e) => {
        (e.setAttribute("aria-invalid", !1),
          e.removeAttribute("aria-describedby"),
          e.classList.remove("field__input--error"));
      });
    }
  }
  (customElements.define("recipient-form", w),
    (theme.announcementBar = (function () {
      var o = {
          autoPlay: 5e3,
          avoidReflow: !0,
          cellAlign: theme.config.rtl ? "right" : "left",
        },
        e,
        t;
      function s() {
        ((e = document.getElementById("AnnouncementSlider")),
          e &&
            (a(),
            e.dataset.blockCount !== 1 &&
              ((theme.config.bpSmall || e.dataset.compact === "true") && i(),
              document.addEventListener("matchSmall", function () {
                (a(), i());
              }),
              document.addEventListener("unmatchSmall", function () {
                (a(), e.dataset.compact === "true" && i());
              }))));
      }
      function i() {
        t = new theme.Slideshow(e, o);
      }
      function n(l) {
        var c = e.querySelector("#AnnouncementSlide-" + l),
          v = parseInt(c.dataset.index);
        t && typeof t.pause == "function" && (t.goToSlide(v), t.pause());
      }
      function r() {
        t && typeof t.play == "function" && t.play();
      }
      function a() {
        t && typeof t.destroy == "function" && t.destroy();
      }
      return { init: s, onBlockSelect: n, onBlockDeselect: r, unload: a };
    })()),
    (theme.customerTemplates = function () {
      (o(), t(), s(), i());
      function o() {
        var n = window.location.hash;
        n === "#recover" && e();
      }
      function e() {
        (document
          .getElementById("RecoverPasswordForm")
          .classList.toggle("hide"),
          document
            .getElementById("CustomerLoginForm")
            .classList.toggle("hide"));
      }
      function t() {
        var n = document.getElementById("RecoverPassword");
        n &&
          n.addEventListener("click", function (a) {
            (a.preventDefault(), e());
          });
        var r = document.getElementById("HideRecoverPasswordLink");
        r &&
          r.addEventListener("click", function (a) {
            (a.preventDefault(), e());
          });
      }
      function s() {
        var n = document.querySelector(".reset-password-success");
        n && document.getElementById("ResetSuccess").classList.remove("hide");
      }
      function i() {
        var n = document.getElementById("AddressNewForm"),
          r = document.querySelectorAll(".js-address-form");
        !n ||
          !r.length ||
          (setTimeout(function () {
            document.querySelectorAll(".js-address-country").forEach((a) => {
              var l = a.dataset.countryId,
                c = a.dataset.provinceId,
                v = a.dataset.provinceContainerId;
              new Shopify.CountryProvinceSelector(l, c, { hideElement: v });
            });
          }, 1e3),
          document.querySelectorAll(".address-new-toggle").forEach((a) => {
            a.addEventListener("click", function () {
              n.classList.toggle("hide");
            });
          }),
          document.querySelectorAll(".address-edit-toggle").forEach((a) => {
            a.addEventListener("click", function (l) {
              var c = l.currentTarget.dataset.formId;
              document
                .getElementById("EditAddress_" + c)
                .classList.toggle("hide");
            });
          }),
          document.querySelectorAll(".address-delete").forEach((a) => {
            a.addEventListener("click", function (l) {
              var c = l.currentTarget.dataset.formId,
                v = l.currentTarget.dataset.confirmMessage;
              confirm(v || "Are you sure you wish to delete this address?") &&
                Shopify &&
                Shopify.postLink("/account/addresses/" + c, {
                  parameters: { _method: "delete" },
                });
            });
          }));
      }
    }),
    (theme.CartDrawer = (function () {
      var o = { form: "#CartDrawerForm" };
      function e() {
        ((this.form = document.querySelector(o.form)),
          (this.drawer = new theme.Drawers("CartDrawer", "cart")),
          this.init());
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            ((this.cartForm = new theme.CartForm(this.form)),
              this.cartForm.buildCart(),
              document.addEventListener(
                "ajaxProduct:added",
                function (t) {
                  (this.cartForm.buildCart(), this.open());
                }.bind(this),
              ),
              document.addEventListener("cart:open", this.open.bind(this)),
              document.addEventListener("cart:close", this.close.bind(this)));
          },
          open: function () {
            (this.drawer.open(),
              theme.a11y.trapFocus({
                container: this.form,
                elementToFocus: this.form,
                namespace: "cartdrawer_focus",
              }));
          },
          close: function () {
            (this.drawer.close(),
              theme.a11y.removeTrapFocus({
                container: this.form,
                namespace: "cartdrawer_focus",
              }));
          },
        })),
        e
      );
    })()),
    (theme.headerNav = (function () {
      var o = {
          wrapper: "#HeaderWrapper",
          siteHeader: "#SiteHeader",
          searchBtn: ".js-search-header",
          searchContainer: ".site-header__search-container",
          megamenu: ".megamenu",
          navDetails: ".site-nav__details",
        },
        e = {
          namespace: ".siteNav",
          wrapperOverlayed: !1,
          overlayedClass: "is-light",
          overlayEnabledClass: "header-wrapper--sticky",
          stickyEnabled: !1,
          stickyActive: !1,
          stickyClass: "site-header--stuck",
          stickyHeaderWrapper: "StickyHeaderWrap",
          openTransitionClass: "site-header--opening",
          lastScroll: 0,
        },
        t,
        s;
      function i() {
        ((t = document.querySelector(o.wrapper)),
          (s = document.querySelector(o.siteHeader)),
          (e.stickyEnabled = s.dataset.sticky === "true"),
          e.stickyEnabled &&
            ((e.wrapperOverlayed = t.classList.contains(e.overlayedClass)),
            a()),
          (theme.settings.overlayHeader = s.dataset.overlay === "true"),
          theme.settings.overlayHeader &&
            Shopify &&
            Shopify.designMode &&
            document.body.classList.contains("template-collection") &&
            !document.querySelector(".collection-hero") &&
            this.disableOverlayHeader(),
          n(),
          P());
      }
      function n() {
        document.querySelectorAll(o.navDetails).forEach((A) => {
          const M = A.querySelector("summary");
          document.addEventListener("click", (V) => {
            A.hasAttribute("open") && !A.contains(V.target)
              ? (A.removeAttribute("open"),
                M.setAttribute("aria-expanded", "false"))
              : A.hasAttribute("open")
                ? M.setAttribute("aria-expanded", "false")
                : M.setAttribute("aria-expanded", "true");
          });
        });
      }
      function r() {
        (t.classList.remove(e.overlayEnabledClass, e.overlayedClass),
          (e.wrapperOverlayed = !1),
          (theme.settings.overlayHeader = !1));
      }
      function a() {
        ((theme.config.stickyHeader = l()),
          theme.config.stickyHeader
            ? ((e.forceStopSticky = !1), c())
            : (e.forceStopSticky = !0));
      }
      function l() {
        var k = 0;
        return (
          s.querySelectorAll(o.megamenu).forEach((A) => {
            var M = A.offsetHeight;
            M > k && (k = M);
          }),
          !(window.innerHeight < k + 120)
        );
      }
      function c() {
        e.lastScroll = 0;
        var k = document.createElement("div");
        ((k.id = e.stickyHeaderWrapper),
          theme.utils.wrap(s, k),
          v(s),
          I(),
          window.on("resize" + e.namespace, theme.utils.debounce(50, I)),
          window.on("scroll" + e.namespace, theme.utils.throttle(20, C)),
          Shopify &&
            Shopify.designMode &&
            setTimeout(function () {
              I();
            }, 250));
      }
      function v(k) {
        const M = k.closest(
          ".shopify-section-group-header-group",
        ).nextElementSibling;
        if (M && M.classList.contains("shopify-section-group-header-group")) {
          const V = M.offsetHeight;
          document.querySelector(o.wrapper).style.top = V + "px";
        }
      }
      function I() {
        if (e.stickyEnabled) {
          var k = s.offsetHeight;
          if (
            s.classList.contains("site-header--stuck") &&
            !theme.config.bpSmall
          ) {
            let M = parseFloat(
              window.getComputedStyle(s, null).getPropertyValue("padding-top"),
            );
            k += M * 2;
          }
          var A = document.querySelector("#" + e.stickyHeaderWrapper);
          A.style.height = k + "px";
        }
      }
      function C() {
        e.stickyEnabled &&
          (e.forceStopSticky ||
            (requestAnimationFrame(T), (e.lastScroll = window.scrollY)));
      }
      function T() {
        if (window.scrollY > 250) {
          if (e.stickyActive) return;
          ((e.stickyActive = !0),
            s.classList.add(e.stickyClass),
            e.wrapperOverlayed && t.classList.remove(e.overlayedClass),
            setTimeout(function () {
              s.classList.add(e.openTransitionClass);
            }, 100));
        } else {
          if (!e.stickyActive) return;
          ((e.stickyActive = !1),
            s.classList.remove(e.openTransitionClass),
            s.classList.remove(e.stickyClass),
            e.wrapperOverlayed && t.classList.add(e.overlayedClass));
        }
      }
      function P() {
        (document.querySelectorAll(o.searchBtn).forEach((k) => {
          k.addEventListener("click", function (A) {
            (A.preventDefault(),
              A.stopPropagation(),
              document.dispatchEvent(
                new CustomEvent("predictive-search:open", {
                  detail: { context: "header" },
                  bubbles: !0,
                }),
              ),
              document
                .querySelector(o.searchContainer)
                .classList.add("is-active"));
          });
        }),
          document.addEventListener("predictive-search:close-all", function () {
            q();
          }));
      }
      function q(k) {
        (document.activeElement.blur(),
          document.documentElement.classList.add("js-drawer-closing"),
          document.documentElement.classList.remove(
            "js-drawer-open",
            "js-drawer-open--search",
          ),
          window.setTimeout(
            function () {
              document.documentElement.classList.remove("js-drawer-closing");
            }.bind(this),
            500,
          ));
        var A = document.querySelector(o.searchContainer);
        theme.utils.prepareTransition(
          A,
          function () {
            A.classList.remove("is-active");
          }.bind(this),
        );
      }
      return { init: i, disableOverlayHeader: r };
    })()),
    (window.onpageshow = function (o) {
      o.persisted &&
        (document.body.classList.remove("unloading"),
        document.querySelectorAll(".cart__checkout").forEach((e) => {
          e.classList.remove("btn--loading");
        }));
    }),
    (theme.buildProductGridItem = function (o, e, t, s) {
      var i = "";
      return (
        o.forEach((n) => {
          var r = theme.buildProductImage(n, s);
          let a = "";
          theme.settings.predictiveSearchVendor &&
            (a = `<div class="grid-product__vendor">${n.vendor}</div>`);
          const l = theme.Currency.formatMoney(n.price_min, theme.moneyFormat),
            c = n.variants[0],
            I =
              n.available && c
                ? `
        <button
          type="button"
          data-add-to-cart
          data-variant-id="${c.id}"
          data-product-id="${n.id}"
          class="btn btn--full tw:!p-2"
        >
          <span data-add-to-cart-text>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 64 64">
              <path style="stroke-miterlimit:10" d="M14 17.44h46.79l-7.94 25.61H20.96l-9.65-35.1H3" stroke="white"/><circle cx="27" cy="53" r="2"/><circle cx="47" cy="53" r="2"/>
            </svg>
          </span>
        </button>
      `
                : "";
          var C = `
        <div class="grid__item grid-product ${e} aos-animate" data-aos="row-of-${t}">
          <div class="grid-product__content">
            <div class="grid__item-image-wrapper">
              <div class="grid-product__image-mask">
                ${r}
              </div>
              <div class="grid-product__meta">
                <a href="${n.url}" class="grid-product__link--accessibility">
                  <div class="grid-product__title">${n.title}</div>
                </a>
                ${a}
              </div>
            </div>
            <div class="grid-product__price tw:flex tw:items-end tw:justify-between tw:px-[8px] tw:md:px-[16px] tw:xl:px-[24px] tw:w-full">
              <div class="tw:flex tw:flex-col tw:gap-1">
                <div>${l}</div>
              </div>
              <div class="tw:flex tw:justify-end tw:self-end">
                ${I}
              </div>
            </div>
          </div>
        </div>
      `;
          i += C;
        }),
        i
      );
    }),
    (theme.buildProductImage = function (o, e) {
      var t = theme.settings.productImageSize,
        s = "";
      if (t === "natural") {
        const r = document
            .getElementById("naturalImageMarkup")
            .content.cloneNode(!0),
          a = r.querySelector("img"),
          l = r.querySelector(".image-wrap");
        ((l.style.paddingBottom = `${o.image_aspect_ratio}%`), i(a, e));
        const c = document.createElement("div");
        (c.appendChild(r), (s = c.innerHTML));
      } else {
        const r = document
            .getElementById("fixedRatioImageMarkup")
            .content.cloneNode(!0),
          a = r.querySelector("img");
        (r
          .querySelector(".grid__image-ratio")
          .classList.add(`grid__image-ratio--${t}`),
          theme.settings.productImageCover ||
            a.classList.add("grid__image-contain"),
          i(a, e));
        const c = document.createElement("div");
        (c.appendChild(r), (s = c.innerHTML));
      }
      function i(n, r) {
        ((n.src = o.image_responsive_url),
          (n.srcset = o.image_responsive_urls.toString()),
          (n.alt = o.title),
          (n.sizes = r));
      }
      return s;
    }));
  class S extends HTMLElement {
    constructor() {
      (super(),
        (this.cookieName = this.id),
        (this.cookie = Cookies.get(this.cookieName)),
        (this.classes = {
          activeContent: "age-verification-popup__content--active",
          inactiveContent: "age-verification-popup__content--inactive",
          inactiveDeclineContent:
            "age-verification-popup__decline-content--inactive",
          activeDeclineContent:
            "age-verification-popup__decline-content--active",
        }),
        (this.declineButton = this.querySelector(
          "[data-age-verification-popup-decline-button]",
        )),
        (this.declineContent = this.querySelector(
          "[data-age-verification-popup-decline-content]",
        )),
        (this.content = this.querySelector(
          "[data-age-verification-popup-content]",
        )),
        (this.returnButton = this.querySelector(
          "[data-age-verification-popup-return-button]",
        )),
        (this.exitButton = this.querySelector(
          "[data-age-verification-popup-exit-button]",
        )),
        (this.backgroundImage = this.querySelector("[data-background-image]")),
        (this.mobileBackgroundImage = this.querySelector(
          "[data-mobile-background-image]",
        )),
        Shopify.designMode &&
          (document.addEventListener("shopify:section:select", (e) => {
            e.detail.sectionId === this.dataset.sectionId && this.init();
          }),
          document.addEventListener("shopify:section:load", (e) => {
            if (e.detail.sectionId === this.dataset.sectionId) {
              if (
                (this.init(),
                this.dataset.testMode === "true" &&
                  this.cookie &&
                  Cookies.remove(this.cookieName),
                !sessionStorage.getItem(this.id))
              )
                return;
              this.showDeclineContent();
            }
          }),
          document.addEventListener("shopify:section:unload", (e) => {
            e.detail.sectionId === this.dataset.sectionId && this.modal.close();
          })),
        !(this.cookie && this.dataset.testMode === "false") && this.init());
    }
    init() {
      ((this.modal = new theme.Modals(this.id, "age-verification-popup-modal", {
        closeOffContentClick: !1,
      })),
        this.backgroundImage && (this.backgroundImage.style.display = "block"),
        theme.config.bpSmall &&
          this.mobileBackgroundImage &&
          (this.mobileBackgroundImage.style.display = "block"),
        this.modal.open(),
        theme.a11y.lockMobileScrolling(
          `#${this.id}`,
          document.querySelector("#MainContent"),
        ),
        this.declineButton &&
          this.declineButton.addEventListener("click", (e) => {
            (e.preventDefault(),
              this.showDeclineContent(),
              Shopify.designMode &&
                sessionStorage.setItem(this.id, "second-view"));
          }),
        this.returnButton &&
          this.returnButton.addEventListener("click", (e) => {
            (e.preventDefault(), this.hideDeclineContent());
            const t = sessionStorage.getItem(this.id);
            Shopify.designMode && t && sessionStorage.removeItem(this.id);
          }),
        this.exitButton &&
          this.exitButton.addEventListener("click", (e) => {
            (e.preventDefault(),
              this.dataset.testMode === "false" &&
                Cookies.set(this.cookieName, "entered", {
                  expires: 30,
                  sameSite: "none",
                  secure: !0,
                }),
              this.backgroundImage &&
                (this.backgroundImage.style.display = "none"),
              theme.config.bpSmall &&
                this.mobileBackgroundImage &&
                (this.mobileBackgroundImage.style.display = "none"),
              this.modal.close(),
              theme.a11y.unlockMobileScrolling(
                `#${this.id}`,
                document.querySelector("#MainContent"),
              ));
          }));
    }
    showDeclineContent() {
      (this.declineContent.classList.remove(
        this.classes.inactiveDeclineContent,
      ),
        this.declineContent.classList.add(this.classes.activeDeclineContent),
        this.content.classList.add(this.classes.inactiveContent),
        this.content.classList.remove(this.classes.activeContent));
    }
    hideDeclineContent() {
      (this.declineContent.classList.add(this.classes.inactiveDeclineContent),
        this.declineContent.classList.remove(this.classes.activeDeclineContent),
        this.content.classList.remove(this.classes.inactiveContent),
        this.content.classList.add(this.classes.activeContent));
    }
  }
  (customElements.define("age-verification-popup", S),
    (theme.Maps = (function () {
      var o = { zoom: 14 },
        e = null,
        t = [],
        s = {},
        i = {
          section: '[data-section-type="map"]',
          map: "[data-map]",
          mapOverlay: ".map-section__overlay",
        };
      ((window.gm_authFailure = function () {
        Shopify.designMode &&
          (document.querySelectorAll(i.section).forEach((l) => {
            l.classList.add("map-section--load-error");
          }),
          document.querySelectorAll(i.map).forEach((l) => {
            l.parentNode.removeChild(l);
          }),
          window.mapError(theme.strings.authError));
      }),
        (window.mapError = function (l) {
          var c = document.createElement("div");
          (c.classList.add("map-section__error", "errors", "text-center"),
            (c.innerHTML = l),
            document.querySelectorAll(i.mapOverlay).forEach((v) => {
              v.parentNode.prepend(c);
            }),
            document.querySelectorAll(".map-section__link").forEach((v) => {
              v.classList.add("hide");
            }));
        }));
      function n(l) {
        ((this.container = l),
          (this.sectionId = this.container.getAttribute("data-section-id")),
          (this.namespace = ".map-" + this.sectionId),
          (this.map = l.querySelector(i.map)),
          (this.key = this.map.dataset.apiKey),
          (s = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError,
          }),
          this.key &&
            theme.initWhenVisible({
              element: this.container,
              callback: this.prepMapApi.bind(this),
              threshold: 20,
            }));
      }
      function r() {
        t.forEach((l) => {
          l.createMap();
        });
      }
      function a(l) {
        var c = new google.maps.Geocoder();
        if (l) {
          var v = l.dataset.addressSetting,
            I = new Promise((C, T) => {
              c.geocode({ address: v }, function (P, q) {
                (q !== google.maps.GeocoderStatus.OK && T(q), C(P));
              });
            });
          return I;
        }
      }
      return (
        (n.prototype = Object.assign({}, n.prototype, {
          prepMapApi: function () {
            if (e === "loaded") this.createMap();
            else if (
              (t.push(this),
              e !== "loading" &&
                ((e = "loading"),
                typeof window.google > "u" || typeof window.google.maps > "u"))
            ) {
              var l = document.createElement("script");
              ((l.onload = function () {
                ((e = "loaded"), r());
              }),
                (l.src =
                  "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                document.head.appendChild(l));
            }
          },
          createMap: function () {
            var l = this.map;
            return a(l)
              .then(
                function (c) {
                  var v = {
                      zoom: o.zoom,
                      backgroundColor: "none",
                      center: c[0].geometry.location,
                      draggable: !1,
                      clickableIcons: !1,
                      scrollwheel: !1,
                      disableDoubleClickZoom: !0,
                      disableDefaultUI: !0,
                    },
                    I = (this.map = new google.maps.Map(l, v)),
                    C = (this.center = I.getCenter());
                  (new google.maps.Marker({ map: I, position: I.getCenter() }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      theme.utils.debounce(250, function () {
                        (google.maps.event.trigger(I, "resize"),
                          I.setCenter(C),
                          l.removeAttribute("style"));
                      }),
                    ),
                    Shopify.designMode && window.AOS && AOS.refreshHard());
                }.bind(this),
              )
              .catch(function (c) {
                var v;
                switch (c) {
                  case "ZERO_RESULTS":
                    v = s.addressNoResults;
                    break;
                  case "OVER_QUERY_LIMIT":
                    v = s.addressQueryLimit;
                    break;
                  case "REQUEST_DENIED":
                    v = s.authError;
                    break;
                  default:
                    v = s.addressError;
                    break;
                }
                Shopify.designMode && window.mapError(v);
              });
          },
          onUnload: function () {
            this.map.length !== 0 &&
              google &&
              google.maps &&
              google.maps.event &&
              google.maps.event.clearListeners(this.map, "resize");
          },
        })),
        n
      );
    })()),
    (theme.NewsletterPopup = (function () {
      function o(e) {
        this.container = e;
        var t = this.container.getAttribute("data-section-id");
        if (
          ((this.cookieName = "newsletter-" + t),
          (this.cookie = Cookies.get(this.cookieName)),
          !!e &&
            window.location.pathname !== "/challenge" &&
            window.location.pathname !== "/password")
        ) {
          ((this.data = {
            secondsBeforeShow: e.dataset.delaySeconds,
            daysBeforeReappear: e.dataset.delayDays,
            hasReminder: e.dataset.hasReminder,
            testMode: e.dataset.testMode,
          }),
            (this.modal = new theme.Modals(
              "NewsletterPopup-" + t,
              "newsletter-popup-modal",
            )));
          var s = e.querySelector(".popup-cta a");
          if (
            (s &&
              s.addEventListener(
                "click",
                function () {
                  this.closePopup(!0);
                }.bind(this),
              ),
            (e.querySelector(".errors") || e.querySelector(".note--success")) &&
              this.modal.open(),
            e.querySelector(".note--success"))
          ) {
            this.closePopup(!0);
            return;
          }
          (document.addEventListener(
            "modalClose." + e.id,
            this.closePopup.bind(this),
          ),
            this.cookie || this.initPopupDelay(),
            document.addEventListener("reminder:openNewsletter", () => {
              this.modal.open();
            }));
        }
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          initPopupDelay: function () {
            this.data.testMode !== "true" &&
              setTimeout(
                function () {
                  if (sessionStorage.getItem("newsletterAppeared") === "true") {
                    const t = new CustomEvent("newsletter:openReminder", {
                      bubbles: !0,
                    });
                    this.container.dispatchEvent(t);
                  } else
                    (this.modal.open(),
                      sessionStorage.setItem("newsletterAppeared", !0));
                }.bind(this),
                this.data.secondsBeforeShow * 1e3,
              );
          },
          closePopup: function (e) {
            if (this.data.testMode === "true") {
              Cookies.remove(this.cookieName, { path: "/" });
              return;
            }
            var t = e ? 200 : this.data.daysBeforeReappear,
              s = this.data.hasReminder === "true",
              i = sessionStorage.getItem("reminderAppeared") === "true";
            s && i
              ? Cookies.set(this.cookieName, "opened", {
                  path: "/",
                  expires: t,
                })
              : s ||
                Cookies.set(this.cookieName, "opened", {
                  path: "/",
                  expires: t,
                });
          },
          onLoad: function () {
            this.modal.open();
          },
          onSelect: function () {
            this.modal.open();
          },
          onDeselect: function () {
            this.modal.close();
          },
          onBlockSelect: function () {
            this.modal.close();
          },
          onBlockDeselect: function () {
            this.modal.open();
          },
          onUnload: function () {
            this.modal.close();
          },
        })),
        o
      );
    })()),
    (theme.PasswordHeader = (function () {
      function o() {
        this.init();
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          init: function () {
            if (document.querySelector("#LoginModal")) {
              var e = new theme.Modals("LoginModal", "login-modal", {
                focusIdOnOpen: "password",
                solid: !0,
              });
              document.querySelectorAll(".errors").length && e.open();
            }
          },
        })),
        o
      );
    })()),
    (theme.Photoswipe = (function () {
      var o = {
        trigger: ".js-photoswipe__zoom",
        images: ".photoswipe__image",
        slideshowTrack: ".flickity-viewport ",
        activeImage: ".is-selected",
      };
      function e(t, s) {
        ((this.container = t),
          (this.sectionId = s),
          (this.namespace = ".photoswipe-" + this.sectionId),
          this.gallery,
          this.images,
          this.items,
          (this.inSlideshow = !1),
          !(!t || t.dataset.zoom === "false") && this.init());
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            this.container.querySelectorAll(o.trigger).forEach((t) => {
              t.on("click" + this.namespace, this.triggerClick.bind(this));
            });
          },
          triggerClick: function (t) {
            (this.container.dataset &&
            this.container.dataset.hasSlideshow === "true"
              ? (this.inSlideshow = !0)
              : (this.inSlideshow = !1),
              (this.items = this.getImageData()));
            var s = this.inSlideshow
                ? this.container.querySelector(o.activeImage)
                : t.currentTarget,
              i = this.inSlideshow ? this.getChildIndex(s) : s.dataset.index;
            this.initGallery(this.items, i);
          },
          getChildIndex: function (t) {
            for (var s = 0; (t = t.previousSibling) != null; ) s++;
            return s + 1;
          },
          getImageData: function () {
            this.images = this.inSlideshow
              ? this.container.querySelectorAll(o.slideshowTrack + o.images)
              : this.container.querySelectorAll(o.images);
            var t = [];
            return (
              this.images.forEach((s) => {
                var i = {
                  msrc: s.currentSrc || s.src,
                  src: s.getAttribute("data-photoswipe-src"),
                  w: s.getAttribute("data-photoswipe-width"),
                  h: s.getAttribute("data-photoswipe-height"),
                  el: s,
                  initialZoomLevel: 0.5,
                };
                t.push(i);
              }),
              t
            );
          },
          initGallery: function (t, s) {
            var i = document.querySelectorAll(".pswp")[0],
              n = {
                allowPanToNext: !1,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                index: s - 1,
                pinchToClose: !1,
                preloaderEl: !1,
                scaleMode: "zoom",
                shareEl: !1,
                tapToToggleControls: !1,
                getThumbBoundsFn: function (r) {
                  var a =
                      window.pageYOffset || document.documentElement.scrollTop,
                    l = t[r].el,
                    c = l.getBoundingClientRect();
                  return { x: c.left, y: c.top + a, w: c.width };
                },
              };
            ((this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, t, n)),
              this.gallery.listen("afterChange", this.afterChange.bind(this)),
              this.gallery.init(),
              this.preventiOS15Scrolling());
          },
          afterChange: function () {
            var t = this.gallery.getCurrentIndex();
            this.container.dispatchEvent(
              new CustomEvent("photoswipe:afterChange", {
                detail: { index: t },
              }),
            );
          },
          syncHeight: function () {
            document.documentElement.style.setProperty(
              "--window-inner-height",
              `${window.innerHeight}px`,
            );
          },
          preventiOS15Scrolling: function () {
            let t;
            /iPhone|iPad|iPod/i.test(window.navigator.userAgent) &&
              (this.syncHeight(),
              (t = window.scrollY),
              document.documentElement.classList.add("pswp-open-in-ios"),
              window.addEventListener("resize", this.syncHeight),
              this.gallery.listen("destroy", () => {
                (document.documentElement.classList.remove("pswp-open-in-ios"),
                  window.scrollTo(0, t));
              }));
          },
        })),
        e
      );
    })()));
  class L extends HTMLElement {
    constructor() {
      (super(),
        (this.el = this),
        (this.url = this.dataset.url),
        (this.intent = this.dataset.intent),
        (this.placeholder = this.querySelector(
          ".product-recommendations-placeholder",
        )),
        (this.productResults = this.querySelector(".grid-product")),
        (this.sectionId = this.dataset.sectionId),
        (this.blockId = this.dataset.blockId),
        document.addEventListener("recommendations:loaded", (e) => {
          ((this.colorImages = this.el.querySelectorAll(
            ".grid-product__color-image",
          )),
            this.colorImages.length &&
              ((this.swatches = this.el.querySelectorAll(
                ".color-swatch--with-image",
              )),
              this.colorSwatchHovering()));
        }));
    }
    connectedCallback() {
      fetch(this.url)
        .then((e) => e.text())
        .then((e) => {
          const t = document.createElement("div");
          t.innerHTML = e;
          const s = t.querySelector(".product-recommendations");
          if (!s) {
            (this.el.classList.add("hide"), AOS && AOS.refreshHard());
            return;
          }
          ((this.placeholder.innerHTML = ""),
            (this.placeholder.innerHTML = s.innerHTML),
            theme.reinitProductGridItem(this.el),
            (this.slideshow = this.querySelector("[data-slideshow]")),
            this.slideshow && this.setupSlider(),
            document.dispatchEvent(
              new CustomEvent("recommendations:loaded", {
                detail: { section: this.el, intent: this.intent },
              }),
            ));
        })
        .catch((e) => {
          console.error(e);
        });
    }
    setupSlider() {
      const e = this.slideshow.dataset.controls,
        t = parseFloat(this.slideshow.dataset.perSlide),
        s = parseFloat(this.slideshow.dataset.count);
      let i = !1,
        n = !0;
      (e === "arrows" && ((n = !1), (i = !0)),
        t < s &&
          (this.flickity = new theme.Slideshow(this.slideshow, {
            prevNextButtons: i,
            pageDots: n,
            adaptiveHeight: !0,
            wrapAround: !1,
          })));
    }
    colorSwatchHovering() {
      this.swatches.forEach((e) => {
        (e.addEventListener(
          "mouseenter",
          function () {
            this.setActiveColorImage(e);
          }.bind(this),
        ),
          e.addEventListener(
            "touchstart",
            function (t) {
              (t.preventDefault(), this.setActiveColorImage(e));
            }.bind(this),
            { passive: !0 },
          ),
          e.addEventListener(
            "mouseleave",
            function () {
              this.removeActiveColorImage(e);
            }.bind(this),
          ));
      });
    }
    setActiveColorImage(e) {
      const t = e.dataset.variantId,
        s = e.dataset.variantImage;
      (this.colorImages.forEach((a) => {
        a.classList.remove("is-active");
      }),
        this.swatches.forEach((a) => {
          a.classList.remove("is-active");
        }));
      const i = this.el.querySelector(`.grid-product__color-image--${t}`);
      ((i.style.backgroundImage = "url(" + s + ")"),
        i.classList.add("is-active"),
        e.classList.add("is-active"));
      const n = e.dataset.url;
      e.closest(".grid-item__link").setAttribute("href", n);
    }
    removeActiveColorImage(e) {
      const t = e.dataset.variantId;
      this.el
        .querySelector(`.grid-product__color-image--${t}`)
        .classList.remove("is-active");
    }
  }
  (customElements.define("product-recommendations", L),
    (theme.SlideshowSection = (function () {
      function o(e) {
        this.container = e;
        var t = e.getAttribute("data-section-id");
        if (
          ((this.slideshow = e.querySelector("#Slideshow-" + t)),
          (this.namespace = "." + t),
          (this.initialIndex = 0),
          !!this.slideshow)
        ) {
          var s = e.parentElement,
            i = [].indexOf.call(s.parentElement.children, s);
          i === 0
            ? this.init()
            : theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
              });
        }
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          init: function () {
            var e = this.slideshow.querySelectorAll(".slideshow__slide");
            if (
              (this.slideshow.classList.remove("loading", "loading--delayed"),
              this.slideshow.classList.add("loaded"),
              e.length > 1)
            ) {
              var t = {
                prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                pageDots: this.slideshow.hasAttribute("data-dots"),
                fade: !0,
                setGallerySize: !1,
                initialIndex: this.initialIndex,
                autoPlay:
                  this.slideshow.dataset.autoplay === "true"
                    ? parseInt(this.slideshow.dataset.speed)
                    : !1,
              };
              this.flickity = new theme.Slideshow(this.slideshow, t);
            } else e[0].classList.add("is-selected");
          },
          forceReload: function () {
            (this.onUnload(), this.init());
          },
          onUnload: function () {
            this.flickity &&
              typeof this.flickity.destroy == "function" &&
              this.flickity.destroy();
          },
          onDeselect: function () {
            this.flickity &&
              typeof this.flickity.play == "function" &&
              this.flickity.play();
          },
          onBlockSelect: function (e) {
            var t = this.slideshow.querySelector(
                ".slideshow__slide--" + e.detail.blockId,
              ),
              s = parseInt(t.dataset.index);
            this.flickity && typeof this.flickity.pause == "function"
              ? (this.flickity.goToSlide(s), this.flickity.pause())
              : ((this.initialIndex = s),
                setTimeout(
                  function () {
                    this.flickity &&
                      typeof this.flickity.pause == "function" &&
                      this.flickity.pause();
                  }.bind(this),
                  1e3,
                ));
          },
          onBlockDeselect: function () {
            this.flickity &&
              typeof this.flickity.play == "function" &&
              this.flickity.args.autoPlay &&
              this.flickity.play();
          },
        })),
        o
      );
    })()),
    (theme.StoreAvailability = (function () {
      var o = {
        drawerOpenBtn: ".js-drawer-open-availability",
        modalOpenBtn: ".js-modal-open-availability",
        productTitle: "[data-availability-product-title]",
      };
      function e(t) {
        ((this.container = t),
          (this.baseUrl = t.dataset.baseUrl),
          (this.productTitle = t.dataset.productName));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          updateContent: function (t) {
            var s =
                this.baseUrl +
                "/variants/" +
                t +
                "/?section_id=store-availability",
              i = this;
            fetch(s)
              .then(function (n) {
                return n.text();
              })
              .then(function (n) {
                if (n.trim() === "") {
                  this.container.innerHTML = "";
                  return;
                }
                ((i.container.innerHTML = n),
                  (i.container.innerHTML =
                    i.container.firstElementChild.innerHTML),
                  i.container.querySelector(o.drawerOpenBtn) &&
                    (i.drawer = new theme.Drawers(
                      "StoreAvailabilityDrawer",
                      "availability",
                    )),
                  i.container.querySelector(o.modalOpenBtn) &&
                    (i.modal = new theme.Modals(
                      "StoreAvailabilityModal",
                      "availability",
                    )));
                var r = i.container.querySelector(o.productTitle);
                r && (r.textContent = i.productTitle);
              });
          },
        })),
        e
      );
    })()),
    (theme.VideoSection = (function () {
      var o = { videoParent: ".video-parent-section" };
      function e(t) {
        ((this.container = t),
          (this.sectionId = t.getAttribute("data-section-id")),
          (this.namespace = ".video-" + this.sectionId),
          this.videoObject,
          theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this),
            threshold: 500,
          }));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            var t = this.container.querySelector(".video-div");
            if (t) {
              var s = t.dataset.type;
              switch (s) {
                case "youtube":
                  var i = t.dataset.videoId;
                  this.initYoutubeVideo(i);
                  break;
                case "vimeo":
                  var i = t.dataset.videoId;
                  this.initVimeoVideo(i);
                  break;
                case "mp4":
                  this.initMp4Video();
                  break;
              }
            }
          },
          initYoutubeVideo: function (t) {
            this.videoObject = new theme.YouTube(
              "YouTubeVideo-" + this.sectionId,
              { videoId: t, videoParent: o.videoParent },
            );
          },
          initVimeoVideo: function (t) {
            this.videoObject = new theme.VimeoPlayer(
              "Vimeo-" + this.sectionId,
              t,
              { videoParent: o.videoParent },
            );
          },
          initMp4Video: function () {
            var t = "Mp4Video-" + this.sectionId,
              s = document.getElementById(t),
              i = s.closest(o.videoParent);
            if (s) {
              i.classList.add("loaded");
              var n = document.querySelector("#" + t).play();
              n !== void 0 &&
                n
                  .then(function () {})
                  .catch(function () {
                    (s.setAttribute("controls", ""),
                      i.classList.add("video-interactable"));
                  });
            }
          },
          onUnload: function (t) {
            (t.target.id.replace("shopify-section-", ""),
              this.videoObject &&
                typeof this.videoObject.destroy == "function" &&
                this.videoObject.destroy());
          },
        })),
        e
      );
    })()));
  class E extends HTMLElement {
    constructor() {
      (super(),
        (this.el = this),
        (this.display = this.querySelector("[data-time-display]")),
        (this.block = this.closest(".countdown__block--timer")),
        (this.year = this.el.dataset.year),
        (this.month = this.el.dataset.month),
        (this.day = this.el.dataset.day),
        (this.hour = this.el.dataset.hour),
        (this.minute = this.el.dataset.minute),
        (this.daysPlaceholder = this.querySelector("[date-days-placeholder]")),
        (this.hoursPlaceholder = this.querySelector(
          "[date-hours-placeholder]",
        )),
        (this.minutesPlaceholder = this.querySelector(
          "[date-minutes-placeholder]",
        )),
        (this.secondsPlaceholder = this.querySelector(
          "[date-seconds-placeholder]",
        )),
        (this.messagePlaceholder = this.querySelector(
          "[data-message-placeholder]",
        )),
        (this.hideTimerOnComplete = this.el.dataset.hideTimer),
        (this.completeMessage = this.el.dataset.completeMessage),
        (this.timerComplete = !1),
        this.init());
    }
    init() {
      setInterval(() => {
        this.timerComplete || this._calculate();
      }, 1e3);
    }
    _calculate() {
      const e =
        +new Date(
          `${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`,
        ).getTime() - +new Date().getTime();
      if (e > 0) {
        const t = {
          days: Math.floor(e / 864e5),
          hours: Math.floor((e / 36e5) % 24),
          minutes: Math.floor((e / 1e3 / 60) % 60),
          seconds: Math.floor((e / 1e3) % 60),
        };
        ((this.daysPlaceholder.innerHTML = t.days),
          (this.hoursPlaceholder.innerHTML = t.hours),
          (this.minutesPlaceholder.innerHTML = t.minutes),
          (this.secondsPlaceholder.innerHTML = t.seconds),
          setTimeout(() => {
            this.display.classList.add("countdown__display--loaded");
          }, 1));
      } else
        (this.completeMessage &&
          this.messagePlaceholder &&
          this.messagePlaceholder.classList.add(
            "countdown__timer-message--visible",
          ),
          this.hideTimerOnComplete === "true" &&
            (this.display.classList.remove("countdown__display--visible"),
            this.display.classList.add("countdown__display--hidden")),
          !this.completeMessage &&
            this.hideTimerOnComplete === "true" &&
            this.block.classList.add("countdown__block--hidden"),
          (this.timerComplete = !0));
    }
  }
  customElements.define("countdown-timer", E);
  class b extends HTMLElement {
    constructor() {
      (super(),
        (this.el = this),
        (this.buttons = this.querySelectorAll("[data-button]")),
        (this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]")),
        (this.blockContainer = this.querySelector("[data-block-container]")),
        (this.colorImages = this.querySelectorAll(
          ".grid-product__color-image",
        )),
        (this.colorSwatches = this.querySelectorAll(
          ".color-swatch--with-image",
        )),
        this._bindEvents(),
        this._setupQuickShop(),
        this.colorImages.length && this._colorSwatchHovering());
    }
    _colorSwatchHovering() {
      this.colorSwatches.forEach((e) => {
        (e.addEventListener(
          "mouseenter",
          function () {
            this._setActiveColorImage(e);
          }.bind(this),
        ),
          e.addEventListener(
            "touchstart",
            function (t) {
              (t.preventDefault(), this._setActiveColorImage(e));
            }.bind(this),
            { passive: !0 },
          ),
          e.addEventListener(
            "mouseleave",
            function () {
              this._removeActiveColorImage(e);
            }.bind(this),
          ));
      });
    }
    _setActiveColorImage(e) {
      var t = e.dataset.variantId,
        s = e.dataset.variantImage;
      (this.colorImages.forEach((a) => {
        a.classList.remove("is-active");
      }),
        this.colorSwatches.forEach((a) => {
          a.classList.remove("is-active");
        }));
      var i = this.el.querySelector(".grid-product__color-image--" + t);
      ((i.style.backgroundImage = "url(" + s + ")"),
        i.classList.add("is-active"),
        e.classList.add("is-active"));
      var n = e.dataset.url,
        r = e.closest(".grid-item__link");
      r && r.setAttribute("href", n);
    }
    _removeActiveColorImage(e) {
      const t = e.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${t}`).classList.remove(
        "is-active",
      );
    }
    _bindEvents() {
      (this.buttons.forEach((e) => {
        const t = e.dataset.button;
        e.on("click", (s) => {
          (s.preventDefault(), s.stopPropagation(), this._showContent(t));
        });
      }),
        document.addEventListener("shopify:block:select", (e) => {
          const t = e.detail.blockId;
          this._showContent(`${t}`);
        }));
    }
    _showContent(e) {
      this.hotspotBlocks.forEach((t) => {
        t.dataset.hotspotBlock === e
          ? t.classList.add("is-active")
          : t.classList.remove("is-active");
      });
    }
    _setupQuickShop() {
      this.querySelectorAll('[data-block-type="product"]').length > 0 &&
        (typeof theme.QuickShop == "function"
          ? new theme.QuickShop(this.blockContainer)
          : typeof theme.initQuickShop == "function" && theme.initQuickShop(),
        typeof theme.QuickAdd == "function" &&
          new theme.QuickAdd(this.blockContainer));
    }
  }
  customElements.define("hot-spots", b);
  class y extends HTMLElement {
    constructor() {
      (super(),
        (this.el = this),
        (this.sectionId = this.dataset.sectionId),
        (this.button = this.querySelector("[data-button]")),
        (this.draggableContainer = this.querySelector("[data-draggable]")),
        (this.primaryImage = this.querySelector("[data-primary-image]")),
        (this.secondaryImage = this.querySelector("[data-secondary-image]")),
        this.calculateSizes(),
        (this.active = !1),
        (this.currentX = 0),
        (this.initialX = 0),
        (this.xOffset = 0),
        (this.buttonOffset = this.button.offsetWidth / 2),
        this.el.addEventListener("touchstart", this.dragStart, !1),
        this.el.addEventListener("touchend", this.dragEnd, !1),
        this.el.addEventListener("touchmove", this.drag, !1),
        this.el.addEventListener("mousedown", this.dragStart, !1),
        this.el.addEventListener("mouseup", this.dragEnd, !1),
        this.el.addEventListener("mousemove", this.drag, !1),
        window.on(
          "resize",
          theme.utils.debounce(250, () => {
            this.calculateSizes(!0);
          }),
        ),
        document.addEventListener("shopify:section:load", (e) => {
          e.detail.sectionId === this.sectionId &&
            this.primaryImage !== null &&
            this.calculateSizes();
        }));
    }
    calculateSizes(e = !1) {
      ((this.active = !1),
        (this.currentX = 0),
        (this.initialX = 0),
        (this.xOffset = 0),
        (this.buttonOffset = this.button.offsetWidth / 2),
        (this.elWidth = this.el.offsetWidth),
        (this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`),
        this.primaryImage &&
          (this.primaryImage.style.width = `${this.elWidth}px`),
        e && (this.draggableContainer.style.width = `${this.elWidth / 2}px`));
    }
    dragStart(e) {
      (e.type === "touchstart"
        ? (this.initialX = e.touches[0].clientX - this.xOffset)
        : (this.initialX = e.clientX - this.xOffset),
        e.target === this.button && (this.active = !0));
    }
    dragEnd(e) {
      ((this.initialX = this.currentX), (this.active = !1));
    }
    drag(e) {
      this.active &&
        (e.preventDefault(),
        e.type === "touchmove"
          ? (this.currentX = e.touches[0].clientX - this.initialX)
          : (this.currentX = e.clientX - this.initialX),
        (this.xOffset = this.currentX),
        this.setTranslate(this.currentX, this.button));
    }
    setTranslate(e, t) {
      let s = e - this.buttonOffset,
        i = this.elWidth / 2 + e;
      const n = 50,
        r = (this.elWidth / 2 + this.buttonOffset) * -1,
        a = this.elWidth / 2 - this.buttonOffset;
      (s < r + n
        ? ((s = r + n), (i = n))
        : s > a - n && ((s = a - n), (i = this.elWidth - n)),
        (t.style.transform = `translate(${s}px, -50%)`),
        (this.draggableContainer.style.width = `${i}px`));
    }
  }
  (customElements.define("image-compare", y),
    (theme.Blog = (function () {
      function o(e) {
        this.tagFilters();
      }
      return (
        (o.prototype = Object.assign({}, o.prototype, {
          tagFilters: function () {
            var e = document.getElementById("BlogTagFilter");
            e &&
              e.addEventListener("change", function () {
                location.href = e.value;
              });
          },
        })),
        o
      );
    })()),
    (theme.CollectionHeader = (function () {
      var o = !1;
      function e(t) {
        this.namespace = ".collection-header";
        var s = t.querySelector(".collection-hero");
        (s
          ? (o && this.checkIfNeedReload(),
            s.classList.remove("loading", "loading--delayed"),
            s.classList.add("loaded"))
          : theme.settings.overlayHeader &&
            theme.headerNav.disableOverlayHeader(),
          (o = !0));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          checkIfNeedReload: function () {
            if (Shopify.designMode && theme.settings.overlayHeader) {
              var t = document.querySelector(".header-wrapper");
              t.classList.contains("header-wrapper--overlay") ||
                location.reload();
            }
          },
        })),
        e
      );
    })()),
    (theme.CollectionSidebar = (function () {
      var o = !1,
        e = { sidebar: "#CollectionSidebar" };
      function t(s) {
        this.container = s.querySelector(e.sidebar);
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          init: function () {
            this.container &&
              (this.onUnload(),
              (o = this.container.dataset.style === "drawer"),
              (theme.FilterDrawer = new theme.Drawers(
                "FilterDrawer",
                "collection-filters",
                !0,
              )));
          },
          forceReload: function () {
            this.init();
          },
          onSelect: function () {
            if (theme.FilterDrawer) {
              if (!o) {
                theme.FilterDrawer.close();
                return;
              }
              (o || theme.config.bpSmall) && theme.FilterDrawer.open();
            }
          },
          onDeselect: function () {
            theme.FilterDrawer && theme.FilterDrawer.close();
          },
          onUnload: function () {
            theme.FilterDrawer && theme.FilterDrawer.close();
          },
        })),
        t
      );
    })()),
    (theme.Collection = (function () {
      var o = !1,
        e = {
          sortSelect: "#SortBy",
          colorSwatchImage: ".grid-product__color-image",
          colorSwatch: ".color-swatch--with-image",
          collectionGrid: ".collection-grid__wrapper",
          trigger: ".collapsible-trigger",
          sidebar: "#CollectionSidebar",
          activeTagList: ".tag-list--active-tags",
          tags: ".tag-list input",
          activeTags: ".tag-list a",
          tagsForm: ".filter-form",
          filters: ".collection-filter",
          priceRange: ".price-range",
        },
        t = {
          activeTag: "tag--active",
          removeTagParent: "tag--remove",
          filterSidebar: "collapsible-content--sidebar",
          isOpen: "is-open",
        };
      function s(i) {
        ((this.container = i),
          (this.sectionId = i.getAttribute("data-section-id")),
          (this.namespace = ".collection-" + this.sectionId),
          (this.sidebar = new theme.CollectionSidebar(i)),
          (this.context = i.getAttribute("data-context")),
          (this.ajaxRenderer = new theme.AjaxRenderer({
            sections: [
              { sectionId: this.sectionId, nodeId: "CollectionAjaxContent" },
            ],
            onReplace: this.onReplaceAjaxContent.bind(this),
          })),
          this.init());
      }
      return (
        (s.prototype = Object.assign({}, s.prototype, {
          init: function () {
            this.context && this.context === "featured-collection"
              ? this.colorSwatchHovering()
              : (this.initSort(),
                this.colorSwatchHovering(),
                this.initFilters(),
                this.initPriceRange(),
                this.sidebar.init());
          },
          initSort: function () {
            ((this.sortSelect = document.querySelector(e.sortSelect)),
              this.sortSelect &&
                ((this.defaultSort = this.getDefaultSortValue()),
                this.sortSelect.on(
                  "change" + this.namespace,
                  this.onSortChange.bind(this),
                )));
          },
          getSortValue: function () {
            return this.sortSelect.value || this.defaultSort;
          },
          getDefaultSortValue: function () {
            return this.sortSelect.getAttribute("data-default-sortby");
          },
          onSortChange: function () {
            ((this.queryParams = new URLSearchParams(window.location.search)),
              this.queryParams.set("sort_by", this.getSortValue()),
              this.queryParams.delete("page"),
              (window.location.search = this.queryParams.toString()));
          },
          colorSwatchHovering: function () {
            var i = this.container.querySelectorAll(e.colorSwatchImage);
            i.length &&
              this.container.querySelectorAll(e.colorSwatch).forEach((n) => {
                (n.addEventListener("mouseenter", () => {
                  var r = n.dataset.variantId,
                    a = n.dataset.variantImage,
                    l = this.container.querySelector(
                      ".grid-product__color-image--" + r,
                    );
                  ((l.style.backgroundImage = "url(" + a + ")"),
                    l.classList.add("is-active"));
                }),
                  n.addEventListener("mouseleave", () => {
                    var r = n.dataset.variantId;
                    this.container
                      .querySelector(".grid-product__color-image--" + r)
                      .classList.remove("is-active");
                  }));
              });
          },
          initFilters: function () {
            var i = document.querySelectorAll(e.tags);
            i.length &&
              (this.bindBackButton(),
              theme.config.stickyHeader &&
                (this.setFilterStickyPosition(),
                window.on(
                  "resize",
                  theme.utils.debounce(500, this.setFilterStickyPosition),
                )),
              document.querySelectorAll(e.activeTags).forEach((n) => {
                n.addEventListener("click", this.tagClick.bind(this));
              }),
              document.querySelectorAll(e.tagsForm).forEach((n) => {
                n.addEventListener("input", this.onFormSubmit.bind(this));
              }));
          },
          initPriceRange: function () {
            document
              .querySelectorAll(e.priceRange)
              .forEach(
                (n) =>
                  new theme.PriceRange(n, {
                    onChange: this.renderFromFormData.bind(this),
                  }),
              );
          },
          tagClick: function (i) {
            var n = i.currentTarget;
            if (
              (theme.FilterDrawer && theme.FilterDrawer.close(),
              n.classList.contains("no-ajax") || (i.preventDefault(), o))
            )
              return;
            o = !0;
            const r = n.parentNode,
              a = new URL(n.href);
            (this.renderActiveTag(r, n),
              this.updateScroll(!0),
              this.startLoading(),
              this.renderCollectionPage(a.searchParams));
          },
          onFormSubmit: function (i) {
            var n = i.target;
            if (
              (theme.FilterDrawer && theme.FilterDrawer.close(),
              n.classList.contains("no-ajax") || (i.preventDefault(), o))
            )
              return;
            o = !0;
            const r = n.closest("li"),
              a = n.closest("form"),
              l = new FormData(a);
            (this.renderActiveTag(r, n),
              this.updateScroll(!0),
              this.startLoading(),
              this.renderFromFormData(l));
          },
          fetchOpenCollasibleFilters: function () {
            return Array.from(
              document.querySelectorAll(
                `${e.sidebar} ${e.trigger}.${t.isOpen}`,
              ),
            ).map((i) => i.dataset.collapsibleId);
          },
          renderActiveTag: function (i, n) {
            const r = i.querySelector(".tag__text");
            i.classList.contains(t.activeTag)
              ? i.classList.remove(t.activeTag)
              : (i.classList.add(t.activeTag),
                n.closest("li").classList.contains(t.removeTagParent)
                  ? i.remove()
                  : document.querySelectorAll(e.activeTagList).forEach((a) => {
                      const l = document.createElement("li"),
                        c = document.createElement("a");
                      (l.classList.add("tag", "tag--remove"),
                        c.classList.add("btn", "btn--small"),
                        (c.innerText = r.innerText),
                        l.appendChild(c),
                        a.appendChild(l));
                    }));
          },
          renderFromFormData: function (i) {
            const n = new URLSearchParams(i);
            this.renderCollectionPage(n);
          },
          onReplaceAjaxContent: function (i, n) {
            this.fetchOpenCollasibleFilters().forEach((l) => {
              i.querySelectorAll(`[data-collapsible-id=${l}]`).forEach(
                this.openCollapsible,
              );
            });
            var a = i.getElementById(n.nodeId);
            a && (document.getElementById(n.nodeId).innerHTML = a.innerHTML);
          },
          openCollapsible: function (i) {
            (i.classList.contains(t.filterSidebar) && (i.style.height = "auto"),
              i.classList.add(t.isOpen));
          },
          renderCollectionPage: function (i, n = !0) {
            this.ajaxRenderer
              .renderPage(window.location.pathname, i, n)
              .then(() => {
                (theme.sections.reinit("collection-grid"),
                  this.updateScroll(!1),
                  this.initPriceRange(),
                  theme.reinitProductGridItem(),
                  document.dispatchEvent(
                    new CustomEvent("collection:reloaded"),
                  ),
                  (o = !1));
              });
          },
          bindBackButton: function () {
            (window.off("popstate" + this.namespace),
              window.on(
                "popstate" + this.namespace,
                function (i) {
                  if (i) {
                    const n = new URL(window.location.href);
                    this.renderCollectionPage(n.searchParams, !1);
                  }
                }.bind(this),
              ));
          },
          updateScroll: function (i) {
            var n = document.querySelector("[data-scroll-to]"),
              r = n && n.offsetTop;
            if (
              (theme.config.bpSmall || (r -= 15), theme.config.stickyHeader)
            ) {
              var a = document.querySelector(".site-header").offsetHeight;
              r = r - a;
            }
            i
              ? window.scrollTo({ top: r, behavior: "smooth" })
              : window.scrollTo({ top: r });
          },
          setFilterStickyPosition: function () {
            var i = document.querySelector(".site-header").offsetHeight;
            document.querySelector(e.filters).style.top = i + 10 + "px";
            var n = document.querySelector(".grid__item--sidebar");
            n && (n.style.top = i + 10 + "px");
          },
          forceReload: function () {
            this.init();
          },
          startLoading: function () {
            document.querySelector(e.collectionGrid).classList.add("unload");
          },
        })),
        s
      );
    })()),
    (theme.FooterSection = (function () {
      var o = {
        locale: "[data-disclosure-locale]",
        currency: "[data-disclosure-currency]",
      };
      function e(t) {
        ((this.container = t),
          (this.localeDisclosure = null),
          (this.currencyDisclosure = null),
          this.init());
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            var t = this.container.querySelector(o.locale),
              s = this.container.querySelector(o.currency);
            (t && (this.localeDisclosure = new theme.Disclosure(t)),
              s && (this.currencyDisclosure = new theme.Disclosure(s)));
            var i = document.querySelector(".footer__newsletter-input");
            (i &&
              i.addEventListener("keyup", function () {
                i.classList.add("footer__newsletter-input--active");
              }),
              theme.collapsibles.init(this.container));
          },
          onUnload: function () {
            (this.localeDisclosure && this.localeDisclosure.destroy(),
              this.currencyDisclosure && this.currencyDisclosure.destroy());
          },
        })),
        e
      );
    })()),
    (theme.HeaderSection = (function () {
      var o = {
        locale: "[data-disclosure-locale]",
        currency: "[data-disclosure-currency]",
      };
      function e(t) {
        ((this.container = t),
          (this.sectionId = this.container.getAttribute("data-section-id")),
          this.init());
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            (Shopify &&
              Shopify.designMode &&
              (theme.sections.reinit("slideshow-section"),
              setTimeout(function () {
                window.dispatchEvent(new Event("resize"));
              }, 500)),
              this.initDrawers(),
              this.initDisclosures(),
              theme.headerNav.init(),
              theme.announcementBar.init(),
              this.hoverMenu());
          },
          hoverMenu: function () {
            const t = document.querySelectorAll(
              '[data-section-type="header"] details[data-hover="true"]',
            );
            t.forEach((s) => {
              const i = s.querySelector("summary"),
                n = i.dataset.link;
              (i.addEventListener("click", (r) => {
                (r.preventDefault(), (window.location.href = n));
              }),
                s.addEventListener("focusin", () => {
                  s.hasAttribute("open") ||
                    (t.forEach((r) => {
                      (r.removeAttribute("open"),
                        r.setAttribute("aria-expanded", "false"));
                    }),
                    s.setAttribute("open", ""),
                    s.setAttribute("aria-expanded", "true"));
                }),
                s.addEventListener("focusout", () => {
                  s.hasAttribute("open") &&
                    !s.matches(":focus-within") &&
                    (s.removeAttribute("open"),
                    s.setAttribute("aria-expanded", "false"));
                }),
                s.addEventListener("mouseover", () => {
                  s.hasAttribute("open") ||
                    (s.setAttribute("open", ""),
                    s.setAttribute("aria-expanded", "true"));
                }),
                s.addEventListener("mouseleave", () => {
                  s.hasAttribute("open") &&
                    (s.removeAttribute("open"),
                    s.setAttribute("aria-expanded", "false"));
                }));
            });
          },
          initDisclosures: function () {
            var t = this.container.querySelector(o.locale),
              s = this.container.querySelector(o.currency);
            (t && (this.localeDisclosure = new theme.Disclosure(t)),
              s && (this.currencyDisclosure = new theme.Disclosure(s)));
          },
          initDrawers: function () {
            ((theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
              theme.settings.cartType === "drawer" &&
                (document.body.classList.contains("template-cart") ||
                  new theme.CartDrawer()),
              theme.collapsibles.init(document.getElementById("NavDrawer")));
          },
          onUnload: function () {
            (theme.NavDrawer.close(),
              theme.announcementBar.unload(),
              this.localeDisclosure && this.localeDisclosure.destroy(),
              this.currencyDisclosure && this.currencyDisclosure.destroy());
          },
        })),
        e
      );
    })()),
    (theme.Product = (function () {
      var o = {},
        e = {
          onSale: "on-sale",
          disabled: "disabled",
          isModal: "is-modal",
          hidden: "hide",
          lowInventory: "inventory--low",
        },
        t = {
          productVideo: ".product__video",
          videoParent: ".product__video-wrapper",
          slide: ".product-main-slide",
          currentSlide: ".is-selected",
          startingSlide: ".starting-slide",
          variantType: ".variant-wrapper",
          blocks: "[data-product-blocks]",
          blocksHolder: "[data-blocks-holder]",
          dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
        };
      function s(i) {
        this.container = i;
        var n = (this.sectionId = i.getAttribute("data-section-id")),
          r = (this.productId = i.getAttribute("data-product-id"));
        ((this.inModal = i.dataset.modal === "true"),
          this.modal,
          (this.settings = {
            enableHistoryState: i.dataset.history || !1,
            namespace: ".product-" + n,
            inventory: !1,
            inventoryThreshold: 10,
            modalInit: !1,
            hasImages: !0,
            imageSetName: null,
            imageSetIndex: null,
            currentImageSet: null,
            imageSize: "620x",
            currentSlideIndex: 0,
            videoLooping: i.dataset.videoLooping,
          }),
          this.inModal &&
            ((this.settings.enableHistoryState = !1),
            (this.settings.namespace = ".product-" + n + "-modal"),
            (this.modal = document.getElementById("QuickShopModal-" + r))),
          (this.selectors = {
            variantsJson: "[data-variant-json]",
            currentVariantJson: "[data-current-variant-json]",
            form: ".product-single__form",
            media: "[data-product-media-type-model]",
            closeMedia: ".product-single__close-media",
            photoThumbs: "[data-product-thumb]",
            thumbSlider: "[data-product-thumbs]",
            thumbScroller: ".product__thumbs--scroller",
            mainSlider: "[data-product-photos]",
            imageContainer: "[data-product-images]",
            productImageMain: "[data-product-image-main]",
            priceWrapper: "[data-product-price-wrap]",
            price: "[data-product-price]",
            comparePrice: "[data-compare-price]",
            savePrice: "[data-save-price]",
            priceA11y: "[data-a11y-price]",
            comparePriceA11y: "[data-compare-price-a11y]",
            unitWrapper: "[data-unit-price-wrapper]",
            unitPrice: "[data-unit-price]",
            unitPriceBaseUnit: "[data-unit-base]",
            sku: "[data-sku]",
            inventory: "[data-product-inventory]",
            incomingInventory: "[data-incoming-inventory]",
            colorLabel: "[data-variant-color-label]",
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            originalSelectorId: "[data-product-select]",
            singleOptionSelector: "[data-variant-input]",
            variantColorSwatch: ".variant__input--color-swatch",
            dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
            availabilityContainer: "[data-store-availability-holder]",
          }),
          this.cacheElements(),
          (this.firstProductImage = this.cache.mainSlider.querySelector("img")),
          this.firstProductImage || (this.settings.hasImages = !1));
        var a = this.cache.mainSlider.querySelector("[data-set-name]");
        (a && (this.settings.imageSetName = a.dataset.setName), this.init());
      }
      return (
        (s.prototype = Object.assign({}, s.prototype, {
          init: function () {
            (this.inModal &&
              (this.container.classList.add(e.isModal),
              document.addEventListener(
                "modalOpen.QuickShopModal-" + this.productId,
                this.openModalProduct.bind(this),
              ),
              document.addEventListener(
                "modalClose.QuickShopModal-" + this.productId,
                this.closeModalProduct.bind(this),
              )),
              this.inModal ||
                (this.formSetup(),
                this.productSetup(),
                this.videoSetup(),
                this.initProductSlider(),
                this.customMediaListners(),
                this.addIdToRecentlyViewed()));
          },
          cacheElements: function () {
            this.cache = {
              form: this.container.querySelector(this.selectors.form),
              mainSlider: this.container.querySelector(
                this.selectors.mainSlider,
              ),
              thumbSlider: this.container.querySelector(
                this.selectors.thumbSlider,
              ),
              thumbScroller: this.container.querySelector(
                this.selectors.thumbScroller,
              ),
              productImageMain: this.container.querySelector(
                this.selectors.productImageMain,
              ),
              priceWrapper: this.container.querySelector(
                this.selectors.priceWrapper,
              ),
              comparePriceA11y: this.container.querySelector(
                this.selectors.comparePriceA11y,
              ),
              comparePrice: this.container.querySelector(
                this.selectors.comparePrice,
              ),
              price: this.container.querySelector(this.selectors.price),
              savePrice: this.container.querySelector(this.selectors.savePrice),
              priceA11y: this.container.querySelector(this.selectors.priceA11y),
            };
          },
          formSetup: function () {
            (this.initQtySelector(),
              this.initAjaxProductForm(),
              this.availabilitySetup(),
              this.initVariants(),
              this.settings.imageSetName && this.updateImageSet());
          },
          availabilitySetup: function () {
            var i = this.container.querySelector(
              this.selectors.availabilityContainer,
            );
            i && (this.storeAvailability = new theme.StoreAvailability(i));
          },
          productSetup: function () {
            (this.setImageSizes(),
              this.initImageZoom(),
              this.initModelViewerLibraries(),
              this.initShopifyXrLaunch());
          },
          setImageSizes: function () {
            if (this.settings.hasImages) {
              var i = this.firstProductImage.currentSrc;
              i && (this.settings.imageSize = theme.Images.imageSize(i));
            }
          },
          addIdToRecentlyViewed: function () {
            var i = this.container.getAttribute("data-product-handle"),
              n = this.container.getAttribute("data-product-url"),
              r = this.container.getAttribute("data-aspect-ratio"),
              a = this.container.getAttribute("data-img-url");
            (theme.recentlyViewed.recent.hasOwnProperty(i) &&
              delete theme.recentlyViewed.recent[i],
              (theme.recentlyViewed.recent[i] = {
                url: n,
                aspectRatio: r,
                featuredImage: a,
              }),
              theme.config.hasLocalStorage &&
                window.localStorage.setItem(
                  "theme-recent",
                  JSON.stringify(theme.recentlyViewed.recent),
                ));
          },
          initVariants: function () {
            var i = this.container.querySelector(this.selectors.variantsJson);
            if (i) {
              this.variantsObject = JSON.parse(i.innerHTML);
              var n = !!this.container.querySelector(t.dynamicVariantsEnabled),
                r = {
                  container: this.container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: this.selectors.singleOptionSelector,
                  originalSelectorId: this.selectors.originalSelectorId,
                  variants: this.variantsObject,
                  dynamicVariantsEnabled: n,
                },
                a = this.container.querySelectorAll(
                  this.selectors.variantColorSwatch,
                );
              if (
                (a.length &&
                  a.forEach((T) => {
                    T.addEventListener(
                      "updateSwatch",
                      function (P) {
                        var q = T.dataset.colorName,
                          k = T.dataset.colorIndex;
                        this.updateColorName(q, k);
                      }.bind(this),
                    );
                  }),
                (this.variants = new theme.Variants(r)),
                this.storeAvailability)
              ) {
                var l = this.variants.currentVariant
                  ? this.variants.currentVariant.id
                  : this.variants.variants[0].id;
                (this.storeAvailability.updateContent(l),
                  this.container.on(
                    "variantChange" + this.settings.namespace,
                    this.updateAvailability.bind(this),
                  ));
              }
              (this.container.on(
                "variantChange" + this.settings.namespace,
                this.updateCartButton.bind(this),
              ),
                this.container.on(
                  "variantImageChange" + this.settings.namespace,
                  this.updateVariantImage.bind(this),
                ),
                this.container.on(
                  "variantPriceChange" + this.settings.namespace,
                  this.updatePrice.bind(this),
                ),
                this.container.on(
                  "variantUnitPriceChange" + this.settings.namespace,
                  this.updateUnitPrice.bind(this),
                ),
                this.container.querySelector(this.selectors.sku) &&
                  this.container.on(
                    "variantSKUChange" + this.settings.namespace,
                    this.updateSku.bind(this),
                  ));
              var c = this.container.querySelector(this.selectors.inventory);
              if (
                (c &&
                  ((this.settings.inventory = !0),
                  (this.settings.inventoryThreshold = c.dataset.threshold),
                  this.updateInventory({
                    detail: { variant: this.variants.currentVariant },
                  }),
                  this.container.on(
                    "variantChange" + this.settings.namespace,
                    this.updateInventory.bind(this),
                  )),
                n)
              ) {
                var v = this.container.querySelector(
                  this.selectors.currentVariantJson,
                );
                if (v) {
                  var I = this.container.querySelector(t.variantType);
                  I &&
                    new theme.VariantAvailability({
                      container: this.container,
                      namespace: this.settings.namespace,
                      type: I.dataset.type,
                      variantsObject: this.variantsObject,
                      currentVariantObject: JSON.parse(v.innerHTML),
                    });
                }
              }
              if (this.settings.imageSetName) {
                var C = this.container.querySelector(
                  '.variant-input-wrap[data-handle="' +
                    this.settings.imageSetName +
                    '"]',
                );
                C
                  ? ((this.settings.imageSetIndex = C.dataset.index),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateImageSet.bind(this),
                    ))
                  : (this.settings.imageSetName = null);
              }
            }
          },
          initQtySelector: function () {
            this.container.querySelectorAll(".js-qty__wrapper").forEach((i) => {
              new theme.QtySelector(i, { namespace: ".product" });
            });
          },
          initAjaxProductForm: function () {
            new theme.AjaxProduct(this.cache.form);
          },
          updateColorName: function (i, n) {
            this.container.querySelector(
              this.selectors.colorLabel + `[data-index="${n}"`,
            ).textContent = i;
          },
          updateCartButton: function (i) {
            var n = i.detail.variant,
              r = this.container.querySelector(this.selectors.addToCart),
              a = this.container.querySelector(this.selectors.addToCartText);
            if (r)
              if (n)
                if (n.available) {
                  (r.classList.remove(e.disabled), (r.disabled = !1));
                  var l = a.dataset.defaultText;
                  a.textContent = l;
                } else
                  (r.classList.add(e.disabled),
                    (r.disabled = !0),
                    (a.textContent = theme.strings.soldOut));
              else
                (r.classList.add(e.disabled),
                  (r.disabled = !0),
                  (a.textContent = theme.strings.unavailable));
          },
          updatePrice: function (i) {
            var n = i.detail.variant;
            if (n)
              if (
                ((this.cache.price.innerHTML = theme.Currency.formatMoney(
                  n.price,
                  theme.settings.moneyFormat,
                )),
                n.compare_at_price > n.price)
              ) {
                ((this.cache.comparePrice.innerHTML =
                  theme.Currency.formatMoney(
                    n.compare_at_price,
                    theme.settings.moneyFormat,
                  )),
                  this.cache.priceWrapper.classList.remove(e.hidden),
                  this.cache.price.classList.add(e.onSale),
                  this.cache.comparePriceA11y.setAttribute(
                    "aria-hidden",
                    "false",
                  ),
                  this.cache.priceA11y.setAttribute("aria-hidden", "false"));
                var r = n.compare_at_price - n.price;
                (theme.settings.saveType == "percent"
                  ? (r = Math.round((r * 100) / n.compare_at_price) + "%")
                  : (r = theme.Currency.formatMoney(
                      r,
                      theme.settings.moneyFormat,
                    )),
                  this.cache.savePrice.classList.remove(e.hidden),
                  (this.cache.savePrice.innerHTML =
                    theme.strings.savePrice.replace("[saved_amount]", r)));
              } else
                (this.cache.priceWrapper &&
                  this.cache.priceWrapper.classList.add(e.hidden),
                  this.cache.savePrice.classList.add(e.hidden),
                  this.cache.price.classList.remove(e.onSale),
                  this.cache.comparePriceA11y &&
                    this.cache.comparePriceA11y.setAttribute(
                      "aria-hidden",
                      "true",
                    ),
                  this.cache.priceA11y.setAttribute("aria-hidden", "true"));
          },
          updateUnitPrice: function (i) {
            var n = i.detail.variant;
            n && n.unit_price
              ? ((this.container.querySelector(
                  this.selectors.unitPrice,
                ).innerHTML = theme.Currency.formatMoney(
                  n.unit_price,
                  theme.settings.moneyFormat,
                )),
                (this.container.querySelector(
                  this.selectors.unitPriceBaseUnit,
                ).innerHTML = theme.Currency.getBaseUnit(n)),
                this.container
                  .querySelector(this.selectors.unitWrapper)
                  .classList.remove(e.hidden))
              : this.container
                  .querySelector(this.selectors.unitWrapper)
                  .classList.add(e.hidden);
          },
          imageSetArguments: function (n) {
            var n = n || (this.variants ? this.variants.currentVariant : null);
            if (n) {
              var r = (this.settings.currentImageSet = this.getImageSetName(
                  n[this.settings.imageSetIndex],
                )),
                a = this.settings.imageSetName + "_" + r;
              return (
                (this.settings.currentSlideIndex = 0),
                {
                  cellSelector: '[data-group="' + a + '"]',
                  imageSet: a,
                  initialIndex: this.settings.currentSlideIndex,
                }
              );
            }
          },
          updateImageSet: function (i) {
            var n = i
              ? i.detail.variant
              : this.variants
                ? this.variants.currentVariant
                : null;
            if (n) {
              var r = this.getImageSetName(n[this.settings.imageSetIndex]);
              this.settings.currentImageSet !== r && this.initProductSlider(n);
            }
          },
          updateImageSetThumbs: function (i) {
            this.cache.thumbSlider
              .querySelectorAll(".product__thumb-item")
              .forEach((n) => {
                n.classList.toggle(e.hidden, n.dataset.group !== i);
              });
          },
          getImageSetName: function (i) {
            return i
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/-$/, "")
              .replace(/^-/, "");
          },
          updateSku: function (i) {
            var n = i.detail.variant,
              r = "";
            n &&
              (n.sku && (r = n.sku),
              (this.container.querySelector(this.selectors.sku).textContent =
                r));
          },
          updateInventory: function (i) {
            var n = i.detail.variant;
            if (!n) {
              (this.toggleInventoryQuantity("hidden", !1),
                this.toggleIncomingInventory(!1));
              return;
            }
            if (!n.inventory_management) {
              (this.toggleInventoryQuantity("visible", !1),
                this.toggleIncomingInventory(!1));
              return;
            }
            if (
              n.inventory_management === "shopify" &&
              window.inventories &&
              window.inventories[this.productId]
            ) {
              const r = window.inventories[this.productId][n.id],
                {
                  quantity: a,
                  policy: l,
                  incoming: c,
                  next_incoming_date: v,
                } = r || {};
              (this.toggleInventoryQuantity(void 0, a),
                (c && !n.available) || (a <= 0 && l === "continue")
                  ? this.toggleIncomingInventory(!0, v, l)
                  : this.toggleIncomingInventory(!1));
            }
          },
          updateAvailability: function (i) {
            var n = i.detail.variant;
            n && this.storeAvailability.updateContent(n.id);
          },
          toggleInventoryQuantity: function (i = void 0, n) {
            const r = this.container.querySelector(this.selectors.inventory),
              a = r.closest(".sales-point");
            if (i && i === "hidden") {
              a && a.classList.add(e.hidden);
              return;
            }
            let l = !1;
            (parseInt(n) <= parseInt(this.settings.inventoryThreshold) &&
              parseInt(n) > 0 &&
              (l = !0),
              parseInt(n) > 0 || (i && i === "visible")
                ? (l
                    ? (r.parentNode.classList.add(e.lowInventory),
                      n > 1
                        ? (r.textContent =
                            theme.strings.otherStockLabel.replace("[count]", n))
                        : (r.textContent = theme.strings.oneStockLabel.replace(
                            "[count]",
                            n,
                          )))
                    : (r.parentNode.classList.remove(e.lowInventory),
                      (r.textContent = theme.strings.inStockLabel)),
                  a && a.classList.remove(e.hidden))
                : a && a.classList.add(e.hidden));
          },
          toggleIncomingInventory: function (i, n, r) {
            const a = this.container.querySelector(
                this.selectors.incomingInventory,
              ),
              l = a.querySelector(".icon-and-text");
            if (!a) return;
            const c = a.dataset.enabled === "true",
              v = a.querySelector(".js-incoming-text");
            if (!c) {
              a.classList.add(e.hidden);
              return;
            }
            i
              ? (n
                  ? ((v.textContent = theme.strings.willBeInStockAfter.replace(
                      "[date]",
                      n,
                    )),
                    a.classList.remove(e.hidden))
                  : ((v.textContent = theme.strings.waitingForStock),
                    a.classList.remove(e.hidden)),
                l &&
                  (r !== "continue"
                    ? l.classList.add(e.lowInventory)
                    : l.classList.remove(e.lowInventory)))
              : a.classList.add(e.hidden);
          },
          videoSetup: function () {
            var i = this.cache.mainSlider.querySelectorAll(t.productVideo);
            if (!i.length) return !1;
            i.forEach((n) => {
              var r = n.dataset.videoType;
              r === "youtube"
                ? this.initYoutubeVideo(n)
                : r === "vimeo"
                  ? this.initVimeoVideo(n)
                  : r === "mp4" && this.initMp4Video(n);
            });
          },
          initYoutubeVideo: function (i) {
            o[i.id] = new theme.YouTube(i.id, {
              videoId: i.dataset.videoId,
              videoParent: t.videoParent,
              autoplay: !1,
              style: i.dataset.videoStyle,
              loop: i.dataset.videoLoop,
              events: {
                onReady: this.youtubePlayerReady.bind(this),
                onStateChange: this.youtubePlayerStateChange.bind(this),
              },
            });
          },
          initVimeoVideo: function (i) {
            o[i.id] = new theme.VimeoPlayer(i.id, i.dataset.videoId, {
              videoParent: t.videoParent,
              autoplay: !1,
              style: i.dataset.videoStyle,
              loop: i.dataset.videoLoop,
            });
          },
          youtubePlayerReady: function (i) {
            var n = i.target.getIframe().id;
            if (o[n]) {
              var r = o[n],
                a = r.videoPlayer;
              (r.options.style !== "sound" && a.mute(),
                r.parent.classList.remove("loading"),
                r.parent.classList.add("loaded"),
                r.parent.classList.add("video-interactable"),
                this._isFirstSlide(n) &&
                  r.options.style !== "sound" &&
                  a.playVideo());
            }
          },
          _isFirstSlide: function (i) {
            return this.cache.mainSlider.querySelector(
              t.startingSlide + " #" + i,
            );
          },
          youtubePlayerStateChange: function (i) {
            var n = i.target.getIframe().id,
              r = o[n];
            switch (i.data) {
              case -1:
                r.attemptedToPlay &&
                  r.parent.classList.add("video-interactable");
                break;
              case 0:
                r && r.options.loop === "true" && r.videoPlayer.playVideo();
                break;
              case 3:
                r.attemptedToPlay = !0;
                break;
            }
          },
          initMp4Video: function (i) {
            ((o[i.id] = { id: i.id, type: "mp4" }),
              this._isFirstSlide(i.id) && this.playMp4Video(i.id));
          },
          stopVideos: function () {
            for (var [i, n] of Object.entries(o))
              n.videoPlayer
                ? typeof n.videoPlayer.stopVideo == "function" &&
                  n.videoPlayer.stopVideo()
                : n.type === "mp4" && this.stopMp4Video(n.id);
          },
          _getVideoType: function (i) {
            return i.getAttribute("data-video-type");
          },
          _getVideoDivId: function (i) {
            return i.id;
          },
          playMp4Video: function (i) {
            var n = this.container.querySelector("#" + i),
              r = n.play();
            r !== void 0 &&
              r
                .then(function () {})
                .catch(function (a) {
                  (n.setAttribute("controls", ""),
                    n
                      .closest(t.videoParent)
                      .setAttribute("data-video-style", "unmuted"));
                });
          },
          stopMp4Video: function (i) {
            var n = this.container.querySelector("#" + i);
            n && typeof n.pause == "function" && n.pause();
          },
          initImageZoom: function () {
            var i = this.container.querySelector(this.selectors.imageContainer);
            i &&
              (new theme.Photoswipe(i, this.sectionId),
              i.addEventListener(
                "photoswipe:afterChange",
                function (n) {
                  this.flickity && this.flickity.goToSlide(n.detail.index);
                }.bind(this),
              ));
          },
          getThumbIndex: function (i) {
            return i.dataset.index;
          },
          updateVariantImage: function (i) {
            var n = i.detail.variant;
            theme.Images.getSizedImageUrl(
              n.featured_media.preview_image.src,
              this.settings.imageSize,
            );
            var r = this.container.querySelector(
                '.product__thumb[data-id="' + n.featured_media.id + '"]',
              ),
              a = this.getThumbIndex(r);
            typeof a > "u" || (this.flickity && this.flickity.goToSlide(a));
          },
          initProductSlider: function (i) {
            if (this.cache.mainSlider.querySelectorAll(t.slide).length <= 1) {
              var n = this.cache.mainSlider.querySelector(t.slide);
              n && n.classList.add("is-selected");
              return;
            }
            if (
              (this.flickity &&
                typeof this.flickity.destroy == "function" &&
                this.flickity.destroy(),
              !i)
            ) {
              var r = this.cache.mainSlider.querySelector(t.startingSlide);
              this.settings.currentSlideIndex = this._slideIndex(r);
            }
            var a = {
              dragThreshold: 25,
              adaptiveHeight: !0,
              avoidReflow: !0,
              initialIndex: this.settings.currentSlideIndex,
              childNav: this.cache.thumbSlider,
              childNavScroller: this.cache.thumbScroller,
              childVertical:
                this.cache.thumbSlider.dataset.position === "beside",
              pageDots: !0,
              wrapAround: !0,
              callbacks: {
                onInit: this.onSliderInit.bind(this),
                onChange: this.onSlideChange.bind(this),
              },
            };
            if (this.settings.imageSetName) {
              var l = this.imageSetArguments(i);
              ((a = Object.assign({}, a, l)),
                this.updateImageSetThumbs(a.imageSet));
            }
            this.flickity = new theme.Slideshow(this.cache.mainSlider, a);
          },
          onSliderInit: function (i) {
            this.settings.imageSetName && this.prepMediaOnSlide(i);
          },
          onSlideChange: function (i) {
            if (this.flickity) {
              var n = this.cache.mainSlider.querySelector(
                  '.product-main-slide[data-index="' +
                    this.settings.currentSlideIndex +
                    '"]',
                ),
                r = this.settings.imageSetName
                  ? this.cache.mainSlider.querySelectorAll(
                      ".flickity-slider .product-main-slide",
                    )[i]
                  : this.cache.mainSlider.querySelector(
                      '.product-main-slide[data-index="' + i + '"]',
                    );
              (n.setAttribute("tabindex", "-1"),
                r.setAttribute("tabindex", 0),
                this.stopMediaOnSlide(n),
                this.prepMediaOnSlide(r),
                (this.settings.currentSlideIndex = i));
            }
          },
          stopMediaOnSlide(i) {
            var n = i.querySelector(t.productVideo);
            if (n) {
              var r = this._getVideoType(n),
                a = this._getVideoDivId(n);
              if (r === "youtube") {
                if (o[a].videoPlayer) {
                  o[a].videoPlayer.stopVideo();
                  return;
                }
              } else if (r === "mp4") {
                this.stopMp4Video(a);
                return;
              }
            }
            var l = i.querySelector(this.selectors.media);
            l &&
              l.dispatchEvent(
                new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }),
              );
          },
          prepMediaOnSlide(i) {
            var n = i.querySelector(t.productVideo);
            if (n) {
              this.flickity.reposition();
              var r = this._getVideoType(n),
                a = this._getVideoDivId(n);
              if (r === "youtube") {
                if (o[a].videoPlayer && o[a].options.style !== "sound") {
                  o[a].videoPlayer.playVideo();
                  return;
                }
              } else r === "mp4" && this.playMp4Video(a);
            }
            var l = i.querySelector(this.selectors.media);
            l &&
              (l.dispatchEvent(
                new CustomEvent("mediaVisible", {
                  bubbles: !0,
                  cancelable: !0,
                }),
              ),
              i
                .querySelector(".shopify-model-viewer-ui__button")
                .setAttribute("tabindex", 0),
              i
                .querySelector(".product-single__close-media")
                .setAttribute("tabindex", 0));
          },
          _slideIndex: function (i) {
            return i.getAttribute("data-index");
          },
          openModalProduct: function () {
            var i = !1;
            if (this.settings.modalInit) i = !0;
            else {
              this.blocksHolder = this.container.querySelector(t.blocksHolder);
              var n = this.blocksHolder.dataset.url;
              (fetch(n)
                .then(function (r) {
                  return r.text();
                })
                .then(
                  function (r) {
                    var a = new DOMParser(),
                      l = a.parseFromString(r, "text/html"),
                      c = l.querySelector(t.blocks);
                    c.querySelectorAll("[id]").forEach((C) => {
                      var T = C.getAttribute("id");
                      C.setAttribute("id", T + "-modal");
                      var P = c.querySelector(`[for="${T}"]`);
                      P && P.setAttribute("for", T + "-modal");
                      var q = c.querySelector(`[aria-controls="${T}"]`);
                      q && q.setAttribute("aria-controls", T + "-modal");
                    });
                    var v = c.querySelector(this.selectors.form);
                    if (v) {
                      var I = v.getAttribute("id");
                      c.querySelectorAll("[form]").forEach((C) => {
                        C.setAttribute("form", I);
                      });
                    }
                    ((this.blocksHolder.innerHTML = ""),
                      this.blocksHolder.append(c),
                      this.blocksHolder.classList.add(
                        "product-form-holder--loaded",
                      ),
                      this.cacheElements(),
                      this.formSetup(),
                      this.updateModalProductInventory(),
                      Shopify &&
                        Shopify.PaymentButton &&
                        Shopify.PaymentButton.init(),
                      theme.collapsibles.init(this.container),
                      document.dispatchEvent(
                        new CustomEvent("quickview:loaded", {
                          detail: { productId: this.productId },
                        }),
                      ));
                  }.bind(this),
                ),
                this.productSetup(),
                this.videoSetup(),
                this.settings.imageSetName
                  ? this.variants
                    ? this.initProductSlider()
                    : document.addEventListener(
                        "quickview:loaded",
                        function (r) {
                          r.detail.productId === this.productId &&
                            this.initProductSlider();
                        }.bind(this),
                      )
                  : this.initProductSlider(),
                this.customMediaListners(),
                this.addIdToRecentlyViewed(),
                (this.settings.modalInit = !0));
            }
            (AOS.refreshHard(),
              document.dispatchEvent(
                new CustomEvent("quickview:open", {
                  detail: { initialized: i, productId: this.productId },
                }),
              ));
          },
          updateModalProductInventory: function () {
            ((window.inventories = window.inventories || {}),
              this.container
                .querySelectorAll(".js-product-inventory-data")
                .forEach((i) => {
                  var n = i.dataset.productId;
                  ((window.inventories[n] = {}),
                    i
                      .querySelectorAll(".js-variant-inventory-data")
                      .forEach((r) => {
                        window.inventories[n][r.dataset.id] = {
                          quantity: r.dataset.quantity,
                          policy: r.dataset.policy,
                          incoming: r.dataset.incoming,
                          next_incoming_date: r.dataset.date,
                        };
                      }));
                }));
          },
          closeModalProduct: function () {
            this.stopVideos();
          },
          initModelViewerLibraries: function () {
            var i = this.container.querySelectorAll(this.selectors.media);
            i.length < 1 || theme.ProductMedia.init(i, this.sectionId);
          },
          initShopifyXrLaunch: function () {
            document.addEventListener(
              "shopify_xr_launch",
              function () {
                var i = this.container.querySelector(
                  this.selectors.productMediaWrapper +
                    ":not(." +
                    self.classes.hidden +
                    ")",
                );
                i.dispatchEvent(
                  new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }),
                );
              }.bind(this),
            );
          },
          customMediaListners: function () {
            document
              .querySelectorAll(this.selectors.closeMedia)
              .forEach((n) => {
                n.addEventListener(
                  "click",
                  function () {
                    var r = this.cache.mainSlider.querySelector(t.currentSlide),
                      a = r.querySelector(this.selectors.media);
                    a &&
                      a.dispatchEvent(
                        new CustomEvent("mediaHidden", {
                          bubbles: !0,
                          cancelable: !0,
                        }),
                      );
                  }.bind(this),
                );
              });
            var i = this.container.querySelectorAll("model-viewer");
            i.length &&
              i.forEach((n) => {
                (n.addEventListener(
                  "shopify_model_viewer_ui_toggle_play",
                  function (r) {
                    this.mediaLoaded(r);
                  }.bind(this),
                ),
                  n.addEventListener(
                    "shopify_model_viewer_ui_toggle_pause",
                    function (r) {
                      this.mediaUnloaded(r);
                    }.bind(this),
                  ));
              });
          },
          mediaLoaded: function (i) {
            (this.container
              .querySelectorAll(this.selectors.closeMedia)
              .forEach((n) => {
                n.classList.remove(e.hidden);
              }),
              this.flickity && this.flickity.setDraggable(!1));
          },
          mediaUnloaded: function (i) {
            (this.container
              .querySelectorAll(this.selectors.closeMedia)
              .forEach((n) => {
                n.classList.add(e.hidden);
              }),
              this.flickity && this.flickity.setDraggable(!0));
          },
          onUnload: function () {
            (theme.ProductMedia.removeSectionModels(this.sectionId),
              this.flickity &&
                typeof this.flickity.destroy == "function" &&
                this.flickity.destroy());
          },
        })),
        s
      );
    })()),
    (theme.RecentlyViewed = (function () {
      var o = !1;
      function e(t) {
        t &&
          ((this.container = t),
          (this.sectionId = this.container.getAttribute("data-section-id")),
          (this.namespace = ".recently-viewed" + this.sectionId),
          (this.gridItemWidth = this.container.getAttribute(
            "data-grid-item-class",
          )),
          (this.rowOf = this.container.getAttribute("data-row-of")),
          (this.imageSizes = this.container.getAttribute("data-image-sizes")),
          theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this),
            threshold: 600,
          }));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            if (!o) {
              if (
                ((o = !0),
                Object.keys(theme.recentlyViewed.recent).length === 0 &&
                  theme.recentlyViewed.recent.constructor === Object)
              ) {
                this.container.classList.add("hide");
                return;
              }
              ((this.outputContainer = document.getElementById(
                "RecentlyViewed-" + this.sectionId,
              )),
                (this.handle = this.container.getAttribute(
                  "data-product-handle",
                )));
              var t = [];
              (Object.keys(theme.recentlyViewed.recent).forEach(
                function (s) {
                  s !== "undefined" && t.push(this.getProductInfo(s));
                }.bind(this),
              ),
                Promise.all(t).then(
                  function (s) {
                    (this.setupOutput(s), this.captureProductDetails(s));
                  }.bind(this),
                ));
            }
          },
          getProductInfo: function (t) {
            return new Promise(function (s, i) {
              theme.recentlyViewed.productInfo.hasOwnProperty(t)
                ? s(theme.recentlyViewed.productInfo[t])
                : fetch("/products/" + t + ".js")
                    .then(function (n) {
                      return n.text();
                    })
                    .then(function (n) {
                      s(n);
                    });
            });
          },
          setupOutput: function (t) {
            var s = [],
              i = this.container.getAttribute("data-recent-count");
            if (
              (Object.keys(t).forEach(
                function (r) {
                  if (!t[r]) return;
                  var a = JSON.parse(t[r]);
                  if (a.handle === this.handle || typeof a.handle > "u") return;
                  const l = [180, 360, 540, 720, 900];
                  ((a.url = theme.recentlyViewed.recent[a.handle]
                    ? theme.recentlyViewed.recent[a.handle].url
                    : a.url),
                    (a.image_responsive_url = theme.Images.buildImagePath(
                      a.featured_image,
                    )),
                    (a.image_responsive_urls = theme.Images.buildImagePath(
                      a.featured_image,
                      l,
                    )),
                    (a.image_aspect_ratio =
                      theme.recentlyViewed.recent[a.handle].aspectRatio));
                  var c = a.variants[0];
                  if (c && c.unit_price) {
                    var v = "";
                    (c.unit_price_measurement &&
                      (c.unit_price_measurement.reference_value != 1 &&
                        (v += c.unit_price_measurement.reference_value + " "),
                      (v += c.unit_price_measurement.reference_unit)),
                      (a.unit_price = theme.Currency.formatMoney(c.unit_price)),
                      v != "" && (a.unit_price += "/" + v));
                  }
                  s.unshift(a);
                }.bind(this),
              ),
              s.length === 0)
            ) {
              this.container.classList.add("hide");
              return;
            }
            var n = theme.buildProductGridItem(
              s.slice(0, i),
              this.gridItemWidth,
              this.rowOf,
              this.imageSizes,
            );
            ((this.outputContainer.innerHTML = n),
              AOS && AOS.refreshHard(),
              this.attachAddToCartListeners());
          },
          attachAddToCartListeners: function () {
            this.outputContainer.querySelectorAll("[data-add-to-cart]").forEach(
              function (s) {
                s.addEventListener("click", this.handleAddToCart.bind(this));
              }.bind(this),
            );
          },
          handleAddToCart: function (t) {
            (t.preventDefault(), t.stopPropagation());
            const s = t.currentTarget,
              i = s.getAttribute("data-variant-id");
            if (!i) return;
            s.setAttribute("disabled", "disabled");
            const n = s.innerHTML;
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ id: i, quantity: 1 }),
            })
              .then(function (r) {
                if (!r.ok) throw new Error("HTTP " + r.status);
                return r.json();
              })
              .then(
                function (r) {
                  (typeof theme.CartDrawer < "u" &&
                    document.dispatchEvent(new Event("cart:build")),
                    fetch("/cart.js")
                      .then(function (l) {
                        return l.json();
                      })
                      .then(function (l) {
                        const c = l.item_count || 0;
                        document
                          .querySelectorAll(".cart-link__bubble")
                          .forEach(function (I) {
                            ((I.textContent = String(c)),
                              c > 0 &&
                                I.classList.add("cart-link__bubble--visible"));
                          });
                      }));
                  const a = document.createElement("div");
                  ((a.textContent = r.title
                    ? r.title + " hinzugefügt"
                    : "Produkt zum Warenkorb hinzugefügt"),
                    Object.assign(a.style, {
                      position: "fixed",
                      left: "50%",
                      transform: "translateX(-50%)",
                      bottom: "24px",
                      zIndex: "9999",
                      background: "rgba(0,0,0,0.8)",
                      color: "#fff",
                      padding: "10px 14px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                    }),
                    document.body.appendChild(a),
                    setTimeout(function () {
                      ((a.style.transition = "opacity 180ms ease"),
                        (a.style.opacity = "0"),
                        setTimeout(function () {
                          a.remove();
                        }, 220));
                    }, 1600),
                    s.removeAttribute("disabled"),
                    (s.innerHTML = n));
                }.bind(this),
              )
              .catch(function () {
                const r = document.createElement("div");
                ((r.textContent =
                  "Fehler beim Hinzufügen. Bitte erneut versuchen."),
                  Object.assign(r.style, {
                    position: "fixed",
                    left: "50%",
                    transform: "translateX(-50%)",
                    bottom: "24px",
                    zIndex: "9999",
                    background: "rgba(200,0,0,0.9)",
                    color: "#fff",
                    padding: "10px 14px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                  }),
                  document.body.appendChild(r),
                  setTimeout(function () {
                    ((r.style.transition = "opacity 180ms ease"),
                      (r.style.opacity = "0"),
                      setTimeout(function () {
                        r.remove();
                      }, 220));
                  }, 1600),
                  s.removeAttribute("disabled"),
                  (s.innerHTML = n));
              });
          },
          captureProductDetails: function (t) {
            for (var s = 0; s < t.length; s++) {
              var i = t[s];
              theme.recentlyViewed.productInfo[i.handle] = i;
            }
            theme.config.hasSessionStorage &&
              sessionStorage.setItem(
                "recent-products",
                JSON.stringify(theme.recentlyViewed.productInfo),
              );
          },
          onUnload: function () {
            o = !1;
          },
        })),
        e
      );
    })()),
    (theme.Testimonials = (function () {
      var o = {
        adaptiveHeight: !0,
        avoidReflow: !0,
        pageDots: !0,
        prevNextButtons: !1,
      };
      function e(t) {
        ((this.container = t), this.timeout);
        var s = t.getAttribute("data-section-id");
        ((this.slideshow = t.querySelector("#Testimonials-" + s)),
          (this.namespace = ".testimonial-" + s),
          this.slideshow &&
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 600,
            }));
      }
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function () {
            (this.slideshow.dataset.count <= 3 && (o.wrapAround = !1),
              (this.flickity = new theme.Slideshow(this.slideshow, o)),
              this.slideshow.dataset.count > 2 &&
                (this.timeout = setTimeout(
                  function () {
                    this.flickity.goToSlide(1);
                  }.bind(this),
                  1e3,
                )));
          },
          onUnload: function () {
            this.flickity &&
              typeof this.flickity.destroy == "function" &&
              this.flickity.destroy();
          },
          onDeselect: function () {
            this.flickity &&
              typeof this.flickity.play == "function" &&
              this.flickity.play();
          },
          onBlockSelect: function (t) {
            var s = this.slideshow.querySelector(
                ".testimonials-slide--" + t.detail.blockId,
              ),
              i = parseInt(s.dataset.index);
            (clearTimeout(this.timeout),
              this.flickity &&
                typeof this.flickity.pause == "function" &&
                (this.flickity.goToSlide(i), this.flickity.pause()));
          },
          onBlockDeselect: function () {
            this.flickity &&
              typeof this.flickity.play == "function" &&
              this.flickity.play();
          },
        })),
        e
      );
    })()),
    (theme.isStorageSupported = function (o) {
      if (window.self !== window.top) return !1;
      var e = "test",
        t;
      (o === "session" && (t = window.sessionStorage),
        o === "local" && (t = window.localStorage));
      try {
        return (t.setItem(e, "1"), t.removeItem(e), !0);
      } catch {
        return !1;
      }
    }),
    (theme.reinitProductGridItem = function (o) {
      (AOS && AOS.refreshHard(),
        document.documentElement.classList.contains("modal-open") ||
          theme.initQuickShop(),
        theme.collapsibles.init());
    }),
    (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
    (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
    AOS.init({
      easing: "ease-out-quad",
      once: !0,
      offset: 60,
      disableMutationObserver: !0,
    }),
    theme.config.hasLocalStorage &&
      ((theme.recentlyViewed.localStorage =
        window.localStorage.getItem("theme-recent")),
      theme.recentlyViewed.localStorage &&
        (theme.recentlyViewed.recent = JSON.parse(
          theme.recentlyViewed.localStorage,
        ))),
    (theme.recentlyViewed.productInfo =
      theme.config.hasSessionStorage && sessionStorage["recent-products"]
        ? JSON.parse(sessionStorage["recent-products"])
        : {}),
    (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
    matchMedia(theme.config.mediaQuerySmall).addListener(function (o) {
      o.matches
        ? ((theme.config.bpSmall = !0),
          document.dispatchEvent(new CustomEvent("matchSmall")))
        : ((theme.config.bpSmall = !1),
          document.dispatchEvent(new CustomEvent("unmatchSmall")));
    }));
  function _(o) {
    document.readyState != "loading"
      ? o()
      : document.addEventListener("DOMContentLoaded", o);
  }
  ((theme.initGlobals = function () {
    (theme.collapsibles.init(), theme.videoModal());
  }),
    _(function () {
      if (
        ((theme.sections = new theme.Sections()),
        theme.sections.register("slideshow-section", theme.SlideshowSection),
        theme.sections.register("header", theme.HeaderSection),
        theme.sections.register("product", theme.Product),
        theme.sections.register("blog", theme.Blog),
        theme.sections.register("password-header", theme.PasswordHeader),
        theme.sections.register("photoswipe", theme.Photoswipe),
        theme.sections.register("background-image", theme.BackgroundImage),
        theme.sections.register("testimonials", theme.Testimonials),
        theme.sections.register("video-section", theme.VideoSection),
        theme.sections.register("map", theme.Maps),
        theme.sections.register("footer-section", theme.FooterSection),
        theme.sections.register("store-availability", theme.StoreAvailability),
        theme.sections.register("recently-viewed", theme.RecentlyViewed),
        theme.sections.register("newsletter-popup", theme.NewsletterPopup),
        theme.sections.register("collection-header", theme.CollectionHeader),
        theme.sections.register("collection-grid", theme.Collection),
        theme.initGlobals(),
        theme.initQuickShop(),
        theme.rteInit(),
        document.body.classList.contains("template-cart"))
      ) {
        var o = document.getElementById("CartPageForm");
        o && new theme.CartForm(o);
      }
      (theme.settings.isCustomerTemplate && theme.customerTemplates(),
        document.dispatchEvent(new CustomEvent("page:loaded")));
    }));
})();
document.addEventListener("recommendations:loaded", function () {
  yotpoWidgetsContainer.initWidgets();
});
const pe = window.theme;
(function () {
  var d = {
      autoPlay: 5e3,
      avoidReflow: !0,
      cellAlign: pe.config.rtl ? "right" : "left",
      initAbove: 1279,
    },
    u,
    h;
  function p() {
    ((u = document.getElementById("AnnouncementSlider")),
      u &&
        (S(),
        u.dataset.blockCount !== "1" &&
          (window.innerWidth <= d.initAbove && f(),
          window.addEventListener("resize", g))));
  }
  function g() {
    (S(), window.innerWidth <= d.initAbove && f());
  }
  function f() {
    h = new pe.Slideshow(u, d);
  }
  function m(L) {
    var E = u.querySelector("#AnnouncementSlide-" + L);
    if (E) {
      var b = parseInt(E.dataset.index, 10);
      h && typeof h.pause == "function" && (h.goToSlide(b), h.pause());
    }
  }
  function w() {
    h && typeof h.play == "function" && h.play();
  }
  function S() {
    h && typeof h.destroy == "function" && (h.destroy(), (h = null));
  }
  ((pe.announcementBar = {
    init: p,
    onBlockSelect: m,
    onBlockDeselect: w,
    unload: S,
  }),
    pe.announcementBar.init());
})();
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('[data-section-type="header"] details[data-hover="true"]')
    .forEach((u) => {
      const h = u.querySelector("summary");
      h.replaceWith(h.cloneNode(!0));
      const p = u.querySelector("summary");
      p.addEventListener("click", (g) => {
        const f = p.dataset.link;
        f && f.trim() !== "" ? (window.location.href = f) : g.preventDefault();
      });
    });
});
function Ie(d) {
  return typeof d == "number";
}
function Ee(d) {
  return typeof d == "string";
}
function ge(d) {
  return typeof d == "boolean";
}
function Fe(d) {
  return Object.prototype.toString.call(d) === "[object Object]";
}
function H(d) {
  return Math.abs(d);
}
function ke(d) {
  return Math.sign(d);
}
function le(d, u) {
  return H(d - u);
}
function Ze(d, u) {
  if (d === 0 || u === 0 || H(d) <= H(u)) return 0;
  const h = le(H(d), H(u));
  return H(h / d);
}
function et(d) {
  return Math.round(d * 100) / 100;
}
function de(d) {
  return ue(d).map(Number);
}
function W(d) {
  return d[fe(d)];
}
function fe(d) {
  return Math.max(0, d.length - 1);
}
function _e(d, u) {
  return u === fe(d);
}
function Be(d, u = 0) {
  return Array.from(Array(d), (h, p) => u + p);
}
function ue(d) {
  return Object.keys(d);
}
function Re(d, u) {
  return [d, u].reduce(
    (h, p) => (
      ue(p).forEach((g) => {
        const f = h[g],
          m = p[g],
          w = Fe(f) && Fe(m);
        h[g] = w ? Re(f, m) : m;
      }),
      h
    ),
    {},
  );
}
function Le(d, u) {
  return typeof u.MouseEvent < "u" && d instanceof u.MouseEvent;
}
function tt(d, u) {
  const h = { start: p, center: g, end: f };
  function p() {
    return 0;
  }
  function g(S) {
    return f(S) / 2;
  }
  function f(S) {
    return u - S;
  }
  function m(S, L) {
    return Ee(d) ? h[d](S) : d(u, S, L);
  }
  return { measure: m };
}
function he() {
  let d = [];
  function u(g, f, m, w = { passive: !0 }) {
    let S;
    if ("addEventListener" in g)
      (g.addEventListener(f, m, w), (S = () => g.removeEventListener(f, m, w)));
    else {
      const L = g;
      (L.addListener(m), (S = () => L.removeListener(m)));
    }
    return (d.push(S), p);
  }
  function h() {
    d = d.filter((g) => g());
  }
  const p = { add: u, clear: h };
  return p;
}
function it(d, u, h, p) {
  const g = he(),
    f = 1e3 / 60;
  let m = null,
    w = 0,
    S = 0;
  function L() {
    g.add(d, "visibilitychange", () => {
      d.hidden && o();
    });
  }
  function E() {
    (_(), g.clear());
  }
  function b(t) {
    if (!S) return;
    m || ((m = t), h(), h());
    const s = t - m;
    for (m = t, w += s; w >= f; ) (h(), (w -= f));
    const i = w / f;
    (p(i), S && (S = u.requestAnimationFrame(b)));
  }
  function y() {
    S || (S = u.requestAnimationFrame(b));
  }
  function _() {
    (u.cancelAnimationFrame(S), (m = null), (w = 0), (S = 0));
  }
  function o() {
    ((m = null), (w = 0));
  }
  return { init: L, destroy: E, start: y, stop: _, update: h, render: p };
}
function nt(d, u) {
  const h = u === "rtl",
    p = d === "y",
    g = p ? "y" : "x",
    f = p ? "x" : "y",
    m = !p && h ? -1 : 1,
    w = E(),
    S = b();
  function L(o) {
    const { height: e, width: t } = o;
    return p ? e : t;
  }
  function E() {
    return p ? "top" : h ? "right" : "left";
  }
  function b() {
    return p ? "bottom" : h ? "left" : "right";
  }
  function y(o) {
    return o * m;
  }
  return {
    scroll: g,
    cross: f,
    startEdge: w,
    endEdge: S,
    measureSize: L,
    direction: y,
  };
}
function ne(d = 0, u = 0) {
  const h = H(d - u);
  function p(L) {
    return L < d;
  }
  function g(L) {
    return L > u;
  }
  function f(L) {
    return p(L) || g(L);
  }
  function m(L) {
    return f(L) ? (p(L) ? d : u) : L;
  }
  function w(L) {
    return h ? L - h * Math.ceil((L - u) / h) : L;
  }
  return {
    length: h,
    max: u,
    min: d,
    constrain: m,
    reachedAny: f,
    reachedMax: g,
    reachedMin: p,
    removeOffset: w,
  };
}
function je(d, u, h) {
  const { constrain: p } = ne(0, d),
    g = d + 1;
  let f = m(u);
  function m(y) {
    return h ? H((g + y) % g) : p(y);
  }
  function w() {
    return f;
  }
  function S(y) {
    return ((f = m(y)), b);
  }
  function L(y) {
    return E().set(w() + y);
  }
  function E() {
    return je(d, w(), h);
  }
  const b = { get: w, set: S, add: L, clone: E };
  return b;
}
function st(d, u, h, p, g, f, m, w, S, L, E, b, y, _, o, e, t, s, i) {
  const { cross: n, direction: r } = d,
    a = ["INPUT", "SELECT", "TEXTAREA"],
    l = { passive: !1 },
    c = he(),
    v = he(),
    I = ne(50, 225).constrain(_.measure(20)),
    C = { mouse: 300, touch: 400 },
    T = { mouse: 500, touch: 600 },
    P = o ? 43 : 25;
  let q = !1,
    k = 0,
    A = 0,
    M = !1,
    V = !1,
    N = !1,
    j = !1;
  function Q(x) {
    if (!i) return;
    function O(R) {
      (ge(i) || i(x, R)) && re(R);
    }
    const F = u;
    c.add(F, "dragstart", (R) => R.preventDefault(), l)
      .add(F, "touchmove", () => {}, l)
      .add(F, "touchend", () => {})
      .add(F, "touchstart", O)
      .add(F, "mousedown", O)
      .add(F, "touchcancel", B)
      .add(F, "contextmenu", B)
      .add(F, "click", K, !0);
  }
  function $() {
    (c.clear(), v.clear());
  }
  function G() {
    const x = j ? h : u;
    v.add(x, "touchmove", U, l)
      .add(x, "touchend", B)
      .add(x, "mousemove", U, l)
      .add(x, "mouseup", B);
  }
  function Y(x) {
    const O = x.nodeName || "";
    return a.includes(O);
  }
  function J() {
    return (o ? T : C)[j ? "mouse" : "touch"];
  }
  function oe(x, O) {
    const F = b.add(ke(x) * -1),
      R = E.byDistance(x, !o).distance;
    return o || H(x) < I
      ? R
      : t && O
        ? R * 0.5
        : E.byIndex(F.get(), 0).distance;
  }
  function re(x) {
    const O = Le(x, p);
    ((j = O),
      (N = o && O && !x.buttons && q),
      (q = le(g.get(), m.get()) >= 2),
      !(O && x.button !== 0) &&
        (Y(x.target) ||
          ((M = !0),
          f.pointerDown(x),
          L.useFriction(0).useDuration(0),
          g.set(m),
          G(),
          (k = f.readPoint(x)),
          (A = f.readPoint(x, n)),
          y.emit("pointerDown"))));
  }
  function U(x) {
    if (!Le(x, p) && x.touches.length >= 2) return B(x);
    const F = f.readPoint(x),
      R = f.readPoint(x, n),
      X = le(F, k),
      Z = le(R, A);
    if (!V && !j && (!x.cancelable || ((V = X > Z), !V))) return B(x);
    const te = f.pointerMove(x);
    (X > e && (N = !0),
      L.useFriction(0.3).useDuration(0.75),
      w.start(),
      g.add(r(te)),
      x.preventDefault());
  }
  function B(x) {
    const F = E.byDistance(0, !1).index !== b.get(),
      R = f.pointerUp(x) * J(),
      X = oe(r(R), F),
      Z = Ze(R, X),
      te = P - 10 * Z,
      ee = s + Z / 50;
    ((V = !1),
      (M = !1),
      v.clear(),
      L.useDuration(te).useFriction(ee),
      S.distance(X, !o),
      (j = !1),
      y.emit("pointerUp"));
  }
  function K(x) {
    N && (x.stopPropagation(), x.preventDefault(), (N = !1));
  }
  function z() {
    return M;
  }
  return { init: Q, destroy: $, pointerDown: z };
}
function ot(d, u) {
  let p, g;
  function f(b) {
    return b.timeStamp;
  }
  function m(b, y) {
    const o = `client${(y || d.scroll) === "x" ? "X" : "Y"}`;
    return (Le(b, u) ? b : b.touches[0])[o];
  }
  function w(b) {
    return ((p = b), (g = b), m(b));
  }
  function S(b) {
    const y = m(b) - m(g),
      _ = f(b) - f(p) > 170;
    return ((g = b), _ && (p = b), y);
  }
  function L(b) {
    if (!p || !g) return 0;
    const y = m(g) - m(p),
      _ = f(b) - f(p),
      o = f(b) - f(g) > 170,
      e = y / _;
    return _ && !o && H(e) > 0.1 ? e : 0;
  }
  return { pointerDown: w, pointerMove: S, pointerUp: L, readPoint: m };
}
function rt() {
  function d(h) {
    const { offsetTop: p, offsetLeft: g, offsetWidth: f, offsetHeight: m } = h;
    return {
      top: p,
      right: g + f,
      bottom: p + m,
      left: g,
      width: f,
      height: m,
    };
  }
  return { measure: d };
}
function at(d) {
  function u(p) {
    return d * (p / 100);
  }
  return { measure: u };
}
function ct(d, u, h, p, g, f, m) {
  const w = [d].concat(p);
  let S,
    L,
    E = [],
    b = !1;
  function y(t) {
    return g.measureSize(m.measure(t));
  }
  function _(t) {
    if (!f) return;
    ((L = y(d)), (E = p.map(y)));
    function s(i) {
      for (const n of i) {
        if (b) return;
        const r = n.target === d,
          a = p.indexOf(n.target),
          l = r ? L : E[a],
          c = y(r ? d : p[a]);
        if (H(c - l) >= 0.5) {
          (t.reInit(), u.emit("resize"));
          break;
        }
      }
    }
    ((S = new ResizeObserver((i) => {
      (ge(f) || f(t, i)) && s(i);
    })),
      h.requestAnimationFrame(() => {
        w.forEach((i) => S.observe(i));
      }));
  }
  function o() {
    ((b = !0), S && S.disconnect());
  }
  return { init: _, destroy: o };
}
function lt(d, u, h, p, g, f) {
  let m = 0,
    w = 0,
    S = g,
    L = f,
    E = d.get(),
    b = 0;
  function y() {
    const l = p.get() - d.get(),
      c = !S;
    let v = 0;
    return (
      c
        ? ((m = 0), h.set(p), d.set(p), (v = l))
        : (h.set(d), (m += l / S), (m *= L), (E += m), d.add(m), (v = E - b)),
      (w = ke(v)),
      (b = E),
      a
    );
  }
  function _() {
    const l = p.get() - u.get();
    return H(l) < 0.001;
  }
  function o() {
    return S;
  }
  function e() {
    return w;
  }
  function t() {
    return m;
  }
  function s() {
    return n(g);
  }
  function i() {
    return r(f);
  }
  function n(l) {
    return ((S = l), a);
  }
  function r(l) {
    return ((L = l), a);
  }
  const a = {
    direction: e,
    duration: o,
    velocity: t,
    seek: y,
    settled: _,
    useBaseFriction: i,
    useBaseDuration: s,
    useFriction: r,
    useDuration: n,
  };
  return a;
}
function dt(d, u, h, p, g) {
  const f = g.measure(10),
    m = g.measure(50),
    w = ne(0.1, 0.99);
  let S = !1;
  function L() {
    return !(S || !d.reachedAny(h.get()) || !d.reachedAny(u.get()));
  }
  function E(_) {
    if (!L()) return;
    const o = d.reachedMin(u.get()) ? "min" : "max",
      e = H(d[o] - u.get()),
      t = h.get() - u.get(),
      s = w.constrain(e / m);
    (h.subtract(t * s),
      !_ &&
        H(t) < f &&
        (h.set(d.constrain(h.get())), p.useDuration(25).useBaseFriction()));
  }
  function b(_) {
    S = !_;
  }
  return { shouldConstrain: L, constrain: E, toggleActive: b };
}
function ut(d, u, h, p, g) {
  const f = ne(-u + d, 0),
    m = b(),
    w = E(),
    S = y();
  function L(o, e) {
    return le(o, e) <= 1;
  }
  function E() {
    const o = m[0],
      e = W(m),
      t = m.lastIndexOf(o),
      s = m.indexOf(e) + 1;
    return ne(t, s);
  }
  function b() {
    return h
      .map((o, e) => {
        const { min: t, max: s } = f,
          i = f.constrain(o),
          n = !e,
          r = _e(h, e);
        return n ? s : r || L(t, i) ? t : L(s, i) ? s : i;
      })
      .map((o) => parseFloat(o.toFixed(3)));
  }
  function y() {
    if (u <= d + g) return [f.max];
    if (p === "keepSnaps") return m;
    const { min: o, max: e } = w;
    return m.slice(o, e);
  }
  return { snapsContained: S, scrollContainLimit: w };
}
function ht(d, u, h) {
  const p = u[0],
    g = h ? p - d : W(u);
  return { limit: ne(g, p) };
}
function ft(d, u, h, p) {
  const f = u.min + 0.1,
    m = u.max + 0.1,
    { reachedMin: w, reachedMax: S } = ne(f, m);
  function L(y) {
    return y === 1 ? S(h.get()) : y === -1 ? w(h.get()) : !1;
  }
  function E(y) {
    if (!L(y)) return;
    const _ = d * (y * -1);
    p.forEach((o) => o.add(_));
  }
  return { loop: E };
}
function mt(d) {
  const { max: u, length: h } = d;
  function p(f) {
    const m = f - u;
    return h ? m / -h : 0;
  }
  return { get: p };
}
function pt(d, u, h, p, g) {
  const { startEdge: f, endEdge: m } = d,
    { groupSlides: w } = g,
    S = b().map(u.measure),
    L = y(),
    E = _();
  function b() {
    return w(p)
      .map((e) => W(e)[m] - e[0][f])
      .map(H);
  }
  function y() {
    return p.map((e) => h[f] - e[f]).map((e) => -H(e));
  }
  function _() {
    return w(L)
      .map((e) => e[0])
      .map((e, t) => e + S[t]);
  }
  return { snaps: L, snapsAligned: E };
}
function gt(d, u, h, p, g, f) {
  const { groupSlides: m } = g,
    { min: w, max: S } = p,
    L = E();
  function E() {
    const y = m(f),
      _ = !d || u === "keepSnaps";
    return h.length === 1
      ? [f]
      : _
        ? y
        : y.slice(w, S).map((o, e, t) => {
            const s = !e,
              i = _e(t, e);
            if (s) {
              const n = W(t[0]) + 1;
              return Be(n);
            }
            if (i) {
              const n = fe(f) - W(t)[0] + 1;
              return Be(n, W(t)[0]);
            }
            return o;
          });
  }
  return { slideRegistry: L };
}
function vt(d, u, h, p, g) {
  const { reachedAny: f, removeOffset: m, constrain: w } = p;
  function S(o) {
    return o.concat().sort((e, t) => H(e) - H(t))[0];
  }
  function L(o) {
    const e = d ? m(o) : w(o),
      t = u
        .map((i, n) => ({ diff: E(i - e, 0), index: n }))
        .sort((i, n) => H(i.diff) - H(n.diff)),
      { index: s } = t[0];
    return { index: s, distance: e };
  }
  function E(o, e) {
    const t = [o, o + h, o - h];
    if (!d) return o;
    if (!e) return S(t);
    const s = t.filter((i) => ke(i) === e);
    return s.length ? S(s) : W(t) - h;
  }
  function b(o, e) {
    const t = u[o] - g.get(),
      s = E(t, e);
    return { index: o, distance: s };
  }
  function y(o, e) {
    const t = g.get() + o,
      { index: s, distance: i } = L(t),
      n = !d && f(t);
    if (!e || n) return { index: s, distance: o };
    const r = u[s] - i,
      a = o + E(r, 0);
    return { index: s, distance: a };
  }
  return { byDistance: y, byIndex: b, shortcut: E };
}
function yt(d, u, h, p, g, f, m) {
  function w(b) {
    const y = b.distance,
      _ = b.index !== u.get();
    (f.add(y),
      y && (p.duration() ? d.start() : (d.update(), d.render(1), d.update())),
      _ && (h.set(u.get()), u.set(b.index), m.emit("select")));
  }
  function S(b, y) {
    const _ = g.byDistance(b, y);
    w(_);
  }
  function L(b, y) {
    const _ = u.clone().set(b),
      o = g.byIndex(_.get(), y);
    w(o);
  }
  return { distance: S, index: L };
}
function bt(d, u, h, p, g, f, m, w) {
  const S = { passive: !0, capture: !0 };
  let L = 0;
  function E(_) {
    if (!w) return;
    function o(e) {
      if (new Date().getTime() - L > 10) return;
      (m.emit("slideFocusStart"), (d.scrollLeft = 0));
      const i = h.findIndex((n) => n.includes(e));
      Ie(i) && (g.useDuration(0), p.index(i, 0), m.emit("slideFocus"));
    }
    (f.add(document, "keydown", b, !1),
      u.forEach((e, t) => {
        f.add(
          e,
          "focus",
          (s) => {
            (ge(w) || w(_, s)) && o(t);
          },
          S,
        );
      }));
  }
  function b(_) {
    _.code === "Tab" && (L = new Date().getTime());
  }
  return { init: E };
}
function ce(d) {
  let u = d;
  function h() {
    return u;
  }
  function p(S) {
    u = m(S);
  }
  function g(S) {
    u += m(S);
  }
  function f(S) {
    u -= m(S);
  }
  function m(S) {
    return Ie(S) ? S : S.get();
  }
  return { get: h, set: p, add: g, subtract: f };
}
function Ne(d, u) {
  const h = d.scroll === "x" ? m : w,
    p = u.style;
  let g = null,
    f = !1;
  function m(y) {
    return `translate3d(${y}px,0px,0px)`;
  }
  function w(y) {
    return `translate3d(0px,${y}px,0px)`;
  }
  function S(y) {
    if (f) return;
    const _ = et(d.direction(y));
    _ !== g && ((p.transform = h(_)), (g = _));
  }
  function L(y) {
    f = !y;
  }
  function E() {
    f ||
      ((p.transform = ""),
      u.getAttribute("style") || u.removeAttribute("style"));
  }
  return { clear: E, to: S, toggleActive: L };
}
function St(d, u, h, p, g, f, m, w, S) {
  const E = de(g),
    b = de(g).reverse(),
    y = s().concat(i());
  function _(c, v) {
    return c.reduce((I, C) => I - g[C], v);
  }
  function o(c, v) {
    return c.reduce((I, C) => (_(I, v) > 0 ? I.concat([C]) : I), []);
  }
  function e(c) {
    return f.map((v, I) => ({
      start: v - p[I] + 0.5 + c,
      end: v + u - 0.5 + c,
    }));
  }
  function t(c, v, I) {
    const C = e(v);
    return c.map((T) => {
      const P = I ? 0 : -h,
        q = I ? h : 0,
        k = I ? "end" : "start",
        A = C[T][k];
      return {
        index: T,
        loopPoint: A,
        slideLocation: ce(-1),
        translate: Ne(d, S[T]),
        target: () => (w.get() > A ? P : q),
      };
    });
  }
  function s() {
    const c = m[0],
      v = o(b, c);
    return t(v, h, !1);
  }
  function i() {
    const c = u - m[0] - 1,
      v = o(E, c);
    return t(v, -h, !0);
  }
  function n() {
    return y.every(({ index: c }) => {
      const v = E.filter((I) => I !== c);
      return _(v, u) <= 0.1;
    });
  }
  function r() {
    y.forEach((c) => {
      const { target: v, translate: I, slideLocation: C } = c,
        T = v();
      T !== C.get() && (I.to(T), C.set(T));
    });
  }
  function a() {
    y.forEach((c) => c.translate.clear());
  }
  return { canLoop: n, clear: a, loop: r, loopPoints: y };
}
function wt(d, u, h) {
  let p,
    g = !1;
  function f(S) {
    if (!h) return;
    function L(E) {
      for (const b of E)
        if (b.type === "childList") {
          (S.reInit(), u.emit("slidesChanged"));
          break;
        }
    }
    ((p = new MutationObserver((E) => {
      g || ((ge(h) || h(S, E)) && L(E));
    })),
      p.observe(d, { childList: !0 }));
  }
  function m() {
    (p && p.disconnect(), (g = !0));
  }
  return { init: f, destroy: m };
}
function Et(d, u, h, p) {
  const g = {};
  let f = null,
    m = null,
    w,
    S = !1;
  function L() {
    ((w = new IntersectionObserver(
      (o) => {
        S ||
          (o.forEach((e) => {
            const t = u.indexOf(e.target);
            g[t] = e;
          }),
          (f = null),
          (m = null),
          h.emit("slidesInView"));
      },
      { root: d.parentElement, threshold: p },
    )),
      u.forEach((o) => w.observe(o)));
  }
  function E() {
    (w && w.disconnect(), (S = !0));
  }
  function b(o) {
    return ue(g).reduce((e, t) => {
      const s = parseInt(t),
        { isIntersecting: i } = g[s];
      return (((o && i) || (!o && !i)) && e.push(s), e);
    }, []);
  }
  function y(o = !0) {
    if (o && f) return f;
    if (!o && m) return m;
    const e = b(o);
    return (o && (f = e), o || (m = e), e);
  }
  return { init: L, destroy: E, get: y };
}
function Lt(d, u, h, p, g, f) {
  const { measureSize: m, startEdge: w, endEdge: S } = d,
    L = h[0] && g,
    E = o(),
    b = e(),
    y = h.map(m),
    _ = t();
  function o() {
    if (!L) return 0;
    const i = h[0];
    return H(u[w] - i[w]);
  }
  function e() {
    if (!L) return 0;
    const i = f.getComputedStyle(W(p));
    return parseFloat(i.getPropertyValue(`margin-${S}`));
  }
  function t() {
    return h
      .map((i, n, r) => {
        const a = !n,
          l = _e(r, n);
        return a ? y[n] + E : l ? y[n] + b : r[n + 1][w] - i[w];
      })
      .map(H);
  }
  return { slideSizes: y, slideSizesWithGaps: _, startGap: E, endGap: b };
}
function It(d, u, h, p, g, f, m, w, S) {
  const { startEdge: L, endEdge: E, direction: b } = d,
    y = Ie(h);
  function _(s, i) {
    return de(s)
      .filter((n) => n % i === 0)
      .map((n) => s.slice(n, n + i));
  }
  function o(s) {
    return s.length
      ? de(s)
          .reduce((i, n, r) => {
            const a = W(i) || 0,
              l = a === 0,
              c = n === fe(s),
              v = g[L] - f[a][L],
              I = g[L] - f[n][E],
              C = !p && l ? b(m) : 0,
              T = !p && c ? b(w) : 0,
              P = H(I - T - (v + C));
            return (r && P > u + S && i.push(n), c && i.push(s.length), i);
          }, [])
          .map((i, n, r) => {
            const a = Math.max(r[n - 1] || 0);
            return s.slice(a, i);
          })
      : [];
  }
  function e(s) {
    return y ? _(s, h) : o(s);
  }
  return { groupSlides: e };
}
function kt(d, u, h, p, g, f, m) {
  const {
      align: w,
      axis: S,
      direction: L,
      startIndex: E,
      loop: b,
      duration: y,
      dragFree: _,
      dragThreshold: o,
      inViewThreshold: e,
      slidesToScroll: t,
      skipSnaps: s,
      containScroll: i,
      watchResize: n,
      watchSlides: r,
      watchDrag: a,
      watchFocus: l,
    } = f,
    c = 2,
    v = rt(),
    I = v.measure(u),
    C = h.map(v.measure),
    T = nt(S, L),
    P = T.measureSize(I),
    q = at(P),
    k = tt(w, P),
    A = !b && !!i,
    M = b || !!i,
    {
      slideSizes: V,
      slideSizesWithGaps: N,
      startGap: j,
      endGap: Q,
    } = Lt(T, I, C, h, M, g),
    $ = It(T, P, t, b, I, C, j, Q, c),
    { snaps: G, snapsAligned: Y } = pt(T, k, I, C, $),
    J = -W(G) + W(N),
    { snapsContained: oe, scrollContainLimit: re } = ut(P, J, Y, i, c),
    U = A ? oe : Y,
    { limit: B } = ht(J, U, b),
    K = je(fe(U), E, b),
    z = K.clone(),
    D = de(h),
    x = ({
      dragHandler: se,
      scrollBody: Se,
      scrollBounds: we,
      options: { loop: me },
    }) => {
      (me || we.constrain(se.pointerDown()), Se.seek());
    },
    O = (
      {
        scrollBody: se,
        translate: Se,
        location: we,
        offsetLocation: me,
        previousLocation: ze,
        scrollLooper: We,
        slideLooper: Qe,
        dragHandler: Xe,
        animation: Ge,
        eventHandler: Me,
        scrollBounds: Ye,
        options: { loop: qe },
      },
      Oe,
    ) => {
      const De = se.settled(),
        Je = !Ye.shouldConstrain(),
        He = qe ? De : De && Je,
        Ve = He && !Xe.pointerDown();
      Ve && Ge.stop();
      const Ke = we.get() * Oe + ze.get() * (1 - Oe);
      (me.set(Ke),
        qe && (We.loop(se.direction()), Qe.loop()),
        Se.to(me.get()),
        Ve && Me.emit("settle"),
        He || Me.emit("scroll"));
    },
    F = it(
      p,
      g,
      () => x(be),
      (se) => O(be, se),
    ),
    R = 0.68,
    X = U[K.get()],
    Z = ce(X),
    te = ce(X),
    ee = ce(X),
    ie = ce(X),
    ae = lt(Z, ee, te, ie, y, R),
    ve = vt(b, U, J, B, ie),
    ye = yt(F, K, z, ae, ve, ie, m),
    Te = mt(B),
    Ae = he(),
    Ue = Et(u, h, m, e),
    { slideRegistry: Pe } = gt(A, i, U, re, $, D),
    $e = bt(d, h, Pe, ye, ae, Ae, m, l),
    be = {
      ownerDocument: p,
      ownerWindow: g,
      eventHandler: m,
      containerRect: I,
      slideRects: C,
      animation: F,
      axis: T,
      dragHandler: st(
        T,
        d,
        p,
        g,
        ie,
        ot(T, g),
        Z,
        F,
        ye,
        ae,
        ve,
        K,
        m,
        q,
        _,
        o,
        s,
        R,
        a,
      ),
      eventStore: Ae,
      percentOfView: q,
      index: K,
      indexPrevious: z,
      limit: B,
      location: Z,
      offsetLocation: ee,
      previousLocation: te,
      options: f,
      resizeHandler: ct(u, m, g, h, T, n, v),
      scrollBody: ae,
      scrollBounds: dt(B, ee, ie, ae, q),
      scrollLooper: ft(J, B, ee, [Z, ee, te, ie]),
      scrollProgress: Te,
      scrollSnapList: U.map(Te.get),
      scrollSnaps: U,
      scrollTarget: ve,
      scrollTo: ye,
      slideLooper: St(T, P, J, V, N, G, U, ee, h),
      slideFocus: $e,
      slidesHandler: wt(u, m, r),
      slidesInView: Ue,
      slideIndexes: D,
      slideRegistry: Pe,
      slidesToScroll: $,
      target: ie,
      translate: Ne(T, u),
    };
  return be;
}
function _t() {
  let d = {},
    u;
  function h(L) {
    u = L;
  }
  function p(L) {
    return d[L] || [];
  }
  function g(L) {
    return (p(L).forEach((E) => E(u, L)), S);
  }
  function f(L, E) {
    return ((d[L] = p(L).concat([E])), S);
  }
  function m(L, E) {
    return ((d[L] = p(L).filter((b) => b !== E)), S);
  }
  function w() {
    d = {};
  }
  const S = { init: h, emit: g, off: m, on: f, clear: w };
  return S;
}
const Ct = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0,
};
function xt(d) {
  function u(f, m) {
    return Re(f, m || {});
  }
  function h(f) {
    const m = f.breakpoints || {},
      w = ue(m)
        .filter((S) => d.matchMedia(S).matches)
        .map((S) => m[S])
        .reduce((S, L) => u(S, L), {});
    return u(f, w);
  }
  function p(f) {
    return f
      .map((m) => ue(m.breakpoints || {}))
      .reduce((m, w) => m.concat(w), [])
      .map(d.matchMedia);
  }
  return { mergeOptions: u, optionsAtMedia: h, optionsMediaQueries: p };
}
function Tt(d) {
  let u = [];
  function h(f, m) {
    return (
      (u = m.filter(({ options: w }) => d.optionsAtMedia(w).active !== !1)),
      u.forEach((w) => w.init(f, d)),
      m.reduce((w, S) => Object.assign(w, { [S.name]: S }), {})
    );
  }
  function p() {
    u = u.filter((f) => f.destroy());
  }
  return { init: h, destroy: p };
}
function Ce(d, u, h) {
  const p = d.ownerDocument,
    g = p.defaultView,
    f = xt(g),
    m = Tt(f),
    w = he(),
    S = _t(),
    { mergeOptions: L, optionsAtMedia: E, optionsMediaQueries: b } = f,
    { on: y, off: _, emit: o } = S,
    e = T;
  let t = !1,
    s,
    i = L(Ct, Ce.globalOptions),
    n = L(i),
    r = [],
    a,
    l,
    c;
  function v() {
    const { container: D, slides: x } = n;
    l = (Ee(D) ? d.querySelector(D) : D) || d.children[0];
    const F = Ee(x) ? l.querySelectorAll(x) : x;
    c = [].slice.call(F || l.children);
  }
  function I(D) {
    const x = kt(d, l, c, p, g, D, S);
    if (D.loop && !x.slideLooper.canLoop()) {
      const O = Object.assign({}, D, { loop: !1 });
      return I(O);
    }
    return x;
  }
  function C(D, x) {
    t ||
      ((i = L(i, D)),
      (n = E(i)),
      (r = x || r),
      v(),
      (s = I(n)),
      b([i, ...r.map(({ options: O }) => O)]).forEach((O) =>
        w.add(O, "change", T),
      ),
      n.active &&
        (s.translate.to(s.location.get()),
        s.animation.init(),
        s.slidesInView.init(),
        s.slideFocus.init(z),
        s.eventHandler.init(z),
        s.resizeHandler.init(z),
        s.slidesHandler.init(z),
        s.options.loop && s.slideLooper.loop(),
        l.offsetParent && c.length && s.dragHandler.init(z),
        (a = m.init(z, r))));
  }
  function T(D, x) {
    const O = $();
    (P(), C(L({ startIndex: O }, D), x), S.emit("reInit"));
  }
  function P() {
    (s.dragHandler.destroy(),
      s.eventStore.clear(),
      s.translate.clear(),
      s.slideLooper.clear(),
      s.resizeHandler.destroy(),
      s.slidesHandler.destroy(),
      s.slidesInView.destroy(),
      s.animation.destroy(),
      m.destroy(),
      w.clear());
  }
  function q() {
    t || ((t = !0), w.clear(), P(), S.emit("destroy"), S.clear());
  }
  function k(D, x, O) {
    !n.active ||
      t ||
      (s.scrollBody.useBaseFriction().useDuration(x === !0 ? 0 : n.duration),
      s.scrollTo.index(D, O || 0));
  }
  function A(D) {
    const x = s.index.add(1).get();
    k(x, D, -1);
  }
  function M(D) {
    const x = s.index.add(-1).get();
    k(x, D, 1);
  }
  function V() {
    return s.index.add(1).get() !== $();
  }
  function N() {
    return s.index.add(-1).get() !== $();
  }
  function j() {
    return s.scrollSnapList;
  }
  function Q() {
    return s.scrollProgress.get(s.offsetLocation.get());
  }
  function $() {
    return s.index.get();
  }
  function G() {
    return s.indexPrevious.get();
  }
  function Y() {
    return s.slidesInView.get();
  }
  function J() {
    return s.slidesInView.get(!1);
  }
  function oe() {
    return a;
  }
  function re() {
    return s;
  }
  function U() {
    return d;
  }
  function B() {
    return l;
  }
  function K() {
    return c;
  }
  const z = {
    canScrollNext: V,
    canScrollPrev: N,
    containerNode: B,
    internalEngine: re,
    destroy: q,
    off: _,
    on: y,
    emit: o,
    plugins: oe,
    previousScrollSnap: G,
    reInit: e,
    rootNode: U,
    scrollNext: A,
    scrollPrev: M,
    scrollProgress: Q,
    scrollSnapList: j,
    scrollTo: k,
    selectedScrollSnap: $,
    slideNodes: K,
    slidesInView: Y,
    slidesNotInView: J,
  };
  return (C(u, h), setTimeout(() => S.emit("init"), 0), z);
}
Ce.globalOptions = void 0;
const At = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null,
};
function Pt(d, u) {
  const h = d.scrollSnapList();
  return typeof u == "number" ? h.map(() => u) : u(h, d);
}
function Mt(d, u) {
  const h = d.rootNode();
  return (u && u(h)) || h;
}
function xe(d = {}) {
  let u,
    h,
    p,
    g,
    f = null,
    m = 0,
    w = !1,
    S = !1,
    L = !1,
    E = !1;
  function b(k, A) {
    h = k;
    const { mergeOptions: M, optionsAtMedia: V } = A,
      N = M(At, xe.globalOptions),
      j = M(N, d);
    if (((u = V(j)), h.scrollSnapList().length <= 1)) return;
    ((E = u.jump), (p = !1), (g = Pt(h, u.delay)));
    const { eventStore: Q, ownerDocument: $ } = h.internalEngine(),
      G = !!h.internalEngine().options.watchDrag,
      Y = Mt(h, u.rootNode);
    (Q.add($, "visibilitychange", s),
      G && h.on("pointerDown", n),
      G && !u.stopOnInteraction && h.on("pointerUp", r),
      u.stopOnMouseEnter && Q.add(Y, "mouseenter", a),
      u.stopOnMouseEnter && !u.stopOnInteraction && Q.add(Y, "mouseleave", l),
      u.stopOnFocusIn && h.on("slideFocusStart", t),
      u.stopOnFocusIn &&
        !u.stopOnInteraction &&
        Q.add(h.containerNode(), "focusout", e),
      u.playOnInit && e());
  }
  function y() {
    (h.off("pointerDown", n).off("pointerUp", r).off("slideFocusStart", t),
      t(),
      (p = !0),
      (w = !1));
  }
  function _() {
    const { ownerWindow: k } = h.internalEngine();
    (k.clearTimeout(m),
      (m = k.setTimeout(T, g[h.selectedScrollSnap()])),
      (f = new Date().getTime()),
      h.emit("autoplay:timerset"));
  }
  function o() {
    const { ownerWindow: k } = h.internalEngine();
    (k.clearTimeout(m), (m = 0), (f = null), h.emit("autoplay:timerstopped"));
  }
  function e() {
    if (!p) {
      if (i()) {
        L = !0;
        return;
      }
      (w || h.emit("autoplay:play"), _(), (w = !0));
    }
  }
  function t() {
    p || (w && h.emit("autoplay:stop"), o(), (w = !1));
  }
  function s() {
    if (i()) return ((L = w), t());
    L && e();
  }
  function i() {
    const { ownerDocument: k } = h.internalEngine();
    return k.visibilityState === "hidden";
  }
  function n() {
    S || t();
  }
  function r() {
    S || e();
  }
  function a() {
    ((S = !0), t());
  }
  function l() {
    ((S = !1), e());
  }
  function c(k) {
    (typeof k < "u" && (E = k), e());
  }
  function v() {
    w && t();
  }
  function I() {
    w && e();
  }
  function C() {
    return w;
  }
  function T() {
    const { index: k } = h.internalEngine(),
      A = k.clone().add(1).get(),
      M = h.scrollSnapList().length - 1,
      V = u.stopOnLastSnap && A === M;
    if (
      (h.canScrollNext() ? h.scrollNext(E) : h.scrollTo(0, E),
      h.emit("autoplay:select"),
      V)
    )
      return t();
    e();
  }
  function P() {
    if (!f) return null;
    const k = g[h.selectedScrollSnap()],
      A = new Date().getTime() - f;
    return k - A;
  }
  return {
    name: "autoplay",
    options: d,
    init: b,
    destroy: y,
    play: c,
    stop: v,
    reset: I,
    isPlaying: C,
    timeUntilNext: P,
  };
}
xe.globalOptions = void 0;
const qt = (d, u, h) => {
    const p = () => {
      (d.canScrollPrev()
        ? u.removeAttribute("disabled")
        : u.setAttribute("disabled", "disabled"),
        d.canScrollNext()
          ? h.removeAttribute("disabled")
          : h.setAttribute("disabled", "disabled"));
    };
    return (
      d.on("select", p).on("init", p).on("reInit", p),
      () => {
        (u.removeAttribute("disabled"), h.removeAttribute("disabled"));
      }
    );
  },
  Ot = (d, u, h) => {
    const p = () => {
        d.scrollPrev();
      },
      g = () => {
        d.scrollNext();
      };
    (u.addEventListener("click", p, !1), h.addEventListener("click", g, !1));
    const f = qt(d, u, h);
    return () => {
      (f(),
        u.removeEventListener("click", p, !1),
        h.removeEventListener("click", g, !1));
    };
  },
  Dt = (d, u) => {
    let h = [];
    const p = () => {
        u.innerHTML = d
          .scrollSnapList()
          .map(() => '<button class="embla__dot" type="button"></button>')
          .join("");
        const f = (m) => {
          d.scrollTo(m);
        };
        ((h = Array.from(u.querySelectorAll(".embla__dot"))),
          h.forEach((m, w) => {
            m.addEventListener("click", () => f(w), !1);
          }));
      },
      g = () => {
        const f = d.previousScrollSnap(),
          m = d.selectedScrollSnap();
        (h[f].classList.remove("embla__dot--selected"),
          h[m].classList.add("embla__dot--selected"));
      };
    return (
      d
        .on("init", p)
        .on("reInit", p)
        .on("init", g)
        .on("reInit", g)
        .on("select", g),
      () => {
        u.innerHTML = "";
      }
    );
  },
  Ht = (d, u) => {
    const h = u.querySelector(".embla__icon--play"),
      p = u.querySelector(".embla__icon--pause"),
      g = (m) => {
        const w = m?.plugins()?.autoplay;
        if (!w) return;
        w.isPlaying()
          ? ((h.style.display = "none"),
            (p.style.display = "inline-block"),
            u.setAttribute("aria-label", "Carousel pausieren"),
            u.setAttribute("aria-pressed", "true"))
          : ((h.style.display = "inline-block"),
            (p.style.display = "none"),
            u.setAttribute("aria-label", "Carousel starten"),
            u.setAttribute("aria-pressed", "false"));
      },
      f = () => {
        const m = d?.plugins()?.autoplay;
        if (!m) return;
        (m.isPlaying() ? m.stop : m.play)();
      };
    return (
      u.addEventListener("click", f),
      d.on("autoplay:play", g).on("autoplay:stop", g).on("reInit", g),
      () => {
        (u.removeEventListener("click", f),
          d.off("autoplay:play", g).off("autoplay:stop", g).off("reInit", g));
      }
    );
  },
  Vt = (d, ...u) => {
    const h = () => {
      const p = d?.plugins()?.autoplay;
      if (!p) return;
      (p.options.stopOnInteraction === !1 ? p.reset : p.stop)();
    };
    return (
      u.forEach((p) => p.addEventListener("click", h, !0)),
      () => {
        u.forEach((p) => p.removeEventListener("click", h, !0));
      }
    );
  };
document.querySelectorAll(".embla").forEach((d) => {
  const u = d.querySelector(".embla__viewport"),
    h = d.querySelector(".embla__button--prev"),
    p = d.querySelector(".embla__button--next"),
    g = d.querySelector(".embla__dots"),
    f = d.querySelector(".embla__play"),
    m = d.dataset.autoplay === "true",
    w = d.dataset.loop === "true",
    S = parseInt(d.dataset.autoplaySpeed || "5", 10) * 1e3;
  let L = {};
  try {
    L = JSON.parse(d.dataset.breakpoints || "{}");
  } catch (i) {
    console.error("Error parsing breakpoints:", i);
  }
  const E = {
      loop: w,
      align: "start",
      slidesToScroll: 1,
      containScroll: "trimSnaps",
      breakpoints: L,
    },
    b = [];
  m && b.push(xe({ delay: S }));
  const y = Ce(u, E, b),
    _ = Ot(y, h, p),
    o = Dt(y, g),
    e = Ht(y, f),
    t = Vt(y, h, p);
  let s;
  (window.addEventListener("resize", () => {
    (clearTimeout(s),
      (s = setTimeout(() => {
        y.reInit();
      }, 250)));
  }),
    y.on("destroy", _),
    y.on("destroy", o),
    y.on("destroy", e),
    y.on("destroy", t));
});
(function () {
  const d = 'form[action*="/cart/add"], form.shopify-product-form',
    u = '[data-add-to-cart], button[name="add"]';
  function h(E) {
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", E)
      : E();
  }
  async function p() {
    try {
      const E = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (!E.ok) return;
      const b = await E.json(),
        y = b && typeof b.item_count == "number" ? b.item_count : 0;
      document.querySelectorAll(".cart-link__bubble").forEach((e) => {
        ((e.textContent = String(y)),
          y > 0
            ? e.classList.add("cart-link__bubble--visible")
            : e.classList.remove("cart-link__bubble--visible"));
      });
      const o = document.querySelector("a.js-drawer-open-cart");
      if (o) {
        const e = `Warenkorb, ${y} Artikel`;
        o.setAttribute("aria-label", e);
      }
    } catch {}
  }
  function g(E) {
    const b = document.createElement("div");
    ((b.textContent = E),
      Object.assign(b.style, {
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: "24px",
        zIndex: "9999",
        background: "rgba(0,0,0,0.8)",
        color: "#fff",
        padding: "10px 14px",
        borderRadius: "6px",
        fontSize: "14px",
        lineHeight: "18px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        pointerEvents: "none",
      }),
      document.body.appendChild(b),
      setTimeout(() => {
        ((b.style.transition = "opacity 180ms ease"),
          (b.style.opacity = "0"),
          setTimeout(() => b.remove(), 220));
      }, 1600));
  }
  function f(E, b) {
    if (!E) return;
    const y = E.querySelector("[data-add-to-cart-text]");
    if (b) {
      (E.setAttribute("disabled", "disabled"),
        y && !y.dataset.prevHtml && (y.dataset.prevHtml = y.innerHTML));
      const _ = !!(y && y.querySelector("svg"));
      y && !_ && (y.textContent = E.dataset.loadingText || "...");
    } else
      (E.removeAttribute("disabled"),
        y &&
          y.dataset.prevHtml != null &&
          ((y.innerHTML = y.dataset.prevHtml), delete y.dataset.prevHtml));
  }
  async function m(E) {
    const b = E.querySelector(u);
    try {
      f(b, !0);
      const y = new FormData(E),
        _ = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: y,
          credentials: "same-origin",
        });
      if (!_.ok) {
        const e = await _.text();
        throw new Error(e || "HTTP " + _.status);
      }
      let o = "Produkt zum Warenkorb hinzugefügt";
      try {
        const e = await _.json();
        e && e.title && (o = `${e.title} hinzugefügt`);
      } catch {}
      await p();
      try {
        document.dispatchEvent(new Event("cart:build"));
      } catch {}
      g(o);
    } finally {
      f(b, !1);
    }
  }
  function w(E) {
    return !E.hasAttribute("data-no-ajax");
  }
  function S(E) {
    if (!E) return null;
    if (E instanceof HTMLFormElement) return E;
    if (E instanceof HTMLButtonElement || E instanceof HTMLInputElement) {
      if (E.form) return E.form;
      const b = E.getAttribute && E.getAttribute("form");
      if (b) {
        const y = document.getElementById(b);
        if (y && y instanceof HTMLFormElement) return y;
      }
    }
    if (typeof E.closest == "function") {
      const b = E.closest("form");
      if (b) return b;
    }
    if (typeof E.composedPath == "function") {
      const b = E.composedPath();
      for (const y of b) if (y instanceof HTMLFormElement) return y;
    }
    return null;
  }
  function L(E = document) {
    (E.addEventListener(
      "submit",
      function (b) {
        const y = S(b.target);
        !y ||
          !(y instanceof HTMLFormElement) ||
          (y.matches(d) &&
            w(y) &&
            (b.preventDefault(),
            typeof b.stopImmediatePropagation == "function" &&
              b.stopImmediatePropagation(),
            m(y).catch(() => {
              g("Fehler beim Hinzufügen. Bitte erneut versuchen.");
            })));
      },
      !0,
    ),
      E.addEventListener(
        "click",
        function (b) {
          const y = b.target instanceof Element ? b.target : null;
          if (!y) return;
          const _ = y.closest(u);
          if (!_) return;
          const o = _.closest("form"),
            e =
              _.form ||
              (_.getAttribute &&
                document.getElementById(_.getAttribute("form"))),
            t = o || e || S(_);
          !t ||
            !t.matches(d) ||
            (w(t) &&
              (b.preventDefault(),
              b.stopPropagation(),
              typeof b.stopImmediatePropagation == "function" &&
                b.stopImmediatePropagation(),
              m(t).catch(() => {
                g("Fehler beim Hinzufügen. Bitte erneut versuchen.");
              })));
        },
        !0,
      ));
  }
  h(() => {
    L(document);
  });
})();
(function () {
  function d() {
    const u = document.getElementById("discountTopbar");
    if (!u) return;
    const h = { successMessage: u.dataset.successMessage },
      g = new URLSearchParams(window.location.search).get("discount");
    if (
      !g ||
      window.location.pathname.includes("/cart") ||
      window.location.pathname.includes("/checkout")
    )
      return;
    const f = h.successMessage.replace("{code}", `<strong>${g}</strong>`);
    ((u.innerHTML = `
      <div class="discount-topbar success">
        ${f}
        <button class="discount-topbar-close" aria-label="Schließen">×</button>
      </div>
    `),
      document.body.classList.add(
        "has-discount-topbar",
        "has-discount-active",
        "discount-status-success",
      ));
    const m = u.querySelector(".discount-topbar-close");
    m &&
      m.addEventListener("click", function () {
        const w = document.querySelector(".discount-topbar");
        w &&
          ((w.style.animation = "slideDown 0.3s ease-out reverse"),
          setTimeout(() => {
            (w.remove(),
              document.body.classList.remove(
                "has-discount-topbar",
                "has-discount-active",
                "discount-status-success",
              ));
          }, 300));
      });
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", d)
    : d();
})();
